(function ($) {

  //iPhone X
    if ($(window).height() == '2436') {
        $('body').addClass('iPx');
    }


    if ($('.popin-booking').length) {
        $('.popin-booking').marypopin({
            triggers: '.btn.booking',
            closeSelector: '.close'
        });
    }

  //popins
    if ($('.popin-filters').length) {
        $('.popin-filters').marypopin({
            triggers: '.btn.filters',
            closeSelector: '.close',
            speed: 500,
            afterOpen: function () {
                if ($(window).width() < 381 && (parseInt($('.popin-content').outerHeight() + $('.popin-top').outerHeight())) > $(window).height()) {
                    $('.popin').addClass('with-bottom-margin');
                }
            },
            beforeOpen: function () {
                $('.popin-filters .agency .form-element .form-element-dropdown').each(function (cpt) {
                    if (cpt > 0) {
                        $(this).remove();
                    } else {
                        $(this).show();
                    }
                    cpt++;
                });
            }
        });
    }

    if ($('.block-estimate-sticky:not(.local)').length) {
        $.post($("#base_route").val() + "/_ajax/resetInstance/", {
        }, function (data) {

            $.ajax({
                url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                type: 'GET',
                data: getFormParameters('.page-content.page-single')
            }).done(function (data) {
                $('.block-estimate-sticky').html(data);

            }).fail(function (data) {
              //Nothing done
            }).always(function (data) {
            });
        });
    }

    if ($('.popin-quoting').length) {
        $('.popin-quoting').marypopin({
            triggers: '#estimate-button,.btn.devis',
            position: 'middle',
            closeSelector: '.close',
            maskClick: false,
            beforeOpen: function (popin, trigger) {
                if ($(trigger).hasClass('devis')) {
                    $('.block-estimate-sticky').html('');
                    $('input[name="display_header"]').val(true);
                }

                $.ajax({
                    url: $('#base_route').attr('value') + "/booking_form/bookingBlankForm",
                    type: 'GET',
                    data: ''
                }).done(function (data) {
                    $('.popin.popin-quoting').html(data);
                    $('.popin-quoting').css('margin-top', parseInt($(window).height() / 2 - $('.popin-quoting').height() / 2 - 44));
                    //Nothing done
                }).always(function (data) {

                });
            },
            afterOpen: function (popin, trigger) {
                $.post($("#base_route").val() + "/_ajax/resetInstance/", {
                }, function (data) {

                    $.ajax({
                        url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                        type: 'GET',
                        data: getFormParameters(trigger)
                    }).done(function (data) {

                        $('.popin.popin-quoting').html(data);
                        spinWaiting('.popin.popin-quoting', false);
                        $('.popin.popin-quoting').css('display', 'block');

                        var h = 25;
                        $('.popin-quoting .popin-content form .block-section').each(function () {
                            h += $(this).outerHeight();
                        });

                        $('.popin-quoting .popin-content').css('height', h + 'px');
                    }).fail(function (data) {
                      //Nothing done
                    }).always(function (data) {
                        setTimeout(function () {
                            $('.popin.popin-quoting select').parent().find('.form-element-dropdown:last-child').remove();
                            $('.popin.popin-quoting select').dropdown({
                                maxItems: 5
                            }).dropdown({
                                maxItems: 5
                            });

                            setTimeout(function () {
                                $('select').each(function () {
                                    var parentElem = $(this).parent();
                                    var parentClass = parentElem.attr('class');
                                    parentClass = parentClass.replace(/\s+/g,' ').trim().split(' ').join('.');
                                    var item = $(".form-element." + parentClass + " .form-element-dropdown")[ 0 ];
                                    $('body').find(item).show();
                                });
                            }, 100);
                        }, 100);
                    });
                });
            },
            beforeClose: function () {
                $('.popin-quoting').removeClass('with-map').css('max-width', '380px');
                if (matchMedia('(max-width: 1023px)').matches) {
                    $('body').height('auto');
                }
            },
            afterClose: function () {
                $('.popin.popin-quoting').html('');

                if ($('body.page-vehicle').length) {
                    var paramsData = getFormParameters($('a.btn.devis'));
                    paramsData.display_price_header = $('input[name="display_price_header"]').val();
                    paramsData.display_header = false;

                    initBookingForm(paramsData);
                }
            }
        });
    }

    function getFormParameters(trigger)
    {

        var params = {
            id_type:                    $('input[name="id_type"]').val(),
            owt_availability:           $('input[name="owt_availability"]').val(),
            one_way_trip:               $('input[name="one_vay_trip"]').val(),
            display_form_tabs:          $('input[name="display_form_tabs"]').val(),
            display_form_tabs_ids:      $('input[name="display_form_tabs_ids"]').val(),
            module_name:                $('input[name="module_name"]').val(),
            action_name:                $('input[name="action_name"]').val(),
            post_params_redirect:       $('input[name="post_params_redirect"]').val(),
            current_categorie_type_url: $('input[name="current_categorie_type_url"]').val(),
            contenu_categorie_type_url: $('input[name="contenu_categorie_type_url"]').val(),
            contenu_agence_url:         $('input[name="contenu_agence_url"]').val(),
            url_type_vehicules:         $('input[name="url_type_vehicules"]').val(),
            url_categorie_vehicules:    $('input[name="url_categorie_vehicules"]').val(),
            posted_data:                $('.form-context .post-data .data').text(),
            display_layout:             $('input[name="display_layout"]').val(),
            display_mode:               $('input[name="display_mode"]').val(),
            display_header:             $('input[name="display_header"]').val(),
            id_vehicule:                $(trigger).attr('data-id-vehicle')
        };

        if ($('input[name="id_agence_depart"]').val() != '') {
            params.id_agence_depart = $('input[name="id_agence_depart"]').val();
        }

        if ($('input[name="id_agence_retour"]').val() != '') {
            params.id_agence_retour = $('input[name="id_agence_retour"]').val();
        }

        return params;
    }

  //input quantity
    var btnQuantityMinus = $('.btn-quantity-minus');
    var btnQuantityPlus = $('.btn-quantity-plus');

    btnQuantityPlus.on('click', function (e) {
        var inputQuantity = $(this).siblings('input[type=text]');
        var quantity = parseInt(inputQuantity.val(), 10);

        e.preventDefault();
        inputQuantity.val(quantity + 1).attr('value', quantity + 1);

        updateTotalPrice();
    });

    btnQuantityMinus.on('click', function (e) {
        var inputQuantity = $(this).siblings('input[type=text]');
        var quantity = parseInt(inputQuantity.val(), 10);

        e.preventDefault();
        inputQuantity.val(quantity - 1).attr('value', quantity - 1);

        if (inputQuantity.val() < 0) {
            inputQuantity.val(0).attr('value', 0);
        }

        updateTotalPrice();
    });

    var updateTotalPrice = function () {
        var price = 0;
        $('ul.packages-list li.package').each(function () {
            price += parseInt($(this).find('.input-quantity').val()) * parseInt($(this).find('span.package-nb-person').text()) * parseFloat($(this).find('div.real-price').text());
        });

        $.post($('#base_route').val() + "/_ajax/amountTransform/", {number: price}, function (data) {
            var obj = jQuery.parseJSON(data);
            $('span.total-price span').text(html_entity_decode(obj.result) + '');
        }).fail(function () {
        });
    };


  //filters
    $('.filters-list .filter >a').on('click', function (e) {
        e.preventDefault();
        $('.filter-content').fadeOut();
        $('body').addClass('filters');
        $('#mask').addClass('filter');
        $(this).siblings('.filter-content').fadeIn();
    });


    $('.filters-list .filter input[type="submit"]').on('click', function () {
        $('.filter-content').fadeOut();
        $('#mask').removeClass('filter');
        $('body').removeClass('filters');
    });


    $('#mask').on('click', function () {
        if ($(this).hasClass('menu')) {
            $('body').removeClass('fixed');
            $('#mask').removeClass('menu');
            $('.icon-hamburger').removeClass('is-active');
            $('.block-nav-mobile').removeClass('open').css('width', '100%');
        } else {
            $('.filter-content').fadeOut();
            $('#mask').removeClass('filter');
            $('body').removeClass('filters');
        }
    });

    $('.btn.filters').on('click', function (e) {
        e.preventDefault();
        $('body').addClass('fixed');
        $('.block-filters-mobile').addClass('open');

        setTimeout(function () {
            var contentHeight = parseInt(document.getElementById('mobile-popin-content').offsetHeight);
            var screenHeight  = parseInt($(window).height());

            if (contentHeight < screenHeight && $('.popin-filters .popin-content').outerWidth() < $(window).width()) {
                $('.popin .popin-bottom').css('top', '100%');
            }
            $('.popin .popin-bottom').fadeIn();
        }, 300);

    });

    $('.block-filters-mobile .block-filters-mobile-top a.close').on('click', function (e) {
        e.preventDefault();
        $('.block-filters-mobile').removeClass('open');
        $('body').removeClass('fixed');
    });

  //form-elements
    $('#slider, #slider-mobile').slider({
        range: true,
        min: 0,
        max: 3000,
        step: 100,
        values: [0, 3000],
        slide: function (event, ui) {
            $('#slider-min, #slider-min-mobile').html(ui.values[0]);
            $('#slider-max, #slider-max-mobile').html(ui.values[1] + ' km');
        },
        stop: function (event, ui) {
        }
    });


    if ($.isFunction($.fn.flickity) && $('.slider').length) {
        setTimeout(function () {
            $('.slider').each(function () {
                var $that = $(this);
                if ($that.children().length > 1) {
                    $that.children().removeClass('active');
                    $that.flickity({
                        draggable: true,
                        groupCells: true,
                        cellAlign: 'left',
                        wrapAround: false,
                        autoPlay: false,
                        pageDots: true,
                        imagesLoaded: true,
                        arrowShape: {
                            x0: 0,
                            x1: 0, y1: 0,
                            x2: 0, y2: 0,
                            x3: 0
                        },
                        prevNextButtons: false
                    });

                    $that.on('dragMove.flickity', function ( event, pointer, moveVector ) {
                            $that.find("img").addClass("prevent");
                    });
                    $that.on('dragEnd.flickity', function ( event, pointer ) {
                            setTimeout(function () {
                                $that.find("img").removeClass("prevent");
                            }, 10);
                    });
                }
            });

        }, 100);
    }

  // slider comments
    if ($(".comments-list").length > 0) {
        $(".comments-list").flickity({
            draggable: true,
            wrapAround: true,
            autoPlay: false,
            pageDots: true,
            imagesLoaded: true,
            prevNextButtons: false,
            groupCells: 1
        });
    }

  //slider photo
    function sliderPhoto()
    {

        var popin = $('.popin-photo');
        if (!popin.length) {
            return;
        }
        var images = $('img[data-popin-photo-num]');

        images.on("click",function () {
            if (this.classList.contains("prevent")) {
                return;
            }
            var index = this.getAttribute("data-popin-num");
            var pop = document.querySelector('.popin-photo[data-popin-num="' + index + '"]');
            pop.classList.add("open");
            var num = this.getAttribute("data-popin-photo-num");
            var slider = $(pop).find('.slider-photo');
            slider.flickity({
                draggable: true,
                wrapAround: true,
                autoPlay: false,
                pageDots: false,
                prevNextButtons: true,
                initialIndex: num - 1,
                lazyLoad: 1,
                on: {
                    ready: function (index) {
                        $('.page-vehicle.pwa #gallery .popin-photo span.current').text(index);
                    },
                    change: function ( index ) {
                        if ($('.page-vehicle.pwa #gallery').length) {
                            $('.page-vehicle.pwa #gallery .popin-photo span.current').text(index + 1);
                        }
                    },
                    select: function ( index ) {
                        if ($('.page-vehicle.pwa #gallery').length) {
                            $('.page-vehicle.pwa #gallery .popin-photo span.current').text(index + 1);
                        }
                    }
                }
            });
            var close = $(pop).find('.btn-close');
            close.on("click", function () {
                pop.classList.add('close');
                setTimeout(function () {
                    popin.removeClass('close');
                    popin.removeClass('open');
                    slider.flickity('destroy');
                }, 300);
            });
        });
    }

    sliderPhoto();

  //product like
    $('.product .icon-like, .block-infos .icon-like, .menu-item .icon.like').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('liked');
    });

  //product carousel
    if ($('.pwa .product.carousel .img-container').length > 0) {
        $('.product.carousel .img-container').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: 0,
        });
    }
  //menu mobile
    $('.btn.menu-mobile').on('click', function (e) {
        e.preventDefault();
        $('.icon-hamburger').toggleClass('is-active');
        $('#mask').toggleClass('menu');
        $('body').toggleClass('fixed');
        $('.block-nav-mobile').toggleClass('open');
        $('section#burger-menu-background').fadeIn();
        if ($('.block-nav-mobile.open').length === 1) {
            $('.block-subnav').addClass('disabled');
            $('.block-nav-mobile.open').css('width', '75%');
        } else {
            $('.block-subnav').removeClass('disabled');
            $('.block-nav-mobile').css('width', '100%');
        }
    });

    $('section#burger-menu-background').on('click', function (e) {
        e.preventDefault();
        $('.block-nav-mobile').toggleClass('open');
        $('.icon-hamburger').toggleClass('is-active');
        $('body').toggleClass('fixed');
        $('section#burger-menu-background').fadeOut();
        if ($('.block-nav-mobile.open').length === 1) {
            $('.block-subnav').addClass('disabled');
            $('.block-nav-mobile.open').css('width', '75%');
        } else {
            $('.block-subnav').removeClass('disabled');
            $('.block-nav-mobile.open').css('width', '100%');
        }
    });

    $('.block-nav-mobile').removeClass('open');

    if ($('#block-nav-mobile-content').length > 0) {
        var $blockNavMobileContent = document.getElementById('block-nav-mobile-content');
        var mc = new Hammer($blockNavMobileContent);

        mc.on('swipeleft', function (ev) {
            $('.block-nav-mobile').toggleClass('open');
            $('body').toggleClass('fixed');
            $('#mask').toggleClass('menu');
            $('.icon-hamburger').toggleClass('is-active');
        });
    }

  //carousel single
    if ($('.block-breadcrumbs.carousel .img-container, .block-header.carousel .img-container').length) {
        $('.block-breadcrumbs.carousel .img-container, .block-header.carousel .img-container').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: 0
        });
    }

  //main menu
    if ($('body').attr('id') !== 'home') {
        $('.block-nav #menu-item-explore').on('mouseenter', function () {
            $('.block-subnav').addClass('show');
        });

        $('.block-nav').on('mouseleave', function () {
            $('.block-subnav').removeClass('show');
        });
    } else {
        $('.block-subnav').addClass('show');
    }

  //anchors
    $('.main-bar-single-mobile-sticky .block-infos .anchors').each(function (i, e) {
        var Sum = 0;

        $(this).children('li').each(function (i, e) {
            Sum += $(e).outerWidth(true);
        });

        if (Sum > $(this).outerWidth()) {
            $(this).outerWidth(Sum + 30);
        }
    });

    $('.main-bar-single:not(.bottom-banner):not(.desktop) .block-infos .anchors').each(function (i, e) {
        var Sum = 0;

        $(this).children('li').each(function (i, e) {
            Sum += $(e).outerWidth(true);
        });

        if (Sum > $(this).outerWidth()) {
            $(this).outerWidth(Sum + 30);
        }
    });

    var xDown = null;
    var yDown = null;

    if ($('.anchors-container').length) {
        var confObject = {capture: false, passive: true};
        document.addEventListener('touchstart', handleTouchStart, confObject);

        if ($('#mobile-scroll-section-height-adjust-touch').length && $('#mobile-scroll-section-height-adjust-click').length) {
            document.addEventListener('touchmove', handleTouchMove, confObject);
            document.addEventListener('scroll', handleScrollMove, confObject);
            $('.anchors-container ul.anchors li.anchor').click(function () {
                $('#mobile-scroll-section-height-adjust').text($('#mobile-scroll-section-height-adjust-click').text());
            });
        }
    }

    function getTouches(evt)
    {
        return evt.touches ||             // browser API
        evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt)
    {
        var firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    };

    function handleScrollMove(evt)
    {
        heightAdjustUpdate();
    };

    function heightAdjustUpdate()
    {
        $('#mobile-scroll-section-height-adjust').text($('#mobile-scroll-section-height-adjust-touch').text());
    }

    function handleTouchMove(evt)
    {
        heightAdjustUpdate();
    };

    var firstSectionTop = undefined;

    if ($('div.first-block').length && $('#firstSectionTop').text() == '') {
        firstSectionTop = $('div.first-block').offset().top;
        $('#firstSectionTop').text(firstSectionTop);
    } else {
        if ($('#fisrtSectionTop').text() != '') {
            firstSectionTop = parseInt($('#firstSectionTop').text());
        }
    }

    $(document).on('scroll', function () {
        var screenTop = $(document).scrollTop();
        var backButtonSelector = '.btn-back.picto.picto-arrow-left.image-bkg';

        if (screenTop >= ($('.header.img-container img').height() - 70)) {
            $(backButtonSelector).fadeOut();
        } else {
            if (!$(backButtonSelector + ':visible').length) {
                $(backButtonSelector).fadeIn();
            }
        }

        if (screenTop >= (firstSectionTop - 2)) {
            if ($(window).width() >= 1022 && $('.page-vehicle .sticky-desktop').length === 1 && $('div.first-block').length) {
                $('.page-vehicle .main-bar-single.sticky-desktop.active').attr('style', 'top: 0px !important');
            }
            $('.block-estimate-sticky').addClass('below-main-bar');
        } else {
            if ($('.page-vehicle .sticky-desktop.active').length === 1) {
                $('.page-vehicle .main-bar-single.sticky-desktop.active').attr('style', 'top: -140px !important');
            }

            $('.block-estimate-sticky').removeClass('below-main-bar');
        }

        var selector = '.main-bar-single-mobile-sticky.show';
        if ($(window).width() >= 1022 ) {
            selector = '.main-bar-single.sticky-desktop.active';
        }

        if ($('#separator-div').length && $('#separator-div').offset().top - $(window).scrollTop() <= $(selector).height()) {
            $('#below-separator').attr('data-value', '1');
            $('.anchors-container ul.anchors .active').removeClass('active');
            $('.borderbottom').attr('style', '');
        } else {
            if (parseInt($('#below-separator').attr('data-value')) === 1 && !$('.anchors-container ul.anchors li:last-child').hasClass('active')) {
                $('.anchors-container ul.anchors li:last-child').addClass('active');
            }
            $('#below-separator').attr('data-value', '0');
        }

    });

  //menu swipe mobile
    if (matchMedia('(max-width: 1023px)').matches) {
        $('.submenu-container .submenu').each(function (i, e) {
            var Sum = 0;

            $(this).children('li').each(function (i, e) {
                Sum += $(e).outerWidth(true);
            });

            if (Sum > $(this).outerWidth()) {
                $(this).outerWidth(Sum + 30);
            }
        });
    }

    var $activeItemContainer;

    if (matchMedia('(max-width: 1023px)').matches) {
        if ($('body').attr('id') == 'page-single') {
            $activeItemContainer = $('.main-bar-single-mobile-sticky');
        } else if ($('body').attr('id') == 'page-vehicle') {
            $activeItemContainer = $('.main-bar-single-mobile-sticky');
        } else if (!$('body').hasClass('page-vehicle')) {
            $activeItemContainer = $('.main-bar-single:not(.bottom-banner):not(.desktop)');

          //$('.main-bar-single:not(.bottom-banner)').sticky({ topSpacing: 0 });
        }

      //console.log($activeItemContainer);
    } else  {
        if ($('body').attr('id') == 'page-vehicle') {
            $activeItemContainer = $('.sticky-desktop');
        } else if ($('body').attr('id') == 'page-single') {
            $activeItemContainer = $('.main-bar-single:not(.bottom-banner):not(.desktop)');
        }
    }


  //smoothscroll
    var $activeItemContainer;
    if (matchMedia('(max-width: 1021px)').matches) {
        $activeItemContainer = $('.main-bar-single-mobile-sticky');
    }
    if (matchMedia('(min-width: 1022px)').matches) {
        $activeItemContainer = $('.main-bar-single:not(.bottom-banner):not(.desktop)');
    }

    if ($('body.page-promo-list.page-circuit-list.pwa, body.page-vehicle.pwa').length) {
        var $menuItems = $activeItemContainer.find('.anchors-container .anchors .anchor'),
        activeMenuItems = $activeItemContainer.find('.anchors-container .anchors .anchor.active'),
        position = activeMenuItems.position(),
        barWidth = activeMenuItems.innerWidth();
    }

    var $blockEstimateSticky = $('.block-estimate-sticky');

    $(window).resize(function () {
        waitForFinalEvent(testEstimateSticky, 100, "resize blocks height with quartier");
    });
    testEstimateSticky();

    function testEstimateSticky()
    {
        $blockEstimateSticky.toggleClass('no-sticky', window.innerHeight < $blockEstimateSticky.height() + 200);
    }

    var waitForFinalEvent = (function () {
        var timers = {};
        return function (callback, ms, uniqueId) {
            if (!uniqueId) {
                uniqueId = "Don't call this twice without a uniqueId";
            }
            if (timers[uniqueId]) {
                clearTimeout(timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
        };
    })();

    function updateActiveBottomBarById(id)
    {

        if ($menuItems.eq(id).length) {
            $activeItemContainer.find('.anchors-container .borderbottom').css({
                left: $menuItems.eq(id).position().left,
                width: $menuItems.eq(id).innerWidth()
            });
        }
    }

  //smoothscroll
    if ($('body.page-promo-list.page-circuit-list.single.pwa, body.page-vehicle.pwa').length) {
        var anchors = undefined;

        anchors = {
            triggers: $('.block-infos .anchors a'),

            init: function () {
                var self = this;

                self.triggers.click(function (e) {
                    var findAttr = $(this).attr('href');

                    if ($(findAttr).offset() === undefined) {
                        return;
                    }

                    e.preventDefault();
                    self.scrollToAnchor(findAttr);
                });
            },
            scrollToAnchor: function (anchor) {
                var self = this;
                var anchorPos = $(anchor).offset();

                if ($(window).width() < 1022) {
                    $("html, body").animate({ scrollTop: anchorPos.top - parseInt($('#mobile-handlescroll-top').text()) });
                } else {
                    $("html, body").animate({ scrollTop: anchorPos.top - parseInt($('#handlescroll-top').text()) });
                }
            }
        };
        anchors.init();

      //dynamic anchors
      //block booking mobile sticky
        var handleScroll = undefined;
        var topbarHeight = $(".main-bar-single:not(.bottom-banner):not(.desktop)").outerHeight();

        handleScroll = {
            capability: 0,
            topPos: undefined,
            $blockBookingMobile: $('.block-booking-mobile'),
            $mainBarSingleMobileSticky: $('.main-bar-single-mobile-sticky'),
            $anchors: $activeItemContainer.find('.anchors-container .anchors .anchor'),
            nbAnchors: $activeItemContainer.find('.anchors-container .anchors .anchor').length,
            $blockSection: $('.block-section--scroll'),
            currentInternalSectionId: 0,
            oldInternalSectionId: 0,

            init: function () {
                var self = this;

                if (window.pageYOffset != undefined) {
                    self.capability = 1;
                } else if (document.body && document.body.scrollTop != undefined) {
                    self.capability = 2;
                }

                $(window).scroll(function () {
                    self.scrollCheck();
                });
            },
            scrollCheck: function () {
                var self = this;

                switch (self.capability) {
                    case 1 :
                        self.topPos = window.pageYOffset;
                    break;
                    case 2 :
                        self.topPos = document.body.scrollTop;
                    break;
                    default :
                        self.topPos = 0;
                    break;
                }
                handleSticky();
                anchorsUnderline();

                if ($('#module_name').val() == 'circuits' && $('#action_name').val() == 'fiche') {
                    checkProgram();
                }
            }
        };

        handleScroll.init();
        updateActiveSection();
    }


    function handleSticky()
    {
        var topSpacing = $('div.first-block').offset().top;
        if ($(window).width() < 1022 && $('div.first-block-mobile').length) {
            topSpacing = $('div.first-block-mobile').offset().top;
        }
        if (handleScroll.topPos >= topSpacing && $(window).width() < 1022) {
            handleScroll.$mainBarSingleMobileSticky.addClass('show');
        } else {
            handleScroll.$mainBarSingleMobileSticky.removeClass('show');
            if ($(window).width() < 1022) {
                $('.main-bar-single.desktop .anchors-container ul.anchors li.anchor').each(function () {
                    $(this).removeClass('active');
                    $('.borderbottom').attr('style', '');
                });
                $('.main-bar-single.desktop .anchors-container ul.anchors li.anchor:first-child').addClass('active');
            }
        }
    }

    function anchorsUnderline()
    {

        var adjust = parseInt($('#scroll-section-height-adjust').text());
        if ($(window).width() < 1022) {
            adjust = parseInt($('#mobile-scroll-section-height-adjust').text())
        }
        for (var i = 0; i < handleScroll.nbAnchors; i++) {
            if ((handleScroll.topPos + parseInt($('#handlescroll-width').text()) + topbarHeight) > (handleScroll.$blockSection.eq(i).offset().top + adjust)) {
                handleScroll.currentInternalSectionId = i;
            }
        }
        if (handleScroll.oldInternalSectionId != handleScroll.currentInternalSectionId) {
            updateActiveSection();
        }
    }

    function updateActiveSection()
    {

      //alert(handleScroll.currentInternalSectionId);
        handleScroll.$anchors.eq(handleScroll.oldInternalSectionId).removeClass('active');
        handleScroll.oldInternalSectionId = handleScroll.currentInternalSectionId;
        handleScroll.$anchors.eq(handleScroll.currentInternalSectionId).addClass('active');
        handleScroll.$anchors.eq(handleScroll.currentInternalSectionId).find('a').focus();

      //currentInternalSectionId passe tout de suite à deux dès que l'on commence à scroller.
        updateActiveBottomBarById(handleScroll.currentInternalSectionId);

        if (matchMedia('(max-width: 1024px)').matches) {
            var offset       = 0;
            var anchorsWidth = 0;
            var screenWidth  = $(window).width();
            var anchorSelector        = '.main-bar-single-mobile-sticky .anchors-container .anchors .anchor';
            var anchorsContainerWidth = $('.main-bar-single-mobile-sticky .anchors-container .anchors').width();

            for (var i = 0; i < handleScroll.$anchors.length; i++) {
                if (i == 0) {
                    $(anchorSelector).eq(i).attr('data-width', 20);
                    anchorsWidth += 20;
                } else {
                    $(anchorSelector).eq(i).attr('data-width', $(anchorSelector).eq(i).width());
                    anchorsWidth += $(anchorSelector).eq(i).width();
                }
            }

            for (var i = 0; i < handleScroll.currentInternalSectionId; i++) {
                offset += $(anchorSelector).eq(i).width();

                if (offset > (anchorsContainerWidth - screenWidth) && anchorsContainerWidth <= offset) {
                    offset = (anchorsContainerWidth - screenWidth);
                }
            }

            $('.main-bar-single-mobile-sticky .anchors-container .anchors').css(
                'transform',
                'translateX(' + -offset + 'px' + ')'
            );
        }
    }

    $('.page-vehicle .main-bar-single:visible')
    .on('sticky-start', function () {
        $('.page-vehicle .block-estimate-sticky').addClass('below-main-bar');
    })
    .on('sticky-end', function () {
        $('.page-vehicle .block-estimate-sticky').removeClass('below-main-bar');
    });

  //about this program
    $('.block-section a.more, .side-widget.testimonials .testimonial .text-container .more').on('click', function (e) {
        e.preventDefault();
        $(this).parent().addClass('show').slideDown();
        $(this).parent().find('p').attr('style', 'margin-bottom: 4px;line-height: 30px;');
        $(this).remove();
    });

  //program map single

    var mapsInit = false;
    var partialProgramMap;
    var partialProgramMapWrapper = $('#partial-program-map-wrapper');
    var fullProgramMap;
    var fullProgramMapWrapper = $('#full-program-map-wrapper');
    var markersLatLng = [];
    var markersMapsLatLng = [];
    var markers = [];
    var currentMarkerId = -1;
    var oldMarkerId = 0;
    var $daysList = $('.timeline-container .days-list');
    var dayHeight = $daysList.find(".day").outerHeight();
    var $days = $daysList.find('.day');
    var nbDays = $days.length;
    var daysHeight = dayHeight * nbDays;
    var margin = 40;
    var wh = $(window).height();
    var wrapperPaddingBottom = 46;  /* 46 is padding bottom of main wrapper */
    var topHeight = topbarHeight + margin;
    var footerHeight;
    var bottomHeight;
    var boundsFullDirection = null;
    var boundsPartialDirection = null;
    var markerImage = null;
    var mapToBePanned = null;
    var marqueurPartialDeparture = null;
    var marqueurPartialArrival = null;
    var mark = null;

    var movingMode = 'WALKING';

    function initProgram()
    {
        footerHeight = $("footer").outerHeight(); //border
        bottomHeight = footerHeight + $("#offer-list").outerHeight() + $("#comments").outerHeight() + margin + wrapperPaddingBottom;

        if ($('#partial-program-map').length && $('#full-program-map').length) {
            $('#partial-program-map').sticky({
                topSpacing: topHeight,
                bottomSpacing: bottomHeight,
                zIndex: 1
            });
            $('#full-program-map').sticky({
                topSpacing: topHeight,
                bottomSpacing: bottomHeight,
                zIndex: 1
            });
            initProgramMap();
        }
    }

    function createMarkers()
    {

        $('.timeline-container .days-list .day').each(function () {
            if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined) {
                var LatLng = [];
                LatLng.push($(this).attr('data-lat'), $(this).attr('data-lng'));
                markersLatLng.push(LatLng);
            }
        });
        var LatLng = [];
        LatLng.push($('.day-coords.last').attr('data-lat'), $('.day-coords.last').attr('data-lng'));
        markersLatLng.push(LatLng);
    }
    createMarkers();

    function checkProgram()
    {
        handleDays();

        var documentHeight = $(document).height();
        var maxScroll = documentHeight - wh;
        var timelineHeight = (handleScroll.topPos / maxScroll) * daysHeight;

        $('.current-timeline').height((wh * .5) - $daysList[0].getBoundingClientRect().top);
    }

    function handleDays()
    {

        var marginDay = 20;
        for (var i = 0; i < nbDays; i++) {
            if ( ( handleScroll.topPos + (wh * .5)) > ($days.eq(i).offset().top + marginDay) ) {
                currentMarkerId = i;
            }
        }

        if (( handleScroll.topPos + (wh * .5)) < $daysList[0].getBoundingClientRect().top) {
            currentMarkerId = -1;
        }

        if (oldMarkerId != currentMarkerId) {
            if (oldMarkerId == (nbDays - 1) && currentMarkerId == (nbDays - 2)) {
                updateCurrentDay();
            } else {
                updateCurrentDay();
            }
        }

        if ($('.day[data-day-index="' + (currentMarkerId + 1) + '"]').length) {
            var pc = (((wh * .5) - $('.day[data-day-index="' + (currentMarkerId + 1) + '"]')[0].getBoundingClientRect().top - 50) / $('li.day.active').height());
            var nbPoints = $('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords').length + 1;
            var value = Math.round(nbPoints * pc);

            if (value <= nbPoints && value > 0) {
              //console.log('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords[data-coord-position="' + value +'"]');
                var lat = parseFloat($('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords[data-coord-position="' + value + '"]').attr('data-lat'));
                var lng = parseFloat($('.day[data-day-index="' + (currentMarkerId + 1) + '"] span.day-coords[data-coord-position="' + value + '"]').attr('data-lng'));


                if (lat && lat != 0 && lng && lng != 0) {
                    fullProgramMap.setCenter(new google.maps.LatLng(lat, lng));

                    if (mark != null) {
                        mark.setMap(null);
                    }
                    mark = new google.maps.Marker({
                      //label: 'Départ',
                        position: new google.maps.LatLng(
                            lat,
                            lng
                        ),
                    map: fullProgramMap,
                    });
                      //mark.setAnimation(google.maps.Animation.BOUNCE);
                      mark.setIcon(markerImage);
                }
            }
        }


        if ($(window).width() > 1022) {
            if ($('.day.active').length === 1 || $('.day.active').length === $('.day').length) {
                if ($('.day.active').length === 1 && marqueurPartialDeparture != null && !(marqueurPartialDeparture.getMap() instanceof google.maps.Map)) {
                    marqueurPartialDeparture.setMap(partialProgramMap);
                    marqueurPartialArrival.setMap(null);
                } else {
                    if ($('.day.active').length == $('.day').length && marqueurPartialArrival != null && !(marqueurPartialArrival.getMap() instanceof google.maps.Map)) {
                        marqueurPartialDeparture.setMap(null);
                        marqueurPartialArrival.setMap(partialProgramMap);
                    }
                }

                if ($('#full-program-map-wrapper:visible').length) {
                    partialProgramMapWrapper.show();
                    fullProgramMapWrapper.hide();

                    $('#partial-program-map').sticky({
                        topSpacing: topHeight,
                        bottomSpacing: bottomHeight,
                        zIndex: 10
                    });
                }

                var percent = (((wh * .5) - $daysList[0].getBoundingClientRect().top - 25) / $('li.day.active').height()) * 100;
                partialProgramMap.fitBounds(boundsPartialDirection);
            } else {
                if ($('#partial-program-map-wrapper:visible').length) {
                    partialProgramMapWrapper.hide();
                    fullProgramMapWrapper.show();

                    $('#full-program-map').sticky({
                        topSpacing: topHeight,
                        bottomSpacing: bottomHeight,
                        zIndex: 10
                    });
                }
            }
        } else {
            partialProgramMapWrapper.hide();
            fullProgramMapWrapper.hide();
        }
    }

    function updateCurrentDay(forceCenter)
    {

        mapToBePanned = partialProgramMap;
        if ($('#partial-program-map-wrapper:visible').length) {
            mapToBePanned = partialProgramMap;
        } else if ($('#full-program-map-wrapper:visible').length) {
            mapToBePanned = fullProgramMap;
        }

        if (!mapsInit) {
            return;
        }

        $days.eq(oldMarkerId).removeClass('active');
        var cond = (oldMarkerId < currentMarkerId);

        oldMarkerId = currentMarkerId;

        $days.eq(currentMarkerId).addClass('active');

        for (var i = 0; i < currentMarkerId; i++) {
            $days.eq(i).addClass('active');
        }

        for (var i = 0; i < nbDays; i++) {
            if (markers[i]) {
                markers[i].setIcon('../../images/pwa/common/pin-gmap-out.png');
            }
        }

        var index = currentMarkerId - 1 ;

        if (currentMarkerId > 0 && markersLatLng[index]  != undefined && cond) {
          // programMap.panTo( markersMapsLatLng[currentMarkerId] ); /* gmap pan */
            panTo(markersLatLng[index][0], markersLatLng[index][1]);
          //markers[index].setIcon(markerImage);
            if (forceCenter == true) {
                fullProgramMap.setCenter(new google.maps.LatLng(markersLatLng[index][0], markersLatLng[index][1]));
            }
        }
    }

    var panPath = [];
    var panQueue = [];
    var STEPS = 4;

    function panTo(newLat, newLng)
    {
        if (panPath.length > 0) {
          // We are already panning...queue this up for next move
            panQueue.push([newLat, newLng]);
        } else {
          // Lets compute the points we'll use
            panPath.push("LAZY SYNCRONIZED LOCK");  // make length non-zero - 'release' this before calling setTimeout
            var curLng = mapToBePanned.getCenter().lng();
            var curLat = mapToBePanned.getCenter().lat();
            var dLat = (newLat - curLat) / STEPS;
            var dLng = (newLng - curLng) / STEPS;

            for (var i = 0; i < STEPS; i++) {
                panPath.push([curLat + dLat * i, curLng + dLng * i]);
            }
            panPath.push([newLat, newLng]);
            panPath.shift();      // LAZY SYNCRONIZED LOCK
            setTimeout(doPan, 20);
        }
    }

    function doPan()
    {
        var next = panPath.shift();
        if (next != null) {
          // Continue our current pan action
            mapToBePanned.panTo(new google.maps.LatLng(next[0], next[1]));
            mapToBePanned.setZoom(parseInt($('#circuit-zoom-level').text()));
            setTimeout(doPan, 20);
        } else {
          // We are finished with this pan - check if there are any queue'd up locations to pan to
            var queued = panQueue.shift();
            if (queued != null) {
                panTo(queued[0], queued[1]);
            }
        }
    }

    function initProgramMap()
    {

        if (typeof google === 'object' && typeof google.maps === 'object') {
            boundsFullDirection = new google.maps.LatLngBounds();
            boundsPartialDirection = new google.maps.LatLngBounds();

            markerImage = {
                url: '../../images/pwa/common/pin-gmap.png',
                origin: new google.maps.Point(-0, -12),
            };
        }
        if (typeof google === 'object' && typeof google.maps === 'object') {
          //Départ
            marqueurPartialDeparture = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                position: new google.maps.LatLng(
                    parseFloat($('.day.first').attr('data-lat')),
                    parseFloat($('.day.first').attr('data-lng'))
                ),
            });
            marqueurPartialDeparture.setIcon(markerImage);

          //Arrivée
            marqueurPartialArrival = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                position: new google.maps.LatLng(
                    parseFloat($('.day-coords.last').attr('data-lat')),
                    parseFloat($('.day-coords.last').attr('data-lng'))
                ),
            });
            marqueurPartialArrival.setIcon(markerImage);
        }

      //Carte par défaut
        partialProgramMap = new google.maps.Map(document.getElementById('partial-program-map'), {
            zoom: 10,
            center: {
                lat: 48.8589101,
                lng: 2.3119548
            }
        });
      //Carte par défaut
        fullProgramMap = new google.maps.Map(document.getElementById('full-program-map'), {
            zoom: parseInt($('#circuit-zoom-level').text()),
            center: {
                lat: 48.8589101,
                lng: 2.3119548
            }
        });

        var image = '../../images/pwa/common/pin-gmap-out.png';
        var icon = {
            url: image,
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(50,50),
            scaledSize: new google.maps.Size(100,100)
        }
        var waypts = [];

        var fullPathWayPointsFullDirection = [];
        var fullPathWayPointsPartialDirection = [];

        $('li.day').each(function () {

            waypts = [];

            if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined) {
                fullPathWayPointsFullDirection.push({
                    location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                    stopover: true
                });
                waypts.push({
                    location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                    stopover: true
                });
            }
            var cpt = 1;
            var coords = $(this).find('span.day-coords');
            var increment = Math.ceil(coords.length / 22);

            coords.each(function () {
                if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined) {
                    fullPathWayPointsFullDirection.push({
                        location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                        stopover: true
                    });

                    if (coords.length < 20) {
                            waypts.push({
                                location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                                stopover: true
                                });
                    } else {
                        if ($(this).attr('data-lat') !== undefined && $(this).attr('data-lng') !== undefined && (cpt % increment) == 0) {
                            waypts.push({
                                location: new google.maps.LatLng(parseFloat($(this).attr('data-lat')), parseFloat($(this).attr('data-lng'))),
                                stopover: true
                            });
                        }
                    }
                }
                cpt++;
            });
            fullPathWayPointsPartialDirection.push(waypts);
        });

        var zoomVal = 0;
        var lats = 0;
        var lngs = 0;

        for (var key in fullPathWayPointsFullDirection) {
            if (fullPathWayPointsFullDirection.hasOwnProperty(key)) {
                lats += fullPathWayPointsFullDirection[key].location.lat();
                lngs += fullPathWayPointsFullDirection[key].location.lng();
            }
        }

        var centerLatFullDirection = lats / fullPathWayPointsFullDirection.length;
        var centerLngFullDirection = lngs / fullPathWayPointsFullDirection.length;

        lats = 0;
        lngs = 0;

        var dataSize = 0;

        for (var key in fullPathWayPointsPartialDirection) {
            if (fullPathWayPointsPartialDirection.hasOwnProperty(key)) {
                var arrData = fullPathWayPointsPartialDirection[key];
                dataSize += arrData.length;
                for (var innerKey in arrData) {
                    lats += arrData[innerKey].location.lat();
                    lngs += arrData[innerKey].location.lng();
                    boundsPartialDirection.extend(arrData[innerKey].location);
                }
            }
        }

        var centerLatPartialDirection = lats / dataSize;
        var centerLngPartialDirection = lngs / dataSize;

        partialProgramMap = new google.maps.Map(document.getElementById('partial-program-map'), {
            zoom: 10,
            center:
            new google.maps.LatLng(parseFloat($('.day.first').attr('data-lat')), parseFloat($('.day.first').attr('data-lng')))
        });

        fullProgramMap = new google.maps.Map(document.getElementById('full-program-map'), {
            zoom: parseInt($('#circuit-zoom-level').text()),
            center:
            new google.maps.LatLng(parseFloat($('.day.first').attr('data-lat')), parseFloat($('.day.first').attr('data-lng')))
        });


        if ($('ul.kml-sources li.full').attr('data-url') != '') {
            console.log('Request to ' + $('ul.kml-sources li.full').attr('data-url'));
            var kmlLayer = new google.maps.KmlLayer($('ul.kml-sources li.full').attr('data-url'), {
                suppressInfoWindows: true,
                preserveViewport: false,
                map: partialProgramMap
            });
        }

        $('ul.kml-sources li.step').each(function () {
            if ($(this).attr('data-url') != '') {
                console.log('Request to ' + $(this).attr('data-url'));
                var kmlLayer = new google.maps.KmlLayer($(this).attr('data-url'), {
                    suppressInfoWindows: true,
                    preserveViewport: true,
                    map: fullProgramMap
                });
            }
        });

        for (var i = 0; i < markersLatLng.length; i++ ) {
            var position = new google.maps.LatLng(
                markersLatLng[i][0],
                markersLatLng[i][1]
            );
            markersMapsLatLng.push(position);

            var marker = new google.maps.Marker({
                position: position,
                map: fullProgramMap,
                image: icon
            });
            markers.push(marker);
        }

        mapsInit = true;

        updateCurrentDay();
    }

    window.initProgram = initProgram;

    if ($('body.page-promo-list.page-circuit-list.pwa').length && matchMedia('(max-width: 1024px)').matches) {
        $('.days-list').slick({
            arrows: false,
            dots: true,
            infinite: false,
            variableWidth: true
        });

        var $dots = $('.days-list .slick-dots li');
        var nbDots = $dots.length;

        $dots.eq(0).addClass('active');

        $('.days-list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            window.scrollBy(0, 1); window.scrollBy(0, -1);
        });

        $('.days-list').on('beforeChange', function (event, slick, currentSlide, nextSlide) {

            for (var i = 0; i <= nextSlide; i++) {
                $dots.eq(i).addClass('active');
            }

            for (var j = nbDots; j > nextSlide; j--) {
                $dots.eq(j).removeClass('active');
            }

            window.scrollBy(0, 1); window.scrollBy(0, -1);
        });


        $('.days-list .slick-dots li').each(function (i, e) {
            var buttonText;

            buttonText = $(this).find('button').text();
            buttonText = 'Jour ' + buttonText;

            $(this).find('button').text(buttonText);
        });

        $('.days-list .slick-dots').each(function (i, e) {
            var Sum = 0;

            $(this).children('li').each(function (i, e) {
                Sum += $(e).outerWidth(true);
            });

            if (Sum > $(this).outerWidth()) {
                $(this).outerWidth(Sum + 30);
            }
        });
    }

  //page carousel
    if ($('.page-content .media-container .img-container').length) {
        $('.page-content .media-container .img-container').slick({
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: 0
        });
    }

  //testimonail widget carousel
    if ($('.testimonials-carousel').length) {
        $('.testimonials-carousel').slick({
            arrows: false,
          // autoplay: true,
            dots: true,
            centerMode: true,
            centerPadding: 0,
            pauseOnHover: true
        });
    }

  //faq
    $('.block-faq li.question-line>a').on('click', function (e) {
        e.preventDefault();

        var speed = 300;
        var element = $(this).parent();

        if (!element.hasClass('open')) {
            element.addClass('open');
            element.find('.answer').slideDown(speed);
        } else {
            element.removeClass('open');
            element.find('.answer').slideUp(speed);
        }
    });

  //gmapLoaded();

})(jQuery);

function initMap2()
{
    if ($('body.pwa').length) {
        window.initProgram();
    }
}

function initBookingForm(paramsData)
{
    var formElementSelector = 'div.booking-form .block-estimate-sticky.local';
    var formElement = $(formElementSelector);

    spinWaiting(formElementSelector, true);

    $.post($("#base_route").val() + "/_ajax/resetInstance/", {}, function (data) {
        $.ajax({
            url: $('#base_route').attr('value') + "/booking_form/bookingForm",
            type: 'GET',
            data: paramsData
        }).done(function (recivedData) {
            formElement.html(recivedData);
            if ($('.block-reviews').length === 1) {
                $('.header-reviews-overview').html($('.block-reviews').html());
                $('.header-reviews-overview .note-and-comments').show();
            }
            spinWaiting(formElementSelector, false);
            formElement.css('display', 'block');
            setTimeout(function () {
                $('select:not(#id_agence_depart):not(#id_agence_retour)').dropdown({
                    maxItems: 5
                }).dropdown({
                    maxItems: 5
                });
                setTimeout(function () {
                    $('select').each(function () {
                        if ($(this).parent().find('.form-element-dropdown').length > 1) {
                            $(this).parent().find('.form-element-dropdown:last-child').remove();
                        }
                    });
                }, 100);
            }, 100);

            if (
                $('.booking-form .form-element.select.agence_depart, ' +
                    '.booking-form .form-element.select.agence_retour').length > 0
            ) {
                $(
                    '.booking-form .form-element.select.agence_depart .form-element-dropdown'
                ).each(function (cpt) {
                    if (cpt === 0) {
                        $(this).show();
                    }
                    cpt++;
                });
                $(
                    '.booking-form .form-element.select.agence_retour .form-element-dropdown'
                ).each(function (cpt) {
                    if (cpt === 0) {
                        $(this).show();
                    }
                    cpt++;
                });
            }

            $('.form-element.select.agence_retour.disabled div:last-child').addClass('hidden');

        }).fail(function (recivedData) {
            //Nothing done
        }).always(function (recivedData) {
            formElement.css('height', 'inherit');
            spinWaiting(formElementSelector, false);
        });
    });
}

jQuery(document).ready(function ($) {

    $('select').dropdown({
        maxItems: 5
    });

    $(document).click(function (event) {
        if ($(window).width() < 1022 && $('.block-nav-mobile.open').length &&
        (
        ($(event.target).hasClass('burger') || $(event.target).hasClass('block-top-mobile') || $(event.target).hasClass('col-md-12') || ($(event.target).hasClass('container') && $(event.target).find('span.burger').length))
         ||
        $(event.target).hasClass('--wrapper')
        )
        ) {
            $('section#burger-menu-background').trigger('click');
        }
    });

    $(document).on('click','.form-element-dropdown a',function () {

        var index = 1;

        $(this).parent().find('li').each(function () {
            $(this).removeAttr('selected').attr('data-index', index);
            index++;
        });

        $(this).parent().find("ul li:contains(" + $(this).text() + ")").attr('selected', 'selected');

        if ($(this).parent().parent().hasClass('age-permis') || $(this).parent().parent().hasClass('tranche-age')) {
            $('.popin-content').scrollTop($('.popin-content')[0].scrollHeight);
        }

        var index = parseInt($(this).parent().find('ul li[selected="selected"]').attr('data-index'));

        $(this).parent().find('ul').animate({
            scrollTop: (index - 2) * 20
        }, 5, function () {
        });
    });

});

(function ($) {
    var body = $('body');

    var base_route = $("#base_route").val();

    $('div.topbar.rwd').each(function () {
        var $currentNode = $(this);
        $.post(base_route + "/_ajax/topBar/", {
        }, function (data) {
            $currentNode.replaceWith(data);
        })
    });

    var $dropdownBtn = $(".dropdown-btn");

    bindOverDropdown();
    bindOutDropdown();

    function bindOverDropdown()
    {
        $dropdownBtn.bind("mouseenter", onNavMouseOver);
        // $dropdown.bind("mouseover", onNavMouseOver);
    }

    function bindOutDropdown()
    {
        $dropdownBtn.bind("mouseleave", onNavMouseOut);
    }

    function onNavMouseOver()
    {
        var $currentDropdown = $(this).parent().find(".dropdown");
        $currentDropdown.stop(true, true).fadeIn();
    }

    function onNavMouseOut()
    {
        var $currentDropdown = $(this).parent().find(".dropdown");
        $currentDropdown.stop(true, true).fadeOut();
    }

    function manageKnowMoreElements()
    {
        $('a.know-more[title]').each(function () {
            // pour accepter un contenu html
            var title = $(this).attr('title');
            $(this).tooltip({
                track: true,
                content: title
            });
            $(this).click(function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
        });

        $('.know-more[data-content]').each(function () {
            $(this).hover(function (e) {
                if ($(this).data('content')) {
                    var tooltipBox = $('<div class="tooltip">' +
                        '<p>' +
                        $(this).data('content') +
                        '</p>' +
                        '</div>');

                    tooltipBox.appendTo($(this)).show();
                    $(this).on('mouseleave', function () {
                        $(this).find('.tooltip')
                            .remove();
                    });
                }
            });
            $(this).click(function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
        });
    }


    $(document).click(function (e) {
        if (!$(e.target).closest('.main-nav').length && !$(e.target).closest('.menu-toggle').length) {
            $('.main-nav').removeClass('open');
        }
    });

    //==========================================================================
    // Main nav
    //==========================================================================

    function mobileSectionMainResize($el)
    {
        if ($(this).width() >= 992) {
            // supprime les hauteurs fixées en js
            $('ul.main-menu , ul.main-menu ul.mobile-submenu ').height('');
        } else {
            $('ul.main-menu , ul.main-menu ul.mobile-submenu ').each(function () {
                // sauvegarde la hauteur de tous les menus et sous-menus
                if (!$.isNumeric($(this).data("memoHeight"))) {
                    $(this).data("memoHeight", $(this).height());
                }
            });

            if (typeof ($el) !== 'object') {
                $el = $('ul.main-menu');
            }
            var elh = $el.data("memoHeight");
            $el.height(elh);
            var elt = $el.position().top;
            var smt = $('section.main').position().top;
            // retaille tout les UL pour voir tous les items du menu visible mais pas plus (scroll)
            $('ul.main-menu, ul.main-menu ul.mobile-submenu').height(elh);
            // retaille section.main pour pouvoir scroller le menu sur mobile mais pas plus
            $('section.main').height(elh + elt - smt);
        }
    }

    $(window).resize(function (e) {
        if ($(this).width() >= 992) {
            $('section.main').css('overflow', 'visible');
            $('body').removeClass('mobile-menu-open');
            mobileSectionMainResize();
        }
    });

    $('.menu-toggle').click(function (e) {
        e.preventDefault();
        if (!$('.main-nav').hasClass('open')) {
            $('body').addClass('mobile-menu-open');
            $('.main-nav').addClass('open');
            $('section.main').css('overflow', 'hidden');
            mobileSectionMainResize();
        } else {
            $('body').removeClass('mobile-menu-open');
            $('.main-nav').removeClass('open');
            $('.main-nav .mobile-submenu').removeClass('show');
            $('section.main').css('overflow', 'visible');
        }
    });

    $('.has-submenu > a').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.mobile-submenu').addClass('show');
        mobileSectionMainResize($(this).siblings('.mobile-submenu'));
    });

    $('.mobile-submenu .back').on('click', function (e) {
        e.preventDefault();
        var $actualMenu = $(this).closest('.mobile-submenu');
        $actualMenu.removeClass('show');
        mobileSectionMainResize($actualMenu.parents("ul"));
    });

    $(document).click(function (e) {
        if (!$(e.target).closest('.main-nav').length && !$(e.target).closest('.menu-toggle').length) {
            $('body').removeClass('mobile-menu-open');
            $('.main-nav').removeClass('open');
            $('.main-nav .mobile-submenu').removeClass('show');
            $('section.main').css('overflow', 'visible');
        }
    });

    if ($('.main-menu li.has-submenu').length) {
        var $menu = $('.main-menu');
        $menu.menuAim({
            activate: activateSubmenu,
            deactivate: deactivateSubmenu,
            enter: function () {
            },
            exit: function () {
            },
            exitMenu: function () {
                $menu.find('.megamenu-trigger > span').removeClass('active');
                return true;
            },
            rowSelector: ".has-submenu",
            submenuSelector: "*",
            submenuDirection: "below",
            activationDelay: 250
        });
    }

    function activateSubmenu(row, activeRow)
    {
        row = $(row);
        row.find('> span').addClass('active');

        if (activeRow) {
            row.find('.submenu').show();
        } else {
            row.find('.submenu').slideDown(250);
        }
    }

    function deactivateSubmenu(row, nextRow)
    {
        row = $(row);
        row.find('> span').removeClass('active');

        if (nextRow) {
            row.find('.submenu').hide();
        } else {
            $('.submenu').slideUp(250, function () {
                $('.megamenu-trigger > span').removeClass('active');
            });
        }
    }

    //==========================================================================

    $('.radio-group').each(function () {
        var options = $(this).find('.option');
        var l = options.length;

        var shutEmOff = function () {
            for (var i = 0; i < l; i++) {
                var option = $(options[i]);
                option.removeClass('current');
                option.find('input[type="radio"]').removeAttr('checked');
            }
        }

        for (var i = 0; i < l; i++) {
            var option = $(options[i]);
            var drawedRadio = option.find('span');
            var actualRadio = option.find('input[type="radio"]');

            if (option.hasClass('current')) {
                actualRadio.attr('checked', 'checked');
            }

            + function (drawedRadio, actualRadio) {
                drawedRadio.on('click', function () {
                    var checked = actualRadio.attr('checked');
                    shutEmOff();
                    if (typeof (checked) !== 'undefined') {
                        actualRadio.removeAttr('checked');
                    } else {
                        actualRadio.attr('checked', 'checked');
                    }
                    actualRadio.attr('checked', 'true');
                    actualRadio.parent().addClass('current');
                });
            }(drawedRadio, actualRadio);
        }
    });

    $('.styled-checkbox').each(function () {
        var styledCheckbox = $(this);

        if (styledCheckbox.find('input').prop('checked')) {
            styledCheckbox.addClass('checked');
        } else {
            styledCheckbox.removeClass('checked');
        }

        $(this).find('span').click(function (e) {
            if ($(e.target).hasClass('noclick')) {
                return false;
            }

            var input = styledCheckbox.find('input').first();

            if (input.prop('checked')) {
                styledCheckbox.removeClass('checked');
                input.removeAttr('checked');
                input.prop('checked', false);
                input.trigger('change');
            } else {
                styledCheckbox.addClass('checked');
                input.attr('checked', 'checked');
                input.prop('checked', true);
                input.trigger('change');
            }
        });
    });

    $('.switch-checkbox').each(function () {
        var switchCheckbox = $(this);
        if (switchCheckbox.hasClass('checked')) {
            switchCheckbox.find('input').attr('checked', 'checked');
        }

        var toggleBox = function () {
            var input = switchCheckbox.find('input');
            if (typeof (input.attr('checked')) == 'undefined') {
                input.attr('checked', 'checked');
                switchCheckbox.addClass('checked');
            } else {
                input.removeAttr('checked');
                switchCheckbox.removeClass('checked');
            }
        };

        switchCheckbox.find('span').on('click', toggleBox);
    });

    $('.collapsable-box').each(function () {
        var collapsableBox = $(this);
        collapsableBox.children('div.title').on('click', function () {
            var content = collapsableBox.find('.content')
            if (collapsableBox.hasClass('closed')) {
                collapsableBox.removeClass('closed');
            } else {
                collapsableBox.addClass('closed');
            }
        });
    });

    manageKnowMoreElements();

    $('.slider-bar').each(function () {
        var wrapper = $(this);

        // Creating the bar
        var bar = $('<div class="bar">');
        wrapper.append(bar);

        // Grabbing the settings
        var min = wrapper.data('min');
        var max = wrapper.data('max');
        var step = wrapper.data('step');
        var range = wrapper.data('range');

        if (
            typeof (min) !== 'undefined' ||
            typeof (max) !== 'undefined'
        ) {
            var options = {
                min: min,
                max: max
            };

            if (typeof (step) !== 'undefined') {
                options.step = step;
            } else {
                options.step = 1;
            }

            if (typeof (range) !== 'undefined') {
                options.range = true;
                options.values = [options.min, options.min + options.step];
            }


            var n_vals = (options.max - options.min) / options.step + 1;

            var values = $('<ul class="values">');
            var rulers = $('<ul class="rulers">');
            var percentWidth = (100 / n_vals);
            for (var i = 0; i < n_vals; i++) {
                // The "mesure" for the ruler
                rulers.append(
                    $('<li>').html('<span></span>').css({'width': percentWidth + '%'})
                );

                // The value
                values.append(
                    $('<li>').html(i * options.step).css({'width': percentWidth + '%'})
                );
            }

            bar.slider(options);
            wrapper.append(rulers, values);
        }

    });
    var sidebarMap = {
        initMap: function (mapId) {
            var mapElementsDepart = null;
            var mapElementsRetour = null;
            var mapOptions = null;
            var map = null;
            var clientReference = '';
            var clientName = '';
            var marker = null;

            if (mapId !== undefined) {
                mapElementsDepart = $("#" + mapId);
                mapOptions = {
                    // How zoomed in you want the map to start at (always required)
                    zoom: 15,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    // The latitude and longitude to center the map (always required)
                    center: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude'))
                };

                map = new google.maps.Map(document.getElementById(mapId), mapOptions);
                clientReference = $('#client-reference').text();
                clientName = $('#client-name').text();

                // Add Markers
                marker =
                    new google.maps.Marker({
                        position: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude')),
                        map: map,
                        title: 'Agence ' + clientName + ' de ' + mapElementsDepart.attr('data-villeweb'),
                        icon: '../../../images/v3/specifique_client/' + clientReference + '/icons/map-icon.png'
                    })
                ;
                marker.setMap(map);
            } else {
                mapElementsDepart = $("#map_depart");
                mapOptions = {
                    // How zoomed in you want the map to start at (always required)
                    zoom: 15,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    // The latitude and longitude to center the map (always required)
                    center: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude'))
                };

                map = new google.maps.Map(document.getElementById('map_depart'), mapOptions);
                clientReference = $('#client-reference').text();
                clientName = $('#client-name').text();

                // Add Markers
                marker =
                    new google.maps.Marker({
                        position: new google.maps.LatLng(mapElementsDepart.attr('data-latitude'), mapElementsDepart.attr('data-longitude')),
                        map: map,
                        title: 'Agence ' + clientName + ' de ' + mapElementsDepart.attr('data-villeweb'),
                        icon: '../../../images/v3/specifique_client/' + clientReference + '/icons/map-icon.png'
                    })
                ;
                marker.setMap(map);

                if ($("#map_retour").length) {
                    mapElementsRetour = $("#map_retour");

                    mapOptions = {
                        // How zoomed in you want the map to start at (always required)
                        zoom: 15,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        // The latitude and longitude to center the map (always required)
                        center: new google.maps.LatLng(mapElementsRetour.attr('data-latitude'), mapElementsRetour.attr('data-longitude'))
                    };

                    map = new google.maps.Map(document.getElementById('map_retour'), mapOptions);
                    clientReference = $('#client-reference').text();
                    clientName = $('#client-name').text();

                    // Add Markers
                    marker =
                        new google.maps.Marker({
                            position: new google.maps.LatLng(mapElementsRetour.attr('data-latitude'), mapElementsRetour.attr('data-longitude')),
                            map: map,
                            title: 'Agence ' + clientName + ' de ' + mapElementsRetour.attr('data-villeweb'),
                            icon: '../../../images/v3/specifique_client/' + clientReference + '/icons/map-icon.png'
                        })
                    ;
                    marker.setMap(map);
                }
            }
        }
    };

    var vehicleSearch = undefined;
    vehicleSearch = {
        tabs: $('.vehicle-searchform-tabs a'),
        form: $('#vehicle-search'),
        submit: $('.vehicle-searchform-submit'),
        mapIsInit: false,
        init: function () {
            var self = this;

            $('.slider-loc-search').each(function (i, e) {

                $(this)
                    .on('jcarousel:reload jcarousel:create', function () {
                        $('.slider-loc-search').each(function () {

                            var width = $(this).innerWidth();

                            $(this).find('.slider-inner > li').css('width', width + 'px');
                        });
                    })
                    .jcarousel();
            });

            $('.slider-loc-search .bullets .inner')
                .on('jcarouselpagination:active', 'a', function () {
                    $(this).addClass('active');
                })
                .on('jcarouselpagination:inactive', 'a', function () {
                    $(this).removeClass('active');
                })
                .jcarouselPagination();

            if (jQuery().touchwipe) {
                $('.slider-loc-search').touchwipe({
                    wipeLeft: function (e) {
                        e.jcarousel('scroll', '+=1');
                    },
                    wipeRight: function (e) {
                        e.jcarousel('scroll', '-=1');
                    },
                    min_move_x: 20,
                    min_move_y: 20,
                    preventDefaultEvents: false
                });
            }

            self.tabs.click(function (e) {
                e.preventDefault();
                if (!$(this).hasClass('active')) {
                    self.tabs.removeClass('active');
                    $(this).addClass('active');
                }
            });

            self.submit.click(function (e) {
                e.preventDefault();
                self.form.submit();
            });


            $(".select-agency li[data-search]").each(function (e) {
                // initialise pour la recherche sans accent
                $(this).attr('data-search', filterConvert($(this).attr('data-search')));
            });

            $("#search-departure, #search-arrival").keydown(function (e) {
                // invalide la touche entrer dans les champs de filtrage
                if (e.which == 13) {
                    e.preventDefault();
                }
            });

            $("#search-departure, #search-arrival").keyup(function (e) {
                // filtre les agences
                vehicleSearch.filterAgency($(this))
            });

            $('.input-departure, .input-arrival').click(function (e) {
                $("#search-departure, #search-arrival").hide();
                var $selectAgency = $(this).parent('.vehicle-searchform-line').find('.select-agency');
                if (!$selectAgency.hasClass('visible')) {
                    self.openAgenciesList($(this));
                    var $searchInput = $(this).find("#search-departure, #search-arrival");
                    if ($searchInput.length) {
                        $searchInput.show().focus();
                        vehicleSearch.filterAgency($searchInput);
                    }
                } else {
                    self.closeAgenciesList();
                }
            });

            if ($('#vehicle-type:not(.invisible), #drivers-age, #licence-age').length > 0) {
                $('#vehicle-type:not(.invisible), #drivers-age, #licence-age').selectmenu();
            }

            $.extend($.datepicker, {
                _checkOffset: function (inst, offset, isFixed) {
                    return offset
                }
            });

            $(document).click(function (e) {

                var newHeight = $('#loc-search-default-height').attr('data-value');
                if (!$('body.partial-pwa, body.pwa').length) {
                    if (
                        !$(e.target).hasClass('input-departure') &&
                        !$(e.target).hasClass('input-arrival') &&
                        !$(e.target).closest('div').hasClass('input-departure') &&
                        !$(e.target).closest('div').hasClass('input-arrival')
                    ) {
                        $('.loc-search').css('height', $('#loc-search-default-height').attr('data-value') + 'px');
                    }
                }

                if (!$(e.target).closest('.input-departure').length && !$(e.target).closest('.agency-info').length) {
                    $('.select-departure').removeClass('visible');
                    $("#search-departure").hide();
                }

                if (!$(e.target).closest('.input-arrival').length && !$(e.target).closest('.agency-info').length) {
                    $('.select-arrival').removeClass('visible');
                    $("#search-arrival").hide();
                }

                if (!$(e.target).closest('.input-departure').length && !$(e.target).closest('.input-arrival').length && !$(e.target).closest('.agency-info').length) {
                    $('.vehicle-searchform').removeClass('open').removeClass('arrival');
                    $('.vehicle-searchform .agency-info').removeClass('visible');
                    $('body.home .loc-search').removeClass('full-height');
                }

            });

            $(document).ready(function () {
                $(document).click();
            });

            $('.select-agency a').click(function (e) {
                e.preventDefault;
                self.closeAgenciesList(e);
                var value = $(this).find('.name').text();
                if ($(this).closest('.vehicle-searchform-line').find('.input-departure').length == 1) {
                    var val2 = $('.vehicle-searchform-line .input-arrival .agency-value').text();
                } else {
                    if ($(this).closest('.vehicle-searchform-line').find('.input-arrival').length == 1) {
                        var val2 = $('.vehicle-searchform-line .input-departure .agency-value').text();
                    }
                }

                $(this).closest('.vehicle-searchform-line').find('.agency-value').text(value);
                //one way trip status update required :
                var elem = null;
                if ($('.form-context input[name="one_way_trip"]').length == 1) {
                    elem = $('.form-context input[name="one_way_trip"]');
                    if (value != val2) {
                        elem.attr('value', '1');
                    } else {
                        elem.attr('value', '0');
                    }
                } else {
                    elem = $('.form-context .one-way-trip');
                    if (value != val2) {
                        elem.text('1');
                    } else {
                        elem.text('0');
                    }
                }
            });
        },
        openAgenciesList: function (trigger) {

            var self = this;
            if ($(trigger).parent('.vehicle-searchform-line').find('.input-arrival.disabled').length == 0) {
                $(trigger).parent('.vehicle-searchform-line').find('.select-agency').addClass('visible');
                $('.vehicle-searchform .agency-info').addClass('visible');

                if ($('.select-agency.select-departure').hasClass('visible')) {
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.departure').show();
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.return').hide();
                    $('.vehicle-searchform').removeClass('arrival');
                } else if ($('.select-agency.select-arrival').hasClass('visible')) {
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.return').show();
                    $('.vehicle-searchform .agency-info .agency-hours-ctn.departure').hide();
                    if (matchMedia('(max-width: 992px)').matches) {
                        $('.vehicle-searchform').addClass('arrival');
                    }
                }

                var newHeight = $('.loc-search').height() + $('div[id^="agency-info-"]').height() + $('.add-message').height() + 20;
                $('.loc-search').css('height', newHeight + 'px');

                $('.vehicle-searchform').addClass('open');

                if (self.mapIsInit == false) {
                    self.initMap();
                }
                $('body.home .loc-search').addClass('full-height');
            }
        },
        closeAgenciesList: function (e) {

            if (!$('body.partial-pwa, body.pwa').length) {
                var newHeight = $('#loc-search-default-height').attr('data-value');
                $('.loc-search').css('height', newHeight + 'px');
            }

            var self = this;

            $('.select-departure, .select-arrival').removeClass('visible');
            $('.vehicle-searchform').removeClass('open').removeClass('arrival');
            $('.vehicle-searchform .agency-info').removeClass('visible');

            $('body.home .loc-search').removeClass('full-height');
        },
        initMap: function () {
        },
        filterAgency: function ($element) {
            var $selectAgency;
            var strfiltre = filterConvert($element.val());

            $selectAgency = $element.parents('.vehicle-searchform-line').find('.select-agency');
            $("#info_agence_depart_none,#info_agence_retour_none").hide();
            if (strfiltre.length > 0) {
                $selectAgency.find('li[data-search]').hide();
                $selectAgency.find('li[data-search*="' + strfiltre + '"]').show();
                $selectAgency.find('li[data-search-cp^="' + strfiltre + '"]').show();
            } else {
                $selectAgency.find('li[data-search]').show();
            }
            $selectAgency.find("#info_agence_depart_none, #info_agence_retour_none").toggle(!$selectAgency.find('li[data-search]:visible').length);
        }
    };


    var agenciesList = {
        mapEl: $('.agencies-map .gmap'),
        map: null
    };

    var eventPage = {
        mapEl: $('.location-map .mapCanvas'),
        init: function () {
            this.initMap();


        },
        initMap: function () {

            var mapOptions = {
                zoom: parseInt($('#agency-zoom').attr('data-zoom')),
                scrollwheel: false,
                center: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text())
            };
            var mapElement = this.mapEl[0];
            var map = new google.maps.Map(mapElement, mapOptions);

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text()),
                title: "Lieu de l'évènement",
                animation: google.maps.Animation.DROP,
                icon: '/images/v3/specifique_client/' + $('#client-reference').text() + '/icons/map_icon_black.png'
            });
            marker.setMap(map);
        }
    };

    var agencyPage = {
        mapEl: $('.agency-widget .location-map .mapCanvas'),
        init: function () {
            this.initMap();

            // init feedbacks Masonry
            if ($('#feedbacks-masonry').length) {
                var msnry = new Masonry('#feedbacks-masonry', {
                    itemSelector: '.feedbacks-masonry-item',
                    transitionDuration: 0
                });
            }


        },
        initMap: function () {
            if ($('div.location-map').length) {
                var mapOptions = {
                    zoom: parseInt($('#agency-zoom').attr('data-zoom')),
                    scrollwheel: false,
                    center: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text())
                };
                var mapElement = this.mapEl[0];
                var map = new google.maps.Map(mapElement, mapOptions);

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng($('.latlong .lat').text(), $('.latlong .long').text()),
                    title: $('.page-title-ctn #agenceName').text(),
                    animation: google.maps.Animation.DROP,
                    icon: '../../../images/v3/specifique_client/' + $('#client-reference').text() + '/icons/map-icon.png'
                });
                marker.setMap(map);
            }
        }
    };
    var singleVehicle = {
        init: function () {
            $('.slider-vehicle-images').each(function (i, e) {
                $(this)
                    .on('jcarousel:reload jcarousel:create', function () {
                        $('.slider-vehicle-images').each(function () {

                            var width = $(this).innerWidth();

                            $(this).find('.slider-inner > li').css('width', width + 'px');
                        });
                    })
                    .jcarousel();
            });

            $('.slider-vehicle-images .bullets .inner')
                .on('jcarouselpagination:active', 'a', function () {
                    $(this).addClass('active');
                })
                .on('jcarouselpagination:inactive', 'a', function () {
                    $(this).removeClass('active');
                });

            if ($.jcarouselPagination) {
                $('.slider-vehicle-images .bullets .inner').jcarouselPagination();
            }

            if (jQuery().touchwipe) {
                $('.slider-vehicle-images').touchwipe({
                    wipeLeft: function (e) {
                        e.jcarousel('scroll', '+=1');
                    },
                    wipeRight: function (e) {
                        e.jcarousel('scroll', '-=1');
                    },
                    min_move_x: 20,
                    min_move_y: 20,
                    preventDefaultEvents: false
                });
            }
        }
    };

    var vehicleList = {
        init: function () {
            $('.slider-vehicle-images').each(function (i, e) {
                $(this).on('jcarousel:reload jcarousel:create', function () {

                    $('.slider-vehicle-images').each(function () {

                        var width = $(this).innerWidth();

                        $(this).find('.slider-inner > li').css('width', width + 'px');
                    });
                })
                    .jcarousel();
            });

            $('.slider-vehicle-images .bullets .inner')
                .on('jcarouselpagination:active', 'a', function () {
                    $(this).addClass('active');
                })
                .on('jcarouselpagination:inactive', 'a', function () {
                    $(this).removeClass('active');
                });

            if ($.jcarouselPagination) {
                $('.slider-vehicle-images .bullets .inner').jcarouselPagination();
            }

            if (jQuery().touchwipe) {
                $('.slider-vehicle-images').touchwipe({
                    wipeLeft: function (e) {
                        e.jcarousel('scroll', '+=1');
                    },
                    wipeRight: function (e) {
                        e.jcarousel('scroll', '-=1');
                    },
                    min_move_x: 20,
                    min_move_y: 20,
                    preventDefaultEvents: false
                });
            }

            $('.moar-kilometers-trigger').click(function (e) {
                e.preventDefault();

                $(this).toggleClass('open');
                $('.moar-kilometers').toggle();
            });

            if ($('#drivers-age-filter, #licence-age-filter').length > 0) {
                $('#drivers-age-filter, #licence-age-filter').selectmenu();
            }

            $('.button-search-options').click(function (e) {
                e.preventDefault();
                $(this).toggleClass('open');
                $('.loc-search-edit').toggleClass('invisible');
            });

        }
    };



    if ($('.loc-search').length > 0) {
        if (body.hasClass('page-vehicles') || body.hasClass('page-vehicle')) {
            vehicleList.init();
        }

        if (body.hasClass('home') && $('.form-context').length) {
            //Chargement asynchrone du formulaire de réservation
            var method = 'POST;'
            if ($('.form-context .method').length === 0 || $('input[name="method"]').val() === 'GET') {
                method = 'GET';
            }
            $.ajax({
                url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                type: method,
                data: getFormParameters()
            }).done(function (data) {
                $('.form-container .inner-form').html(data);

                vehicleSearch.init();

                $('#boutonValider.loader').click(function () {
                    var message = '';
                    if (this.hasAttribute('data-loader-message')) {
                        message = $(this).attr('data-loader-message');
                    }
                    showLoader(message);
                });
                setFormDepartureArrival();

                manageKnowMoreElements();

                $('a.my-demand').click(function () {
                    if ($(this).hasClass('open')) {
                        $('.loc-search-edit').fadeIn('slow');
                        $('#vehicle-searchform').toggleClass('invisible', false);
                    } else {
                        $('.loc-search-edit').fadeOut('slow');
                        $('#vehicle-searchform').toggleClass('invisible', true);
                    }
                    $(this).toggleClass('open');
                    $('.loc-search-edit').each(function () {
                        modifieEntetesFixesEtFlottants();
                    });
                });

            }).fail(function (data) {
                //Nothing done
            }).always(function (data) {
                setFormDepartureArrival();

                hideLoader();
            });
        } else {
            vehicleSearch.init();
        }
    } else if (body.hasClass('page-agencies-list')) {
        //agenciesList.init();
    } else if (body.hasClass('page-agency') || body.hasClass('page-event-list')) {
        //agencyPage.init();
        $('.collapsable-box.has-top-sep.feedback-agency').removeAttr('style');
    } else if (body.hasClass('page-vehicle')) {
        singleVehicle.init();
    } else if (body.hasClass('page-vehicles') || body.hasClass('page-vehicle')) {
        vehicleList.init();
    }

    if (body.hasClass('rentiz-step-vehicle')) {
        singleVehicle.init();
    }

    var jcarousel = $('.jcarousel');
    var autostart = false;
    var carouselTimer = 5;

    jcarousel
        .on('jcarousel:reload jcarousel:create', function () {
            var width = jcarousel.innerWidth();

            if ($('#adaptative-width').attr('data-disable') != 'true') {
                if (width >= 600) {
                    width = width / 3;
                } else if (width >= 350) {
                    width = width / 2;
                }
                jcarousel.jcarousel('items').css('width', width + 'px');
            }
        });

    if (jcarousel.length) {
        jcarousel.jcarousel({
            wrap: 'circular'
        });
    }

    jcarousel.each(function () {
        if ($(this).hasClass('vehicules')) {
            carouselTimer = $('#vehicles-carousel-timer').text();
        }

        $(this).jcarouselAutoscroll({
            interval: carouselTimer,
            target: '+=1',
            autostart: autostart
        });


        $('.jcarousel-control-prev')
            .jcarouselControl({
                target: '-=1',
                carousel: $(this)
            });

        $('.jcarousel-control-next')
            .jcarouselControl({
                target: '+=1',
                carousel: $(this)
            });

    });


    jcarousel.touchwipe({
        wipeLeft: function () {
            jcarousel.jcarousel('scroll', '+=1');
        },
        wipeRight: function () {
            jcarousel.jcarousel('scroll', '-=1');
        },
        min_move_x: 20,
        min_move_y: 20,
        preventDefaultEvents: false
    });

    if ($('.jcarousel-pagination').length) {
        $('.jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function () {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function () {
                $(this).removeClass('active');
            })
            .on('click', function (e) {
                e.preventDefault();
            })
            .jcarouselPagination({
                perPage: 1,
                item: function (page) {
                    return '<a href="#' + page + '">' + page + '</a>';
                },
            carousel: jcarousel
            });
    }

    var feedbackcarousel = $('.feedback-jcarousel');
    var carouselTimer = 5;

    if (jcarousel.length > 0) {
        feedbackcarousel.on('jcarousel:reload jcarousel:create', function () {
            feedbackcarousel.jcarousel('items').width(feedbackcarousel.innerWidth());
        }).jcarousel({
            wrap: 'circular'
        }).jcarouselAutoscroll({
            interval: carouselTimer,
            target: '+=1',
            autostart: false
        });

        $('.feedback-slider-prev')
            .jcarouselControl({
                target: '-=1',
                carousel: feedbackcarousel
            });

        $('.feedback-slider-next')
            .jcarouselControl({
                target: '+=1',
                carousel: feedbackcarousel
            });

        feedbackcarousel.touchwipe({
            wipeLeft: function () {
                feedbackcarousel.jcarousel('scroll', '+=1');
            },
            wipeRight: function () {
                feedbackcarousel.jcarousel('scroll', '-=1');
            },
            min_move_x: 20,
            min_move_y: 20,
            preventDefaultEvents: false
        });
    }

    if ($('.custom-select').length > 0) {
        $('.custom-select').selectmenu({
            create: function (event, ui) {
                var prefix = $(event.target).attr('data-prefix');

                if (typeof prefix !== 'undefined') {
                    $('#' + $(event.target).attr('id') + '-button').find('.ui-selectmenu-text').prepend('<span class="prefix">' + prefix + '</span>');
                }
            },
            select: function (event, ui) {
                var prefix = $(event.target).attr('data-prefix');


                if (typeof prefix !== 'undefined') {
                    $('#' + $(event.target).attr('id') + '-button').find('.ui-selectmenu-text').prepend('<span class="prefix">' + prefix + '</span>');
                }

                if ($(this).attr('id') == 'vehicles-sort-agence') {
                    window.location = $(event.target).val();
                }

                if ($(this).attr('id') == 'vehicles-sort') {
                    window.location = $(event.target).val();
                }

                if ($('body.page-vehicles').length === 0) {
                    window.location = $(event.target).val();
                }

                if ($(event.target).attr('id') != 'vehicles-sort-vehicle-type' && $(event.target).attr('id') != 'vehicles-sort-type') {
                    if ($(event.target).val() == 'pertinence') {
                        var sortedVehicles = $('.vehicle-singles .vehicle-single').sort(function (a, b) {
                            var rep = parseFloat($(b).attr('data-pertinence')) - parseFloat($(a).attr('data-pertinence'));
                            return rep;
                        });
                    } else if ($(event.target).val() == 'desc') {
                        var sortedVehicles = $('.vehicle-singles .vehicle-single').sort(function (a, b) {
                            // tri sur le prix et à defaut sur la position. (toujours les prix en premier)
                            var posa = parseFloat($(a).attr('data-position')) || 0.0;
                            var posb = parseFloat($(b).attr('data-position')) || 0.0;
                            var pricea = parseFloat($(a).attr('data-price')) || 0.0;
                            var priceb = parseFloat($(b).attr('data-price')) || 0.0;
                            var rep = 0;
                            if (pricea !== 0.0 && priceb !== 0.0) {
                                rep = priceb - pricea;
                            } else if (pricea !== 0.0) {
                                rep = -1;
                            } else if (priceb !== 0.0) {
                                rep = 1;
                            } else {
                                rep = posb - posa;
                            }
                            return rep;
                        });
                    } else {
                        var sortedVehicles = $('.vehicle-singles .vehicle-single').sort(function (a, b) {
                            // tri sur le prix et à defaut sur la position. (toujours les prix en premier)
                            var posa = parseFloat($(a).attr('data-position')) || 0.0;
                            var posb = parseFloat($(b).attr('data-position')) || 0.0;
                            var pricea = parseFloat($(a).attr('data-price')) || 0.0;
                            var priceb = parseFloat($(b).attr('data-price')) || 0.0;
                            var rep = 0;
                            if (pricea !== 0.0 && priceb !== 0.0) {
                                rep = pricea - priceb;
                            } else if (pricea !== 0.0) {
                                rep = -1;
                            } else if (priceb !== 0.0) {
                                rep = 1;
                            } else {
                                rep = posa - posb;
                            }
                            return rep;
                        });
                    }

                    $.each(sortedVehicles, function (index, element) {
                        $('.vehicle-singles').append($(element));
                    });
                } else {
                    var idType = $(event.target).val();
                    var text = $('#vehicles-sort.filter option[value="' + idType + '"] ').text();

                    if (idType == 'all') {
                        $('.vehicle-single').each(function () {
                            $(this).fadeIn(500);
                        });
                    } else {
                        $('.vehicle-single').each(function () {
                            var elem = $(this).find('.prixOnline');
                            var selector = 'data-idtypevehicule';
                            if (!elem.length) {
                                elem = $(this);
                                selector = 'data-type';
                            }

                            if (elem.attr(selector) != idType) {
                                $(this).fadeOut(500)
                            } else {
                                $(this).fadeIn(500);
                            }
                        });

                        if ($('#sort-selection-old-behaviour').length > 0) {
                            setTimeout(function () {
                                if ($('.vehicle-single:visible').length == 0) {
                                    $('#vehicles-sort-price-button').addClass('grayed').css('pointer-events', 'none');
                                } else {
                                    $('#vehicles-sort-price-button').removeClass('grayed').css('pointer-events', 'all');
                                }
                            }, 700);
                        }
                    }



                    if ($('.vehicle-single[data-type="' + idType + '"]').length == 0) {
                        $('.not-found-msg').addClass('visible').removeClass('invisible');
                        $('.not-found-msg span').text(text);
                    } else {
                        $('.not-found-msg').removeClass('visible').addClass('invisible');
                    }
                }
            }
        });
    }

    if ($(".select-button.form-activated").length && ($('body').hasClass('page-vehicle') || $('body').hasClass('page-vehicles'))) {
        $(".select-button.form-activated").click(function () {
            doQuotationButtonAction($(this));
        });
        performAjaxQuotation($(".select-button.form-activated"));
    }

    //Fiche promotion
    if ($(".select-button.code-promo.arrow-button").length && $('body').hasClass('page-promo-list')) {
        $(".select-button.code-promo.arrow-button").click(function () {
            if ($('#scroll-to-form').text() != '1') {
                doQuotationButtonAction($(this));
            }
        });
        performAjaxQuotation($(".select-button.code-promo.arrow-button"));
    }

    //Fiche évenement
    if ($(".select-button.arrow-button").length && $('body').hasClass('page-event-list')) {
        $(".select-button.arrow-button").click(function () {
            if ($('#scroll-to-form').text() != '1') {
                doQuotationButtonAction($(this));
            }
        });
        performAjaxQuotation($(".select-button.arrow-button"));
    }

    //========================================================
    // Tabs
    //========================================================

    var tabsSelect = undefined;
    tabsSelect = {
        triggerList: $('.tab-triggers'),
        init: function () {
            if ($('body.calculateur').length) {
                var self = this;

                self.triggerList.find('> li > a').click(function (e) {
                    e.preventDefault();
                    $(this).closest('.tab-triggers').find('li').removeClass('active');
                    $(this).parent('li').addClass('active');
                    self.switchTab($(this));
                });
            }
        },
        switchTab: function (trigger) {
            if ($('body.calculateur').length) {
                var self = this;
                var tabsParent = trigger.closest('.tab-triggers').attr('data-target');
                var tabIndex = trigger.attr('data-index');

                $(tabsParent).find('div.page-tab').hide();
                faqList.resetLists();
                calcList.resetLists();
                $(tabsParent).find('div.page-tab[data-index="' + tabIndex + '"]').fadeIn(600);
            }
        }
    }

    //========================================================
    // CLACULATEUR
    //========================================================

// presentation en accordeon

    $(".accordeon").children('.itemAccordeon').each(function () {
        // on les ferme tous
        $(this).removeClass('active');
        $(this).children('div').slideUp(0);
        // lors d'un click sur le titre
        $(this).find('.titreclick').click(function () {
            // memorise mon itemAccordeon
            var itemAccordeon = $(this).parents(".itemAccordeon").last();
            // memorise mon etat active ou non
            var active = $(itemAccordeon).hasClass('active');
            // on ferme les items actifs
            $(this).parents('.accordeon').children('.itemAccordeon.active').each(function () {
                $(this).removeClass('active');
                $(this).children('div').slideUp({duration: 300});
            });
            // on active si besoin mon propre itemAccordeon
            if (!active) {
                $(itemAccordeon).addClass('active');
                $(itemAccordeon).children('div').slideDown({duration: 300});
            }
        });
    });

    //========================================================
    // FAQ
    //========================================================

    var faqList = undefined;
    faqList = {
        list: $('.faq-content'),
        listItems: $('.faq-content li'),
        itemTitle: $('.faq-content .question'),
        init: function () {
            var self = this;

            self.itemTitle.click(function (e) {
                e.preventDefault();
                self.switchItem($(this));
            });
        },
        switchItem: function (item) {
            var self = this;

            if (!item.closest('li').hasClass('open')) {
                self.listItems.removeClass('open');
                item.closest('li').addClass('open');
            }
        },
        resetLists: function () {
            var self = this;

            self.listItems.removeClass('open');

            self.list.each(function (i, e) {
                $(this).find('li:first-child').addClass('open');
            });
        }
    }

    if (body.hasClass('page-faq')) {
        faqList.init();
    }
    //tabsSelect.init();

    //========================================================
    //
    //========================================================

    if (body.hasClass('page-agencies-list') || body.hasClass('page-promo-list')) {
        if ($('#vehicle-type-select, #departure-city-select').length > 0) {
            $('#vehicle-type-select, #departure-city-select').selectmenu({
                change: function (event, data) {
                    if (data.item.value !== undefined) {
                        window.location = data.item.value;
                    }
                }
            });
        }

        $('#promo-single-get').click(function (e) {
            e.preventDefault();
            $(this).fadeOut();
            $('.agency-search-ctn').addClass('open');
        });

        $('#moar-checkbox').click(function (e) {
            if (this.checked) {
                $('.additional-options').fadeIn();

                if ($(window).width() < 992) {
                    $('.additional-options').css('width', $('#vehicle-search').width() + 'px');
                    $('.additional-options').css('position', 'absolute').css('top', '1180px');
                    $('#boutonValider').css('position', 'relative').css('top', '42%');
                    $('#vehicle-searchform').css('height', '530px');
                    $('#vehicle-search').css('height', '530px');
                }

                if ($(window).width() < 768 && $(window).width() > 490) {
                    if ($('#moar-checkbox:checked').length) {
                        $('.additional-options').css('top', '1120px');
                        $('#vehicle-search').css('height', '530px');
                        $('#vehicle-searchform').css('height', '530px');
                        $('#boutonValider').css('top', '42%');
                    }
                }

                if ($(window).width() < 490) {
                    var pos = $('#vehicle-search').offset();
                    $('.additional-options').css('top', ($('.vehicle-searchform-ctn').height() + pos.top + 15) + 'px');
                }

                if ($(window).width() < 483) {
                    if ($('#moar-checkbox:checked').length) {
                        $('#vehicle-search').css('height', '584px');
                        $('#vehicle-searchform').css('height', '592px');
                        $('#boutonValider').css('top', '49%');
                    }
                }
            } else {
                $('.additional-options').fadeOut();
                if ($(window).width() < 992) {
                    $('#vehicle-searchform').removeAttr('style');
                    $('#vehicle-search').removeAttr('style');
                }
            }
        });
    }

    if (body.hasClass('page-account') || body.hasClass('page-wizard-personal-infos')) {
        if ($(window).width() > 991) {
            $('#jour_naissance_day, #jour_naissance_month, #jour_naissance_year, #tiers_jour_naissance_day, #tiers_jour_naissance_month, #tiers_jour_naissance_year').selectmenu({width: 68}).each(function () {
                $(this).selectmenu("menuWidget").addClass("selectmenuoverflow");
            });
            $('#obtention_permis_day, #obtention_permis_month, #obtention_permis_year, #tiers_obtention_permis_day, #tiers_obtention_permis_month, #tiers_obtention_permis_year').selectmenu({width: 68}).each(function () {
                $(this).selectmenu("menuWidget").addClass("selectmenuoverflow");
            });
            $('#tiers_jour_naissance_conducteur_day, #tiers_jour_naissance_conducteur_month, #tiers_jour_naissance_conducteur_year,#tiers_jour_naissance_add_day, #tiers_jour_naissance_add_month, #tiers_jour_naissance_add_year, #tiers_obtention_permis_conducteur_day, #tiers_obtention_permis_conducteur_month, #tiers_obtention_permis_conducteur_year, #tiers_obtention_permis_add_day, #tiers_obtention_permis_add_month, #tiers_obtention_permis_add_year').selectmenu({width: 68}).each(function () {
                $(this).selectmenu("menuWidget").addClass("selectmenuoverflow");
            });
        } else {
            $('#jour_naissance_day, #jour_naissance_month, #jour_naissance_year, #tiers_jour_naissance_day, ' +
                '#tiers_jour_naissance_month, #tiers_jour_naissance_year')
                .addClass('lrStyled')
            ;
            $('#obtention_permis_day, #obtention_permis_month, #obtention_permis_year, #tiers_obtention_permis_day, ' +
                '#tiers_obtention_permis_month, #tiers_obtention_permis_year')
                .addClass('lrStyled')
            ;
            $('#tiers_jour_naissance_conducteur_day, #tiers_jour_naissance_conducteur_month, ' +
                '#tiers_jour_naissance_conducteur_year,#tiers_jour_naissance_add_day, #tiers_jour_naissance_add_month, ' +
                '#tiers_jour_naissance_add_year, #tiers_obtention_permis_conducteur_day, ' +
                '#tiers_obtention_permis_conducteur_month, #tiers_obtention_permis_conducteur_year, ' +
                '#tiers_obtention_permis_add_day, #tiers_obtention_permis_add_month, #tiers_obtention_permis_add_year')
                .addClass('lrStyled')
            ;
        }

        $('#tiers_statut_societe').selectmenu({width: 140});
        $('#day-select, #month-select, #year-select').selectmenu();
        $('#statut_societe').selectmenu();

        $('#obtention_permis_day, #obtention_permis_month, #obtention_permis_year, #tiers_obtention_permis_day,' +
            '#tiers_obtention_permis_month, #tiers_obtention_permis_year').click(
                function (e) {
                    return false;
                }
            )
        ;
    }

    if (body.hasClass('page-wizard-personal-infos') && $(window).width() > 991) {
        if ($('#day-select, #month-select, #year-select').length > 0) {
            $('#day-select, #month-select, #year-select').selectmenu();
        }
    } else {
        if ($(window).width() < 992) {
            $('#day-select, #month-select, #year-select').addClass('lrStyled');
        }
    }

    if (jQuery().fancybox) {
        $(".fancybox").fancybox();
    }

    function doQuotationButtonAction(button)
    {
        if ($('#spinner-script-url').text() != '') {
            loadJS($('#spinner-script-url').text());
        }

        $.post($("#base_route").val() + "/_ajax/resetInstance/", {
        }, function (data) {
        });

        if ($('.form-context').length) {
            var method = 'POST';
            if ($('.form-context .method').length == 0 || $('input[name="method"]').val() == 'GET') {
                method = 'GET';
            }

            $.ajax({
                url: $('#base_route').attr('value') + "/booking_form/bookingForm",
                type: method,
                data: getFormParameters()
            }).done(function (data) {
                if ($('body').hasClass('page-event-list') && $('div.location-map').length && $('.mapCanvas').find('div').length == 0) {
                    eventPage.init();
                }

                $(' .inner-form').html(data);

                vehicleSearch.init();

                $('#boutonValider.loader').click(function () {
                    var message = '';
                    if (this.hasAttribute('data-loader-message')) {
                        message = $(this).attr('data-loader-message');
                    }
                    showLoader(message);
                });
                setFormDepartureArrival();

                manageKnowMoreElements();

                if ($(".select-button.form-activated").length) {
                    button.parent().attr('action', '#');
                    $(".select-button.form-activated.invisible").fadeIn('slow').removeClass('invisible');
                    $("html, body").animate({scrollTop: 0}, 'slow');
                    $('a.my-demand').removeClass('invisible');
                    $('.top-form-controls').removeClass('invisible');
                    $('#vehicle-searchform, .loc-search.loc-search-edit').fadeIn('slow').removeClass('invisible');
                    $('select[name="id_categorie_vehicules"] option').removeAttr('selected');
                    $('select[name="id_categorie_vehicules"] option[value="' + button.attr('data-id-categorie-vehicule') + '"]').attr('selected', 'selected');
                    if (button.hasClass('must-disappear')) {
                        button.addClass('invisible').fadeOut('slow');
                    }

                    $('a.my-demand').click(function () {
                        if ($(this).hasClass('open')) {
                            $('.loc-search-edit').fadeIn('slow');
                            $('#vehicle-searchform').toggleClass('invisible', false);
                        } else {
                            $('.loc-search-edit').fadeOut('slow');
                            $('#vehicle-searchform').toggleClass('invisible', true);
                        }
                        $(this).toggleClass('open');

                        $('.loc-search-edit').each(function () {
                            modifieEntetesFixesEtFlottants();
                        });
                    });
                } else {
                    var o = null;
                    var top = 0;

                    if ($('.select-button.code-promo.arrow-button').length) {
                        o = $('.select-button.code-promo.arrow-button').offset();
                        top = o.top;
                    } else {
                        o = $('#vehicle-search').offset();
                        top = o.top - 100;
                    }

                    $("html, body").animate({scrollTop: top}, 800);

                    $('.loc-search, #vehicle-searchform').removeClass('invisible').fadeIn('slow');
                    button.fadeOut('slow');
                    button.css('pointer-events', 'none');

                    $('.agency-search-ctn').toggleClass('open');

                    var chrome = /chrome/.test(navigator.userAgent.toLowerCase());
                    var safari = /safari/.test(navigator.userAgent.toLowerCase());
                    var position = '';
                    position = '1120px';

                    if ($('#moar-checkbox:checked').length) {
                        $('.additional-options').fadeIn();
                    }

                    $('#moar-checkbox').click(function () {

                        if ($('#moar-checkbox:checked').length) {
                            $('.additional-options').fadeIn().fadeIn();
                        } else {
                            $('.additional-options').fadeOut();
                            $('#vehicle-type option').removeAttr('selected');
                            $('#vehicle-type option[value="0"]').attr('selected', 'selected');
                            $('#vehicle-type-button span.ui-selectmenu-text').text('Sélectionnez un véhicule');
                            $('#kilometres').val('');
                            $('#kilometres').removeAttr('style').removeClass('error');
                            $('#drivers-age option').removeAttr('selected');
                            $('#drivers-age option[value=""]').attr('selected', 'selected');
                            $('#drivers-age-button span.ui-selectmenu-text').text('Votre âge').removeAttr('style');
                            $('#drivers-age-button').removeClass('error');
                            $('#licence-age-button').removeClass('error');
                            $('#licence-age option').removeAttr('selected');
                            $('#licence-age option[value=""]').attr('selected', 'selected');
                            $('#licence-age-button span.ui-selectmenu-text').text('Années de permis').removeAttr('style');
                        }

                        if ($(window).width() > 992) {
                            $('.additional-options').removeAttr('style');
                            $('#vehicle-searchform').removeAttr('style');
                            $('#vehicle-search').removeAttr('style');
                        }

                        if ($(window).width() < 992) {
                            $('.additional-options').css('width', $('#vehicle-search').width() + 'px');
                            $('.additional-options').css('top', '1180px');
                        }

                        if ($(window).width() <= 768 && $(window).width() > 490) {
                            if ($('#moar-checkbox:checked').length) {
                                if (chrome || safari) {
                                    $('.additional-options').css('top', '1180px');
                                } else {
                                    if ($(window).width() == 768) {
                                        $('.additional-options').css('top', '1180px');
                                    } else {
                                        $('.additional-options').css('top', '1120px');
                                    }
                                }
                                $('#vehicle-search').css('height', '530px');
                                $('#vehicle-searchform').css('height', '530px');
                                $('#boutonValider').css('top', '42%');
                            }
                        }

                        if ($(window).width() < 490) {
                            var pos = $('#vehicle-search').offset();
                            $('.additional-options').css('top', ($('.vehicle-searchform-ctn').height() + pos.top + 15) + 'px');
                        }

                        if ($(window).width() < 483) {
                            if ($('#moar-checkbox:checked').length) {
                                $('#vehicle-search').css('height', '584px');
                                $('#vehicle-searchform').css('height', '592px');
                                $('#boutonValider').css('top', '49%');
                            }
                        }
                    });
                }
            }).fail(function (data) {
                //Nothing done
            }).always(function (data) {
                setFormDepartureArrival();

                hideLoader();
            });
        }
    }

    function performAjaxQuotation(object)
    {
        var scrollToForm = $('#scroll-to-form').text();
        $.ajax({
            url: $('#base_route').val() + "/booking_form/getScrollToForm",
            type: "POST",
            data: {
                scroll_to_form: scrollToForm
            }
        }).done(function (data) {
            var obj = jQuery.parseJSON(data);
            $('#scroll-to-form').text(obj['scroll_to_form']);
            if (obj['scroll_to_form'] == '1') {
                doQuotationButtonAction(object);
            }
        }).fail(function (data) {
        }).always(function (data) {
        });
    }

    function getFormParameters()
    {
        var params = {
            id_type: $('input[name="id_type"]').val(),
            owt_availability: $('input[name="owt_availability"]').val(),
            one_way_trip: $('input[name="one_vay_trip"]').val(),
            display_form_tabs: $('input[name="display_form_tabs"]').val(),
            display_form_tabs_ids: $('input[name="display_form_tabs_ids"]').val(),
            module_name: $('input[name="module_name"]').val(),
            action_name: $('input[name="action_name"]').val(),
            post_params_redirect: $('input[name="post_params_redirect"]').val(),
            current_categorie_type_url: $('input[name="current_categorie_type_url"]').val(),
            contenu_categorie_type_url: $('input[name="contenu_categorie_type_url"]').val(),
            contenu_agence_url: $('input[name="contenu_agence_url"]').val(),
            url_type_vehicules: $('input[name="url_type_vehicules"]').val(),
            url_categorie_vehicules: $('input[name="url_categorie_vehicules"]').val(),
            posted_data: $('.form-context .post-data .data').text(),
            display_mode: 'rwd',
        };


        if ($('input[name="id_agence_depart"]').val() != '') {
            params.id_agence_depart = $('input[name="id_agence_depart"]').val();
        }

        if ($('input[name="id_agence_retour"]').val() != '') {
            params.id_agence_retour = $('input[name="id_agence_retour"]').val();
        }

        return params;
    }

    $.fn.initSideBarMaps = function (mapId) {
        sidebarMap.initMap(mapId);
    }
    $.fn.initEventSingleMap = function () {
        eventPage.initMap();
    }
    $.fn.initVehicleSearch = function () {
        vehicleSearch.initMap();
    }
    $.fn.initAgencySingleMap = function () {
        agencyPage.initMap();
    }
})(jQuery);

if ($('#module_name').val() != 'agences') {
    if (($('#module_name').val() == 'vehicules' && !$('body').hasClass('pwa')) || $('#module_name').val() != 'vehicules') {
        function initMap()
        {
            var body = $('body');
            if (body.hasClass('page-event-list') && $('div.location-map').length && $('.mapCanvas').find('div').length == 0) {
                $.fn.initEventSingleMap();
            }
            if ($('form#vehicle-search').length > 0 || ($('section.main .inner-form, section.main .form-context').length > 0)) {
                $.fn.initVehicleSearch();
            }
            if ($('body.pwa.page-circuit-list.single').length) {
                window.initProgram();
            }
        }
    }
}

function rebindEventsOnResultLine()
{
    $('div.minus, div.plus').mouseenter(function () {
        $(this).attr('style', 'opacity: 0.9;');
    });

    $('div.minus, div.plus').mouseleave(function () {
        $(this).attr('style', 'opacity: 0.6;');
    });
}

function filterConvert(str)
{
    if (str === undefined) {
        str = '';
    }
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
        .replace(/æ/g, "ae")
        .replace(/Æ/g, "AE")
        .replace(/ð/g, "o")
        .replace(/ø/g, "o")
        .replace(/Ø/g, "O")
        .toLowerCase()
        .replace(/-/g, " ")
        .replace(/'/g, " ")
        .replace(/saint/g, "st")
        ;

    return str;
}

switch ($("#module_name").val()) {
    case 'mon_compte':
        $('#account-menu-trigger').click(function () {
            $('ul.page-tabs-nav').toggleClass('open');
        });
        break;

    case 'faq':
        $('#account-menu-trigger').click(function () {
            $('.top-menu ul.page-tabs-nav').toggleClass('open').toggleClass('hidden-xs').toggleClass('hidden-sm');
        });
        break;
}

//Exécution au chargement de la page
jQuery(document).ready(function ($) {
    var module_name = $("#module_name").val();
    var action_name = $("#action_name").val();
    var base_route = $("#base_route").val();

    var isMobile = false;
    var mobileText = '';

    try {
        document.createEvent("TouchEvent");
        isMobile = true;
        mobileText = '  /  Device is mobile !';
        $('.screen-size').text($('.screen-size').text() + mobileText);
    } catch (e) {
        isMobile = false;
        mobileText = '  /  Device is not mobile !';
        $('.screen-size').text($('.screen-size').text() + mobileText);
    }

    $(window).resize(function () {
        $('.screen-size').text($(window).width() + ' px by ' + $(window).height() + ' px' + mobileText);
        truncateFunc();
    });

    $(function () {
        $('.bullets .inner, .bullets .inner a').mousedown(function (event) {
            event.preventDefault();
            return false;
        });
    });

    $('li.has-submenu a').click(function () {
        window.location = $(this).attr('href');
    });

    bindLoader();


    //breadcrumb
    var bc = $('div.breadcrumb .container .row ul.breadcrumb');

    if (bc.length) {
        var numLevels = parseInt(bc.find('.previous_link').length) + parseInt(bc.find('.actual_link').length);

        if (numLevels > 2) {
            var url = bc.find('li.previous_link.actual a').attr('href');
            var labelActual = bc.find('li.actual_link a span').text();

            $('.block-top-mobile .btn-back').show();
            $('.block-top-mobile .btn.menu-mobile').hide();
            $('.block-top-mobile .btn-back').attr('href', url);
            $('.block-top-mobile h1.main-title').text(labelActual);
        } else {
            $('.block-top-mobile .btn-back').hide();
            $('.block-top-mobile .btn.menu-mobile').show();
        }
    } else {
        if ((module_name == 'reservation' && action_name != 'etapeInfos' && action_name != 'etapeConfirmation') ||
            (module_name == '_login' && action_name == 'lostPassword')) {
            $('.block-top-mobile .btn-back').show();
            $('.block-top-mobile .btn.menu-mobile').hide();
            $('.block-top-mobile .btn-back').attr('href', $('#back-url').text());
        }
    }


    // si la classe history_back est definie, c'est prioritaire sur les urls definies ci-dessus
    $('.main-bar-single-mobile-sticky .btn-back.history_back, .block-top-mobile .btn-back.history_back').attr('href', '/');
    $('.main-bar-single-mobile-sticky .btn-back.history_back, .block-top-mobile .btn-back.history_back').click(function () {
        event.preventDefault();
        event.stopPropagation();
        window.history.back();
    });

    $('a.load-cgl').click(function () {
        if (parseInt($(this).attr('data-opening-mode')) === 2) {
            window.open(base_route + '/cgl.pdf');
        } else {
            if (parseInt($(this).attr('data-opening-mode')) === 1 || parseInt($(this).attr('data-opening-mode')) === 0) {
                window.location = base_route + '/cgl.pdf';
            } else {
                if (parseInt($(this).attr('data-opening-mode')) === 3) {
                    window.open(
                        base_route + '/cgl.pdf',
                        'popUpWindow',
                        'height=800,width=700,left=100,top=100,resizable=yes,scrollbars=yes,' +
                        'toolbar=no,menubar=no,location=no,directories=no, status=yes'
                    );
                }
            }
        }

        return false;
    });

    $('.main-nav .main-menu li h3 a').click(function () {
        if ($(window).width() >= 991) {
            showLoader();
        }
    });

    if (!$("body").hasClass("backend")) {
        $.post(base_route + "/_ajax/modalbox/", {
        }, function (data) {
            if (data.length) {
                $("#_modalbox_").html(data);
                showModal();
            }
        });
    }

    $('.bloc_confirm img.close_button').click(function () {
        $('.bloc_confirm').fadeOut();
    });


    if ($('select.generic_selectmenu').length > 0) {
        $('select.generic_selectmenu').selectmenu({
            change: function (event, data) {
                $(event.target).val(data.item.value).change();
            }
        });
    }


    switch (module_name) {
        case 'default':
            switch (action_name) {
                case 'homepage':
                    launchSlidersRoll();
                    break;
            }
            break;

        case 'reservation':
            /*
             * Sidebar
             */
            initSidebar();
            switch (action_name) {
                case 'unknownEmail':
                    $('#login').focus();
                    break;

                case 'etapeInfos':

                    $('div[id^="agency-info"], ' +
                        'div[id^="agency-info"] .agency-info-head, ' +
                        'div[id^="agency-info"] .agency-info-moar ').click(function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                        })
                    ;
                    $.post(base_route + "/_ajax/getTargetAgencesIds/", {
                    }, function (data) {
                        var obj = jQuery.parseJSON(data);
                        if (obj['id_agence_depart'] == '') {
                            $('.select-arrival ul li[id="info_agence_retour_' + obj['id_agence_depart'] + '"]').trigger('click');
                        }
                        if (obj['id_agence_retour'] == '') {
                            $('.select-arrival ul li[id="info_agence_retour_' + obj['id_agence_retour'] + '"]').trigger('click');
                        }
                    });
                    $('.simple-modal-link').click(function () {
                        $('#simplemodal-container').remove();
                        $('#simplemodal-overlay').remove();
                    });
                    if ($('#show-simple-modal').attr('data-value') == '1') {
                        $('#basic-modal-pwd-expiry-content').modal();
                        $('#simplemodal-container').attr(
                            'style',
                            'position: fixed; z-index: 1002; left: ' +
                            ($(window).width() - 500) + 'px; top: ' + ($(window).height() - 200) +
                            'px; width: 440px; height: 170px;'
                        );
                    }


                    $('#heure_depart.error').parent().find('#heure_depart-button').addClass('error');
                    $('#heure_retour.error').parent().find('#heure_retour-button').addClass('error');
                    if ($('#heure_depart-button.error').legnth && $('#heure_depart.error').length == 0) {
                        $('#heure_depart-button.error').removeClass('error');
                    }
                    if ($('#heure_retour-button.error').legnth && $('#heure_retour.error').length == 0) {
                        $('#heure_retour-button.error').removeClass('error');
                    }

                    launchSlidersRoll();


                    reservationFormALinkBehaviourManagement();
                    oneWayTripManagement(action_name);
                    //Mise en rouge des champs erreurs
                    $('span.error').parent('p.form-line').prev('p.form-line').children('input,select').
                    css('backgroundColor', '#FFC4C4').css('border', '1px solid #D85656');
                    /*
                     * Enregistrement des infos sélectionné
                     * dans le formulaire d'accueil lors d'un changement d'onglet
                     */

                    $('ul.vehicles-type li a').click(function () {
                        var serializedForm = $('#vehicle-search[name=reservation_form]').serialize();
                        serializedForm = serializedForm.replace(/[^&]+=(?:&|$)/g, ''); //Virer tous les éléments vides
                        serializedForm = serializedForm.replace(/((?:&|$)+)((type|id)_categorie_vehicules=[0-9]+)(?:&|$)/g, '');
                        if (!$('#one_way_trip').length) {
                            serializedForm = serializedForm.replace(/one_way_trip=0/g, 'one_way_trip=1');
                            if (serializedForm.indexOf('one_way_trip') === -1) {
                                serializedForm += '&one_way_trip=1';
                            }
                        }
                        $(this).removeClass('active');
                        var myurl = $(this).attr('href');
                        var urlsep = '&';
                        if (myurl.indexOf('?') === -1) {
                            urlsep = '?';
                        }
                        window.location = myurl + urlsep + serializedForm;
                        return false;
                    });
                    if ($('#toggle-code-promo').length) {
                        $('#promo-trigger').click(function () {
                            if ($('#checkbox_code_promo_1').is(':checked')) {
                                $('#toggle-code-promo').slideDown();
                                $('p.form-line span.error').slideDown();
                            } else {
                                $('#toggle-code-promo').slideUp();
                                $('p.form-line span.error').slideUp();
                            }
                        });
                    }

                    $('#reservation_form input[type=submit]').click(function () {

                        var strIds = '';
                        $('#id_agence_depart option').each(function () {
                            if ($(this).val() !== 0) {
                                strIds += $(this).val() + ',';
                            }
                        });
                        $.ajax({
                            url: base_route + "/_ajax/isAgenceAloneInZone/",
                            data: 'id_zone=' + $('#id_agence_depart').val() + '&agences_ids=' + strIds + '&isowt=' + !$('#one_way_trip').is(':checked'),
                            async: false,
                            success: function (data) {
                                if (data) {
                                    $('#id_agence_depart option[selected=selected]').removeAttr('selected');
                                    $('#id_agence_depart').val(data);
                                    if ($('#one_way_trip').is(':checked')) {
                                        $('#id_agence_retour option[selected=selected]').removeAttr('selected');
                                        $('#id_agence_retour').val(data);
                                    }
                                }
                            }
                        });
                    });
                    reservationFormTimeBehaviourManagement();
                    setFormDepartureArrival();
                    break;
                case 'etapeTrajet':
                case 'etapeTrajetAgences':

                    //gestion du code promotion

                    $('#heure_depart.error').parent().find('#heure_depart-button').addClass('error');
                    $('#heure_retour.error').parent().find('#heure_retour-button').addClass('error');
                    reservationFormALinkBehaviourManagement();
                    // gestion formulaire
                    oneWayTripManagement(action_name);
                    setFormDepartureArrival();
                    $('.select-agency li').hover(function () {
                        var idAgence = $(this).attr('id').replace(/\D+/, '');
                        $('div[id^="agency-info-"]').removeAttr('style');
                        $('div[id="agency-info-' + idAgence + '"]').attr('style', 'z-index: 10;');
                    });
                    manageComboboxesErrorState('depart');
                    manageComboboxesErrorState('retour');
                    $('#reservation_form input[type=submit]').click(function () {

                        var strIds = '';
                        $('#id_agence_depart option').each(function () {
                            if ($(this).val() !== 0) {
                                strIds += $(this).val() + ',';
                            }
                        });
                        $.ajax({
                            url: base_route + "/_ajax/isAgenceAloneInZone/",
                            data: 'id_zone=' + $('#id_agence_depart').val() + '&agences_ids=' + strIds + '&isowt=' + !$('#one_way_trip').is(':checked'),
                            async: false,
                            success: function (data) {
                                if (data) {
                                    $('#id_agence_depart option[selected=selected]').removeAttr('selected');
                                    $('#id_agence_depart').val(data);
                                    if ($('#one_way_trip').is(':checked')) {
                                        $('#id_agence_retour option[selected=selected]').removeAttr('selected');
                                        $('#id_agence_retour').val(data);
                                    }
                                }
                            }
                        });
                    });
                    reservationFormTimeBehaviourManagement();
                    reservationFormALinkBehaviourManagement();
                    setFormDepartureArrival();
                    // etape 2
                    if ($('div.vehicle-list').length) {
                        $('a.my-demand').click(function () {

                            if ($(this).hasClass('open')) {
                                $('.loc-search-edit').fadeIn('slow');
                                $('#vehicle-searchform').toggleClass('invisible', false);
                            } else {
                                $('.loc-search-edit').fadeOut('slow');
                                $('#vehicle-searchform').toggleClass('invisible', true);
                            }
                            $('.loc-search-edit').each(function () {
                                modifieEntetesFixesEtFlottants();
                            });
                        });
                        //gestion du scroll de la page

                        //if ($('body.scroll-binded-events').length) {
                            $(window).scroll(function () {
                                modifieEntetesFixesEtFlottants();
                            });
                        //}
                        //gestion du resize de la page

                        $(window).resize(function () {
                            modifieEntetesFixesEtFlottants();
                        });
                        // gestion du code promo

                        $("input.input[name='promo-code']").click(function () {
                            if ($(this).hasClass('error')) {
                                $(this).removeClass('error');
                            }
                        });
                        $('div.vehicle-list .enter-promo-code button').click(function () {
                            var base_route = $("#base_route").val();
                            var idCategorieVehicule = $(this).closest('div.vehicle-single[rel]').attr('rel');
                            var codePromotion = $(this).closest('.enter-promo-code').find(' input').val();
                            var idAgenceDepart = $('#id_agence_depart option[selected="selected"]').attr('value');
                            var idAgenceRetour = $('#id_agence_retour option[selected="selected"]').attr('value');
                            var dateDepart = $('#date_depart').val();
                            var dateRetour = $('#date_retour').val();
                            var $refreshElement = $(this).closest('div.vehicle-single[rel]').find('div.price-actions');

                            if ($(this).find('span.text').text().trim() == $('#promo-code-adding-label').text().trim()) {
                                if (codePromotion !== '') {
                                    var $bouton = $(this);
                                    $bouton.attr('disabled', 'disabled');
                                    $.post(base_route + "/_ajax/checkPromotionValidity/", {
                                        code_promotion: codePromotion,
                                        id_agence_depart: idAgenceDepart,
                                        id_agence_retour: idAgenceRetour,
                                        id_categorie_vehicules: idCategorieVehicule,
                                        date_depart: dateDepart,
                                        date_retour: dateRetour
                                    }).done(function (data) {
                                        var obj = jQuery.parseJSON(data);
                                        $('#promo-error-' + idCategorieVehicule + ' ul.error_list li').text(obj.message);
                                        if (obj.message == '') {
                                            var $buttonDevis = $refreshElement.find('button.submit.action-devis');
                                            if ($buttonDevis.length) {
                                                $buttonDevis.click();
                                            } else if ($refreshElement.data('ajaxPrixCalled')) {
                                                refreshAjaxPrix($refreshElement, "<memo>", "<memo>", "<memo>", "<memo>", codePromotion);
                                            } else {
                                                $refreshElement.html(""); // par precaution mais ne doit theoriquement jamais arriver
                                            }
                                            $("input.input[data-id-categorie='" + idCategorieVehicule + "']").removeClass('error');
                                            $('#promo-error-' + idCategorieVehicule).addClass('invisible').hide();
                                        } else {
                                            $("input.input[data-id-categorie='" + idCategorieVehicule + "']").addClass('error');
                                            $('#promo-error-' + idCategorieVehicule).removeClass('invisible').show();
                                        }
                                    }).always(function () {
                                        $bouton.removeAttr('disabled');
                                    })
                                } else {
                                    $('#promo-error-' + idCategorieVehicule + ' ul.error_list li').text($("#empty-code-promo-error-text").text());
                                    $("input.input[data-id-categorie='" + idCategorieVehicule + "']").addClass('error');
                                    $('#promo-error-' + idCategorieVehicule).show();
                                }
                            } else {
                                $("input.input[data-id-categorie='" + idCategorieVehicule + "']").val('');
                                $('#promo-error-' + idCategorieVehicule + ' ul.error_list li').text('');
                                $('#promo-error-' + idCategorieVehicule).addClass('invisible');
                                var $buttonDevis = $refreshElement.find('button.submit.action-devis');
                                if ($buttonDevis.length) {
                                    $buttonDevis.click();
                                } else if ($refreshElement.data('ajaxPrixCalled')) {
                                    refreshAjaxPrix($refreshElement, "<memo>", "<memo>", "<memo>", "<memo>", "");
                                } else {
                                    $refreshElement.html(""); // par precaution mais ne doit theoriquement jamais arriver
                                }
                            }
                        });
                        // gestion des liens PLUS D'INFOS

                        $('div.vehicle-list').on('click', 'a.more-infos', function () {
                            $(this).closest('div.vehicle-single').find("a.more-infos").toggleClass('open');
                            $(this).closest('div.vehicle-single').find('div.vehicle-moar-info').slideToggle();
                        });
                        if ($('div.price-actions').length) {
                            // clique sur le choix du devis souhaité

                            $('div.price-actions').on('click', 'div.prixOnline label.radio', function () {
                                var refreshElement = $(this).closest('div.prixOnline').parent();
                                var idCategorieVehicule = $(this).closest('[data-idcategorievehicule]').data('idcategorievehicule');
                                var typeTarif = $(this).closest('[data-typetarif]').data('typetarif');
                                var kmmode = $(this).closest('[data-kmmode]').data('kmmode');
                                var kms = $(this).closest('[data-kms]').data('kms');
                                var codePromotion = $(this).closest('div.vehicle-single').find('.enter-promo-code').find(' input').val();
                                refreshAjaxPrix(refreshElement, idCategorieVehicule, typeTarif, kmmode, kms, codePromotion);
                            });
                            // clique sur plus de km

                            $('div.price-actions').on('click', 'div.prixOnline span.plus', function () {
                                var kmsIncrement = parseInt($(this).closest('div.prixOnline').find('span.raw-kms_increment').text());
                                var kms = 0;
                                var thSep = $('#thousands-separator').text();
                                var regpc = null;
                                if (thSep == ' ' || thSep == String.fromCharCode(160)) {
                                    regpc = new RegExp(/\s/g);
                                } else {
                                    kms = parseInt($(this).closest('div.choix').find('input[name=kilometers]').val().split(thSep).join(''));
                                }
                                if (regpc != null) {
                                    kms = parseInt($(this).closest('div.choix').find('input[name=kilometers]').val().replace(regpc, ''));
                                }
                                $(this).closest('div.choix').find('input[name=kilometers]').val(formatNumber(kms += kmsIncrement));
                                refreshAjaxPrixWaitOnKms(this);
                            });
                            // clique sur moins de km

                            $('div.price-actions').on('click', 'div.prixOnline span.moins', function () {
                                var kmsIncrement = parseInt($(this).closest('div.prixOnline').find('span.raw-kms_increment').text());
                                var kms = 0;
                                var thSep = $('#thousands-separator').text();
                                var regpc = null;
                                if (thSep == ' ' || thSep == String.fromCharCode(160)) {
                                    regpc = new RegExp(/\s/g);
                                } else {
                                    kms = parseInt($(this).closest('div.choix').find('input[name=kilometers]').val().split(thSep).join(''));
                                }
                                if (regpc != null) {
                                    kms = parseInt($(this).closest('div.choix').find('input[name=kilometers]').val().replace(regpc, ''));
                                }
                                $(this).closest('div.choix').find('input[name=kilometers]').val(formatNumber(kms -= kmsIncrement));
                                refreshAjaxPrixWaitOnKms(this);
                            });
                            // saisie numerique des kms (focus)

                            $('div.price-actions').on('focus', 'div.prixOnline input[name=kilometers]', function (event) {
                                $(this).select();
                            });
                            // saisie numerique des kms (validation des touches numerique)

                            $('div.price-actions').on('keypress', 'div.prixOnline input[name=kilometers]', function (event) {
                                var accept = '0123456789';
                                if (event.charCode && accept.indexOf(String.fromCharCode(event.charCode)) >= 0) {
                                    // ok
                                } else if (!event.charCode && (event.key == 'Backspace' || event.key == 'Delete')) {
                                    // ok
                                } else {
                                    return false;
                                }
                            });
                            // saisie numerique des kms

                            $('div.price-actions').on('keyup', 'div.prixOnline input[name=kilometers]', function (event) {
                                refreshAjaxPrixWaitOnKms(this);
                            });
                            // clique sur le bouton RESERVER
                            $('div.price-actions').on('click', 'div.prixOnline button.arrow-button.submit.action-reservation', function () {
                                var $vehicleSingle = $(this).closest('div.vehicle-single');
                                var modeActivation = $vehicleSingle.find('[data-mode-activation]').data('mode-activation');
                                if (modeActivation == 1) {
                                    var $choice = $vehicleSingle.find('div.choix .choice');
                                } else {
                                    var $choice = $vehicleSingle.find('div.choix label.radio.checked');
                                }

                                var wlIdAgenceDepart = $choice.closest('[data-wlidagencedepart]').data('wlidagencedepart');
                                var wlIdAgenceRetour = $choice.closest('[data-wlidagenceretour]').data('wlidagenceretour');
                                var timestampDepart = $choice.closest('[data-timestampdepart]').data('timestampdepart');
                                var timestampRetour = $choice.closest('[data-timestampretour]').data('timestampretour');

                                var idTypeVehicule = $choice.closest('[data-idtypevehicule]').data('idtypevehicule');
                                var idCategorieVehicule = $choice.closest('[data-idcategorievehicule]').data('idcategorievehicule');
                                var typeTarif = $choice.closest('[data-typetarif]').data('typetarif');
                                var kmmode = $choice.closest('[data-kmmode]').data('kmmode');
                                var kms = parseInt($choice.closest('[data-km-desires]').data('km-desires'));
                                var kmsbase = parseInt($choice.closest('[data-km-base]').data('km-base'));
                                var codeReduction = $vehicleSingle.find('input[name=promo-code]').val();
                                var form = $(this).closest('form');
                                showLoader();
                                $.ajax({
                                    url: $("#base_route").val() + "/_ajax/setDevisParameters/",
                                    data: {
                                        wlIdAgenceDepart: wlIdAgenceDepart,
                                        wlIdAgenceRetour: wlIdAgenceRetour,
                                        timestampDepart: timestampDepart,
                                        timestampRetour: timestampRetour,
                                        codeReduction: codeReduction,
                                        kms: ((kms === kmsbase || isNaN(kms)) ? null : kms),
                                        kmmode: kmmode,
                                        typetarif: typeTarif,
                                        id_categorie_vehicule: idCategorieVehicule,
                                        id_type_vehicule: idTypeVehicule
                                    },
                                    type: "POST",
                                    dataType: "json"
                                }).done(function (data) {
                                    $(form).submit();
                                }).fail(function (data) {
                                    if (data.status == 500 && data.statusText == "expiredSession") {
                                        showLoader();
                                        window.location = "/?session_expiree";
                                    } else {
                                        hideLoader();
                                    }
                                });
                            });
                            // clique sur le bouton MODIFIER MES DATES

                            $('div.price-actions').on('click', 'div.prixOnline button.arrow-button.modify-dates', function () {
                                $('html, body').animate({scrollTop: 0}, 800);
                                $('.loc-search-edit').toggleClass('visible', true);
                                $('.date-time-depart').addClass('blink');
                                $('.date-time-retour').addClass('blink');
                                setTimeout(function () {
                                    $('.date-time-depart').removeClass('blink');
                                    $('.date-time-retour').removeClass('blink');
                                }, 4000);
                            });
                        }
                    }

                    $('a.my-demand').click(function () {
                        if ($(this).hasClass('open')) {
                            $('.loc-search-edit').fadeIn('slow');
                            $('#vehicle-searchform').toggleClass('invisible', false);
                        } else {
                            $('.loc-search-edit').fadeOut('slow');
                            $('#vehicle-searchform').toggleClass('invisible', true);
                        }

                        $('.loc-search-edit').each(function () {
                            modifieEntetesFixesEtFlottants();
                        });
                        $(this).toggleClass('open');
                    });
                    break;
                case 'etapeDevisServices':

                    $(window).resize(
                        function () {
                            if ($(window).width() < 768) {
                                $('.big-popin').css('width', $(window).width() - 60);
                            }
                        }
                    );
                    $('div[id^=dialog-modal-modification]').each(function () {

                        var buttonModalContinuer = $(this).find('a.button-arrow.modal_waiting');
                        var buttonModalSelectAsurance = $(this).find('a.button-arrow.white');
                        var idProduit = buttonModalSelectAsurance.attr('rel');
                        //var checkBox  = $(".check[rel=" + idProduit + "] input[type='checkbox']");

                        var dialogBox = $(this);
                        buttonModalContinuer.click(function () {
                            dialogBox.dialog('close');
                        });
                    });
                    $('.panel-actions a.next').click(function () {

                        if ($('div[id^=dialog-modal-modification]').length) {
                            $('div[id^=dialog-modal-modification]').each(function () {

                                var idProduit = $(this).attr('rel');
                                var checkBox = $(".choix_multiple[name=" + idProduit + "] ");
                                if (!checkBox.is(':checked') && $('#' + idProduit + '-validation').text() == '1') {
                                    var buttonModalSelectAsurance = $(this).find('a.previous');
                                    //Appui sur le bouton ajout de la modalbox
                                    buttonModalSelectAsurance.click(function () {
                                        var idProduit = $(this).parent().parent().attr('rel');
                                        $('#dialog-modal-modification-' + idProduit).dialog('close');
                                        $('input.choix_multiple[name="' + idProduit + '"]').parent().
                                        find('span').trigger('click').addClass('noclick');
                                    });
                                    $("#dialog-modal-modification-" + idProduit).dialog({
                                        height: "auto",
                                        width: 600,
                                        modal: true,
                                        resizable: false,
                                        closeOnEscape: true,
                                        close: function () {
                                            $("body").css("overflow", "auto");
                                        }
                                    });
                                } else {
                                    setTimeout(function () {
                                        showLoader();
                                    }, 200);
                                    window.location = base_route + '/reservation/updateEtapeDevisServices';
                                }

                                //Réactivation du header de la modalbox qui est caché par l'appel à showModalWaiting
                                $(".ui-dialog-titlebar").show();
                                $(".ui-dialog-titlebar-close").show();
                            });
                        } else {
                            showLoader();
                            window.location = base_route + '/reservation/updateEtapeDevisServices';
                        }
                        return false;
                    });
                    $('.option-group li .option-checkbox').click(function (e) {
                        if (!$(e.target).parent().hasClass('option-checkbox')) {
                            $(this).find('.option-checkbox').toggleClass('checked');
                            if ($(this).find('input').attr('checked') == 'checked') {
                                $(this).find('input').removeAttr('checked');
                            } else {
                                $(this).find('input').attr('checked', 'checked');
                            }
                            $(this).find('input').trigger('change');
                        }
                    });
                    $('.modify-button[data-load-form="1"]').click(function () {
                        spinWaiting('.current-demand', true);
                        $.post(base_route + "/booking_form/bookingFormComponent/", {
                        }, function (data) {
                            $('.current-demand .content').html(data);
                            spinWaiting('.current-demand', false);
                        });
                    });
                    if ($(window).width() > 992) {
                        attachFixedOnScroll($('.top-breadcrumb'), '-5px');
                    }
                    $('.option-group input[type="checkbox"][checked="checked"]').parent().addClass('checked').
                    parent().find('.text h3.option-title').addClass('product-selected');
                    $('select.select_qte_produit option:selected[value!="0"]').parent().parent().
                    addClass('checked').parent().find('.text h3.option-title').
                    addClass('product-selected');
                    if ($('select.select_qte_produit').length > 0) {
                        $('select.select_qte_produit').selectmenu({
                            change: function (event, data) {
                                $(event.target).val(data.item.value).change();
                            }
                        });
                    }
                    //Ajout ou suppression d'un produit

                    // supprime les autre options selectionnées si choix unique
                    $('.option-group .option-checkbox span').click(function (e) {
                        var input = $(this).parent().find('input.choix_unique[data-famille]');
                        var idFamille = $(input).attr('data-famille');
                        if (!isNaN(idFamille)) {
                            $('input.choix_unique[data-famille="' + idFamille + '"]:checked').not(input).each(function () {
                                $(this).parent().find('input').removeAttr('checked');
                                $(this).parent().find('input').prop('checked', false);
                                $(this).parent().removeClass('checked');
                                $(this).trigger('change');
                            });
                        }
                    });
                    $('.option-group .option-checkbox input , select.select_qte_produit').change(function (e) {
                        if ($(this).parent().hasClass('noclick')) {
                            return false;
                        }

                        var nbMaxResquests = parseInt($('#nb-max-simultaneous-updates').attr('data-value'));
                        disableContinueButton();
                        if (parseInt($('#simultaneous-updates').attr('data-value')) < nbMaxResquests) {
                            if ($('#modal_ajax_display').attr('data-value') == '1') {
                                showLoader();
                            } else {
                                if ($('.quotation div.spinner').length == 0) {
                                    spinWaiting('.quotation', true);
                                }
                                if ($('.panel-sidebar .your-options div.spinner').length === 0) {
                                    spinWaiting('.panel-sidebar .your-options', true);
                                }
                                if (
                                    $('.page-list-options a.loader.next span.arrow div.spinner').length === 0 &&
                                    $('.page-list-options a.loader.next span.arrow-spinner div.spinner').length === 0
                                ) {
                                    $('.page-list-options a.loader.next span.arrow').addClass('arrow-spinner').
                                    removeClass('arrow');
                                    if ($(window).width() > 768) {
                                        spinWaiting(
                                            '.page-list-options a.loader.next span.arrow-spinner',
                                            true,
                                            5,
                                            3,
                                            false,
                                            ($('.loader.next').width() - 5),
                                            -22,
                                            '#fff',
                                            0.9
                                        );
                                    } else {
                                        spinWaiting(
                                            '.page-list-options a.loader.next span.arrow-spinner',
                                            true,
                                            5,
                                            3,
                                            false,
                                            ($('.loader.next').width() - 25),
                                            -22,
                                            '#fff',
                                            0.9
                                        );
                                    }
                                }

                                $('.quotation').removeAttr('spincount').attr('title', 'La mise à jour de votre devis est en cours');
                                $('#simultaneous-updates').attr('data-value', parseInt($('#simultaneous-updates').attr('data-value')) + 1);
                                if (parseInt($('#simultaneous-updates').attr('data-value')) == nbMaxResquests) {
                                    disableProductCheckboxes();
                                    $(this).addClass('clicked');
                                } else {
                                    $('li div.option-checkbox').removeAttr('style');
                                    $('.option-checkbox span').removeAttr('data-title');
                                }
                            }

                            var idProduit = $(this).attr('name');
                            var quantite = 0;
                            var isChecked = false;
                            if ($(this).is("select")) {
                                quantite = $(this).val();
                                isChecked = (quantite > 0);
                            } else {
                                isChecked = $(this).is(':checked');
                                quantite = isChecked ? 1 : 0;
                            }

                            if (!isChecked) {
                                $(this).closest("li").find('.text h3.option-title').removeClass('product-selected');
                            } else {
                                $(this).closest("li").find('.text h3.option-title').addClass('product-selected');
                            }

                            $.post(base_route + "/_ajax/option", {
                                id_produit: idProduit,
                                checked: !isChecked,
                                quantite: quantite
                            }, function (data) {
                                if (data == "badReservation") {
                                    showBadReservation();
                                    return false;
                                }

                                $('li div.option-checkbox').removeAttr('style');
                                if ($('#modal_ajax_display').attr('data-value') == '1') {
                                    hideLoader();
                                } else {
                                    $('.quotation').removeAttr('spincount').attr('title', '');
                                    $('#simultaneous-updates').attr('data-value', parseInt($('#simultaneous-updates').attr('data-value')) - 1);
                                    if (parseInt($('#simultaneous-updates').attr('data-value')) == 0) {
                                        spinWaiting('.quotation', false);
                                        spinWaiting('.panel-sidebar .your-options', false);
                                        spinWaiting('.page-list-options a.loader.next span.arrow-spinner', false);
                                        $('.page-list-options a.loader.next span.arrow-spinner').removeClass('arrow-spinner').addClass('arrow');
                                        enableContinueButton();
                                    } else {
                                        if ($('.quotation div.spinner').length == 0) {
                                            spinWaiting('.quotation', true);
                                        }
                                        if ($('.panel-sidebar .your-options div.spinner').length == 0) {
                                            spinWaiting('.panel-sidebar .your-options', true);
                                        }
                                        if ($('.page-list-options a.loader.next span.arrow div.spinner').length == 0 &&
                                            $('.page-list-options a.loader.next span.arrow-spinner div.spinner').length == 0
                                            ) {
                                            $('.page-list-options a.loader.next span.arrow').addClass('arrow-spinner').removeClass('arrow');
                                            if ($(window).width() > 768) {
                                                spinWaiting('.page-list-options a.loader.next span.arrow-spinner', true, 5, 3, false, ($('.loader.next').width() - 5), -22, '#fff', 0.9);
                                            } else {
                                                spinWaiting('.page-list-options a.loader.next span.arrow-spinner', true, 5, 3, false, ($('.loader.next').width() - 25), -22, '#fff', 0.9);
                                            }
                                        }
                                        disableContinueButton();
                                    }
                                }

                                $('#recapitulatif_produits span').html(data);
                                if (parseInt($('#simultaneous-updates').attr('data-value')) == 0) {
                                    $.post(base_route + "/_ajax/reloadSidebar/", {}, function (data) {
                                        $('.panel-sidebar').html(data);
                                        if (typeof initSidebar == 'function') {
                                            initSidebar();
                                        }
                                    }).fail(function () {
                                        showLoader();
                                        window.location.reload();
                                    });
                                    $('.page-list-options a.loader.next, .page-list-options .loader.next span').removeAttr('style');
                                    enableProductCheckboxes();
                                    enableContinueButton();
                                }
                                if (parseInt($('#simultaneous-updates').attr('data-value')) < nbMaxResquests) {
                                    $('li div.option-checkbox').removeAttr('style');
                                    $('.option-checkbox span').removeAttr('data-title');
                                    enableProductCheckboxes();
                                }
                            }).fail(function () {
                                hideLoader();
                                spinWaiting('.quotation', false);
                                spinWaiting('.panel-sidebar .your-options', false);
                                spinWaiting('.page-list-options a.loader.next span.arrow-spinner', false);
                                $('.page-list-options a.loader.next span.arrow-spinner').removeClass('arrow-spinner').addClass('arrow');
                                enableContinueButton();
                            });
                        } else {
                            $(this).addClass('clicked');
                            disableProductCheckboxes();
                            disableContinueButton();
                        }
                    });
                    $(".option-checkbox span").click(function () {

                        var input = $(this).parent().find('input');
                        var rel = input.attr('name');
                        if (input.is(':checked')) {
                            $('#' + rel + '-validation').text('0');
                        } else {
                            $('#' + rel + '-validation').text('1');
                        }
                        if ($('#one-way-trip').text() == 1) {
                            $.post(base_route + "/_ajax/AllowedOptionForOneWayTrip/", {
                                id_produit: rel,
                                checked: false
                            }, function (data) {
                                if (data == '0') {
                                    $("input[type='checkbox'][name='" + rel + "']").parent().parent().addClass('invisible').fadeOut();
                                    var idFamily = input.attr('data-famille');
                                    var famille = $('div.collapsable-box[data-id-famille="' + idFamily + '"]');
                                    if (famille.find('ul.option-group li:not(.invisible)').length == 0) {
                                        famille.fadeOut();
                                    }
                                }
                            });
                        }
                    });
                    $('a.popin-contact').click(function () {
                        window.location.assign($(this).attr('href'));
                    });
                    break;
                case 'etapeDonneesPersonnelles':

                    // actions immediates *********************************************************************************************

                    $('#bloc_question_compte_existe').hide();
                    $('#reponse_compte_existe_non').prop("checked", true);
                    $('#bloc_password').hide();
                    $('#bouton_valider').hide();
                    $('#bouton_sidentifier').hide();
                    $('#bouton_modifier').hide();
                    if ($('#tiers_email').val().length) {
                        $('#tiers_email').addClass('disabled_by_jquery').attr('readonly', 'readonly');
                        $('#bloc_question_compte_existe').hide();
                        $('#bouton_valider').show();
                        if ($('#isAuthenticated').val() == 0) {
                            $('#bouton_modifier').show();
                        }
                    } else {
                        $('#bloc_question_compte_existe').show();
                        $('#bouton_sidentifier').show();
                    }

                    // mise en forme des erreurs de champ symfony
                    $('ul.error_list').prev('p.form-line').children('input,select').css('backgroundColor', '#FFC4C4').css('border', '1px solid #D85656');
                    // mise en forme selon la taille de l'ecran

                    if ($(window).width() > 992) {
                        attachFixedOnScroll($('.top-breadcrumb'), '-5px');
                    }

                    //Affichage ou non de la partie conducteur/payable du formulaire
                    //On masque par défaut les champs
                    var inputConducteurIsPayable = $('#tiers_conducteur_principal_payable');
                    var inputConducteurIsConducteur = $('#tiers_conducteur_principal_conducteur');
                    if (inputConducteurIsConducteur.is(':checked')) {
                        $('.coordonnees_conducteur input').each(function () {
                            if (parseInt($(this).attr('data-mandatory')) === 1) {
                                $(this).parent().find('label span').
                                attr('class', 'bold red').text('*');
                            }
                            if (parseInt($(this).attr('data-mandatory')) === 0) {
                                $(this).parent().find('label span').
                                attr('class', 'optional-label').text('facultatif');
                            }
                        });
                        $('div.naissance_conducteur, div.coordonnees_conducteur').show();
                        $('div.naissance_payable').hide();
                    } else {
                        $('div.naissance_payable').show();
                        $('div.naissance_conducteur, div.coordonnees_conducteur').hide();
                    }
                    inputConducteurIsPayable.click(function () {
                        $('div.naissance_conducteur, div.coordonnees_conducteur').hide();
                        $('div.naissance_payable').show();
                    });
                    inputConducteurIsConducteur.click(function () {
                        $('div.naissance_payable').hide();
                        $('.coordonnees_conducteur input').each(function () {
                            if (parseInt($(this).attr('data-mandatory')) === 1) {
                                $(this).parent().find('label span').
                                attr('class', 'bold red').text('*');
                            }
                            if (parseInt($(this).attr('data-mandatory')) === 0) {
                                $(this).parent().find('label span').
                                attr('class', 'optional-label').text('facultatif');
                            }
                        });
                        $('div.naissance_conducteur, div.coordonnees_conducteur').show();
                    });

                    // gestion des evenements *********************************************************************************************

                    $(window).resize(function () {
                        if ($(window).width() < 768) {
                            $('.big-popin').css('width', ($(window).width() - 60) + "px");
                        }

                    });
                    //On empêche la touche entrer pour les formulaires
                    $("form").keypress(function (e) {
                        if (e.which == 13) {
                            var tagName = e.target.tagName.toLowerCase();
                            if (tagName !== "textarea") {
                                return false;
                            }
                        }
                    });
                    $('.add-driver, .del-driver').click(function () {
                        showLoader();
                        if ($(this).hasClass('closed')) {
                            $(this).find('p').html('<strong>' + $('#additionnal-driver-del-label').text() + '</strong>');
                            $(this).removeClass('closed');
                            $(this).addClass('opened');
                            $('#zone_conducteur_additionnel').slideDown();
                            $('#tiers_conducteur_additionnel').val('1');
                            var isChecked = false;
                        } else {
                            $(this).find('p').html('<strong>' + $('#additionnal-driver-add-label').text() + '</strong>');
                            $(this).removeClass('opened');
                            $(this).addClass('closed');
                            $('#zone_conducteur_additionnel').slideUp();
                            $('#tiers_conducteur_additionnel').val('0');
                            var isChecked = true;
                        }

                        //Ajout ou suppression d'un produit
                        var idProduit = $(this).find('p').attr('rel');
                        $.post(base_route + "/_ajax/option/", {
                            id_produit: idProduit,
                            checked: isChecked,
                            cond_add: true
                        }, function (data) {
                            if (data == "badReservation") {
                                showBadReservation();
                                return false;
                            }

                            $.post(base_route + "/_ajax/reloadSidebar/", {}, function (data) {
                                $('.panel-sidebar').html(data);
                                hideLoader();
                                initSidebar();
                            }).fail(function () {
                                showLoader();
                                window.location.reload();
                            });
                        });
                        return false;
                    });
                    $('input[name=compteExiste]').change(function () {
                        if ($(this).val() == "oui") {
                            $('#bloc_password').show();
                        } else {
                            $('#bloc_password').hide();
                        }
                        $('#bloc_error_message').hide();
                        $('#bloc_info_message').hide();
                        $('#bloc_login_message').hide();
                    });
                    $('#bouton_valider').click(function () {
                        $('#reservation_tiers_form').submit();
                    });
                    $('#bouton_sidentifier').click(function () {
                        spinWaiting('#reservation_tiers_form', true);
                        var mode_authentification = $('#mode-authentification').text();
                        var email = jQuery.trim($('#tiers_email').val());
                        var password = jQuery.trim($('#password').val());
                        var reponseCompteExiste = $('input[name=compteExiste]:checked').val();
                        $('#bouton_valider').fadeOut();
                        $('#bouton_sidentifier').fadeOut();
                        $('#bouton_modifier').fadeOut();
                        $('#bloc_error_message').hide();
                        $('#bloc_info_message').hide();
                        $('#bloc_login_message').hide();
                        $('#message_pour_authentication').text($('#personnal-data-mention-identification').text());
                        if (email == '') {
                            // email vide
                            $('#bouton_sidentifier').fadeIn();
                            $('#bloc_login_message li').html($('#personnal-data-identification-error-message-email').text());
                            $('#bloc_login_message').show();
                        } else if (!isValidEmailAddress(email)) {
                            // format email invalide
                            $('#bouton_sidentifier').fadeIn();
                            $('#bloc_login_message li').html($('#personnal-data-identification-error-message-email').text());
                            $('#bloc_login_message').show();
                        } else {
                            // email valide

                            var ajaxParams = {email: email};

                            spinWaiting('#reservation_tiers_form', true);
                            $.post(base_route + "/_ajax/disponibiliteEmail/", ajaxParams, function (data) {
                                if (data == 'true') {
                                    // email pas associé (inconnu)
                                    if (reponseCompteExiste == 'oui') {
                                        // declare avoir un compte
                                        // alert('ce compte nexiste pas');
                                        $('#bouton_sidentifier').fadeIn();
                                        if (password === '') {
                                            $('#bloc_login_message li').html($('#personnal-data-identification-no-password-provided-error-message').text());
                                        } else {
                                            $('#bloc_login_message li').html($('#personnal-data-identification-email-non-connu').text());
                                        }
                                        $('#bloc_login_message').show();
                                    } else {
                                        // declare ne pas avoir de compte
                                        // alert('nouveau compte');
                                        $('#tiers_email').addClass('disabled_by_jquery').attr('readonly', 'readonly');
                                        $('#bouton_modifier').fadeIn();
                                        $('#bouton_valider').fadeIn();
                                        $('#bloc_question_compte_existe').hide();
                                        $('#message_pour_authentication').text($('#personnal-data-mention-nouveau-client').text());
                                        $('#bloc_password').hide();
                                        $('#bloc_login_message').hide();
                                        $('#bloc_tiers').slideDown();
                                    }
                                } else if (data == 'false') {
                                    // email associé (connu)
                                    // mouveau mode
                                    if (reponseCompteExiste == 'non') {
                                        // declare ne pas avoir de compte
                                        // alert('ce compte existe deja');
                                        if (parseInt($('#authentification-errors-display-mode').text()) === 2) {
                                            $('#tiers_email').addClass('disabled_by_jquery').attr('readonly', 'readonly');
                                            $('#bouton_modifier').fadeIn();
                                            $('#bouton_valider').fadeIn();
                                            $('#bloc_question_compte_existe').hide();
                                            $('#message_pour_authentication').text($('#personnal-data-mention-nouveau-client').text());
                                            $('#bloc_password').hide();
                                            $('#bloc_login_message').hide();
                                            $('#bloc_tiers').slideDown();
                                        } else {
                                            $('#bouton_sidentifier').fadeIn();
                                            $('#bloc_login_message li').html($('#personnal-data-identification-email-deja-connu').text());
                                            $('#bloc_login_message').show();
                                            $('#bouton_sidentifier').fadeIn();
                                        }
                                    } else {
                                        // declare avoir un compte
                                        if (email !== '' && password === '') {
                                            // password vide
                                            if (mode_authentification == 1) {
                                                // ancien mode 1
                                                $('#bouton_sidentifier').fadeIn();
                                                $('#bouton_modifier').fadeIn();
                                                $('#tiers_email').addClass('disabled_by_jquery').attr('readonly', 'readonly');
                                                $('#message_pour_authentication').text($('#personnal-data-mention-deja-client-1').text());
                                                $('#bloc_password').show();
                                                if ($('#tiers_email').attr("data-memo") == $('#tiers_email').val()) {
                                                    $('#bouton_modifier').fadeIn();
                                                    $('#bloc_login_message li').html($('#personnal-data-identification-no-password-provided-error-message').text());
                                                    $('#bloc_login_message').show();
                                                } else {
                                                    $('#bloc_login_message li').html("");
                                                    $('#bloc_login_message').hide();
                                                }
                                                $('#tiers_email').attr("data-memo", $('#tiers_email').val());
                                            } else {
                                                // nouveau mode 2
                                                $('#bouton_sidentifier').fadeIn();
                                                $('#bloc_login_message li').html($('#personnal-data-identification-no-password-provided-error-message').text());
                                                $('#bloc_login_message').show();
                                                $('#bloc_password').show();
                                            }
                                        } else if (email != '' && password != '') {
                                            $('#bloc_login_message').hide();
                                            $('#bloc_error_message').hide();

                                            spinWaiting('#reservation_tiers_form', true);
                                            $.post(
                                                base_route + "/_ajax/loginEmail/",
                                                {login: email, password: password},
                                                function (returnedData) {
                                                    if (returnedData === 'true') {
                                                        $('#tiers_email').addClass('disabled_by_jquery').attr('readonly', 'readonly');
                                                        showLoader();
                                                        window.location = $('#base_route_reservation').val() + '?userid=' + email;
                                                    } else {
                                                        if (returnedData === 'false') {
                                                            $('#bloc_login_message li').html($('#personnal-data-identification-bad-password-error-message').text());
                                                        } else {
                                                            $('#bloc_login_message li').html(returnedData);
                                                        }
                                                        $('#bloc_login_message').show();
                                                        $('#bloc_password').show();
                                                        $('#bouton_sidentifier').fadeIn();
                                                        if ($('#tiers_email').is('[readonly]')) {
                                                            $('#bouton_modifier').fadeIn();
                                                        }
                                                    }
                                                }
                                            ).always(function (err) {
                                                spinWaiting('#reservation_tiers_form', false);
                                            });
                                        }
                                    }
                                } else {
                                    $('#bouton_sidentifier').fadeIn();
                                    $('#bloc_login_message li').html(data);
                                    $('#bloc_login_message').show();
                                }
                            }).always(function (err) {
                                spinWaiting('#reservation_tiers_form', false);
                            });
                        }

                        spinWaiting('#reservation_tiers_form', false);
                        return false;
                    });
                    $('#bouton_modifier').click(function () {
                        // modifier
                        // alert('modifier');
                        $('#tiers_email').removeClass('disabled_by_jquery').removeAttr('readonly');
                        $('#tiers_email').attr("data-memo", "");
                        $('#password').val('');
                        $('#bouton_sidentifier').show();
                        $('#bouton_valider').hide();
                        $('#bouton_modifier').hide();
                        $('#bloc_question_compte_existe').show();
                        $('#reponse_compte_existe_non').prop("checked", true);
                        $('#bloc_password').hide();
                        $('#message_pour_authentication').text($('#personnal-data-mention-identification').text());
                        $('#bloc_login_message').hide();
                        $('#bloc_error_message').hide();
                        $('#bloc_tiers').slideUp();
                        $("html, body").animate({scrollTop: 0}, 600);
                        return false;
                    });
                    $('#lost_password').click(function () {
                        var email = jQuery.trim($('#tiers_email').val());
                        $('#bloc_info_message').hide();
                        $('#bloc_login_message').hide();
                        if (isValidEmailAddress(email)) {
                            spinWaiting('#reservation_tiers_form', true);
                            $.post(base_route + "/_ajax/lostPassword/", {
                                email:
                                    email
                            }, function (data) {
                                if (data === 'true') {
                                    $('#bloc_info_message').html($('#personnal-data-identification-forgotten-password-confirmation-message-part-1').text() + ' ' + $('#tiers_email').val() + '. ' + $('#personnal-data-identification-forgotten-password-confirmation-message-part-2').text());
                                    $('#bloc_info_message').show();
                                } else {
                                    if (data === 'false') {
                                        if (parseInt($('#authentification-errors-display-mode').text()) === 1) {
                                            $('#bloc_login_message li').html('<span class="red"> ' + $('#personnal-data-error_message_no_account_found').text() + '</span>');
                                            $('.bloc_confirm').hide();
                                            $('#bloc_login_message').show();
                                        } else {
                                            var msg = $('#personnal-data-error_message_no_account_found').text();
                                            msg = msg.replace('######', $('#tiers_email').val() + '. ');
                                            $('.sent-message').html(msg).show();
                                            $('#bloc_login_message').hide();
                                        }
                                    } else {
                                        $('#bloc_login_message li').html('<span class="red"> ' + data + '</span>');
                                        $('.bloc_confirm').hide();
                                        $('#bloc_login_message').show();
                                    }
                                }
                            }).always(function (err) {
                                spinWaiting('#reservation_tiers_form', false);
                            });
                        } else {
                            $('#bloc_login_message li').html('<span class="red">' + $('#personnal-data-identification-error-message-email').text() + '</span>');
                            $('#bloc_login_message').show();
                        }
                        return false;
                    });

                    // saisie automatique google
                    try {
                        setGMapAutoCompleteOnInputField('tiers', '');
                        setGMapAutoCompleteOnInputField('tiers', '_conducteur');
                        setGMapAutoCompleteOnInputField('tiers', '_add');
                    } catch (e) {
                        // si module non activé
                    }

                    break;

                    // IMPORTANT! pas de break car on continue 'etapePaiement'

                case 'etapePaiementExterneDG':
                case 'etapePaiementExterne':
                case 'etapePaiement':

                    if (action_name === 'etapePaiement') {
                        $('#action-promo').click(function () {
                            showLoader();
                            var codePromotion = $('#code-promo').val();
                            var actionPromotion = $('#action-promo').attr("data-action");
                            $.post(base_route + "/_ajax/SetCodePromotionToReservation/", {
                                action_promotion: actionPromotion,
                                code_promotion: codePromotion
                            }).done(function (data) {
                                try {
                                    var obj;
                                    obj = jQuery.parseJSON(data);
                                } catch (e) {
                                    obj = {
                                        message: "Erreur json."
                                    }
                                }
                                $('#code-promo-error').text(obj.message);
                                if (obj.message !== '') {
                                    $('#code-promo').addClass("error");
                                    $('#code-promo-error').show();
                                    hideLoader();
                                } else {
                                    $('#code-promo').removeClass("error");
                                    $('#code-promo-error').hide();
                                    window.location.reload();
                                }
                            }).fail(function (data) {
                                alert('Fail');
                                $('#code-promo-error').text('Un incident a été détecté.').show();
                                window.location.reload();
                            }).always(function () {
                            })
                        });
                    }

                    $(window).resize(function () {
                        if ($(window).width() < 768) {
                            $('.big-popin').css('width', $(window).width() - 60);
                        }
                    });


                    if ($(window).width() > 992) {
                        attachFixedOnScroll($('.top-breadcrumb'), '-5px');
                    }

                    $('#form_reservation_paiement').submit(function () {
                        //On attribue le moyen de paiement au bouton submit

                        if ($('.card .option').hasClass('current')) {
                            return true;
                        } else {
                            hideLoader();
                            showModalSimple();
                            return false;
                        }
                    });

                    $('.card .option span').click(function () {
                        var $cardOption = $(this);

                        var numContrat = $("#reservation_numero_contrat").text();

                        if (action_name === 'etapePaiement') {
                            // Ajout ou suppression du produit DG par chèque
                            if ($cardOption.parent().parent().find('.autorisation.somme')) {
                                var price = $cardOption.parent().parent().find('.autorisation.somme');
                                var checked = false;

                                if ($('#dg-default-selection').attr('data-value') != '1' && (price.attr('data-value') == 0 || $cardOption.parent().parent().find('.autorisation').text() == 'Non autorisée')) {
                                    checked = true;
                                }

                                if ($.isNumeric($('#dg-id').attr('data-id-produit'))) {
                                    showLoader();
                                    $.post(base_route + "/_ajax/option/", {
                                        id_produit: $('#dg-id').attr('data-id-produit'),
                                        checked: checked
                                    }, function (data) {
                                        if (data == "badReservation") {
                                            showBadReservation();
                                            return false;
                                        }

                                        $.post(base_route + "/_ajax/reloadSidebar/", {}, function (data) {
                                            $('.panel-sidebar').html(data);
                                            if (typeof initSidebar == 'function') {
                                                initSidebar();
                                            }
                                        }).fail(function () {
                                            showLoader();
                                            window.location.reload();
                                        });

                                        selectPaymentCard(numContrat, $cardOption, 'Paiement');
                                    }).fail(function () {
                                        showLoader();
                                        window.location.reload();
                                    });
                                } else {
                                    selectPaymentCard(numContrat, $cardOption, 'Paiement');
                                }
                            }
                        } else if (action_name === 'etapePaiementExterne') {
                            selectPaymentCard(numContrat, $cardOption, 'PaiementExterne');
                        } else if (action_name === 'etapePaiementExterneDG') {
                            selectPaymentCard(numContrat, $cardOption, 'PaiementExterneDG');
                        }
                    });

                    $('.option span').click(function () {
                        // utile a SIPS-v1
                        $('#card_x').attr('name', $(this).attr('data-cardname') + '.x');
                        $('#card_y').attr('name', $(this).attr('data-cardname') + '.y');
                    })
                    $('a.cancel').click(function () {
                        $("#dialog-modal-modification").dialog('close');
                    });
                    $('#img_paiement').click(function () {
                        if ($('.option.current').length == 0) {
                            $("#dialog-modal-simple").dialog({
                                height: "auto",
                                width: 400,
                                modal: true,
                                resizable: false,
                                closeOnEscape: true,
                                close: function () {
                                    $("body").css("overflow", "auto");
                                }
                            });
                            hideLoader();
                        } else {
                            if ($('.option.current').length > 0 && $('.option.current').parent().find('.autorisation.bad').length > 0) {
                                $("#dialog-modal-modification").dialog({
                                    height: "auto",
                                    width: 465,
                                    modal: true,
                                    resizable: false,
                                    closeOnEscape: true,
                                    close: function () {
                                        $("body").css("overflow", "auto");
                                    }
                                });
                                hideLoader();
                            } else {
                                if ($('.cgl-wrapper:visible').length != 0 && $('#cgl-check').length != 0 && $('#cgl-check:checked').length == 0) {
                                    $('.message.error_list.full-width-error').fadeIn();
                                    hideLoader();
                                } else {
                                    $(this).closest("form").submit();
                                    return false;
                                }
                            }
                        }
                    });

                    break;

                case 'etapeConfirmation':

                    //Responsivité de la popup d'enquête de satisfaction
                    $(window).resize(function () {
                        var popupAvis = $('.page-wizard-confirmation div[aria-describedby="dialog-modal-monkey-servey"]');

                        if ($(window).width() <= 600) {
                            popupAvis.css('width', '100% !important');
                            popupAvis.css('left', '0');

                            $('p.diag-commands a.previous, p.diag-commands a.next').css('width', '200px');
                            $('p.diag-commands').css('width', '250px');
                        } else {
                            popupAvis.css('width', '600px !important');
                            popupAvis.css('left', ($(window).width() / 2) - 300);
                            $('p.diag-commands').css('width', '475px');
                            $('p.diag-commands a.previous, p.diag-commands a.next').css('width', '223px');
                        }
                    });

                    if ($(window).width() > 992) {
                        attachFixedOnScroll($('.top-breadcrumb'), '-5px');
                    }

                    if ($('#dialog-modal-monkey-servey').length) {
                        $('#dialog-modal-monkey-servey').dialog({
                            height: "auto",
                            width: 600,
                            modal: true,
                            resizable: false,
                            closeOnEscape: true,
                            close: function () {
                                $("body").css("overflow", "auto");
                            }
                        });

                        if ($('#popup_close_button_display').attr('data-value') != '1') {
                            $('.page-wizard-confirmation .ui-dialog-titlebar-close').addClass('invisible');
                        }
                    }

                    $('#dialog-modal-monkey-servey a.next').click(function () {
                        $('#dialog-modal-monkey-servey').parent().hide();
                        $('.ui-widget-overlay').remove();
                        eval("window.open('" + $('#dialog-modal-monkey-servey').attr('data-url-action') + "', 'surveywindow', 'height=650,width=850,scrollbars=yes,resizable=yes,status=yes')");
                    });

                    $('#dialog-modal-monkey-servey a.previous').click(function () {
                        spinWaiting('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable', true);
                        $.ajax({
                            url: base_route + "/_ajax/sendEmailForSurvey/",
                            type: "POST",
                            data: {
                                num_contrat: $('#num-contrat-value').text()
                            },
                            success: function (data) {
                                spinWaiting('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable', false);
                                $('#dialog-modal-monkey-servey p:not(.commands)').remove();
                                $('#dialog-modal-monkey-servey').prepend(html_entity_decode(html_entity_decode(data)));
                                $('#dialog-modal-monkey-servey a').remove();
                                $('.page-wizard-confirmation .ui-dialog-titlebar-close').attr('style', 'display:block;');
                                $('.page-wizard-confirmation .ui-dialog.ui-widget.ui-widget-content').addClass('email-msg');
                            },
                            error: function (data) {
                                spinWaiting('.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-front.ui-draggable', false);
                                $('#dialog-modal-monkey-servey p:not(.commands)').remove();
                                $('#dialog-modal-monkey-servey a').remove();
                                $('#dialog-modal-monkey-servey').parent().hide();
                                $('.ui-widget-overlay').remove();
                            }
                        })
                    });
                    break;
            }
            break;

        case 'mon_compte':


            //Modalbox de modification
            $('.modal_modification').click(function (e) {
                var idContrat = $(this).attr('rel');
                e.stopPropagation();
                e.preventDefault();
                $("#dialog-modal-modification-" + idContrat + "[rel=" + idContrat + "]").dialog({
                    height: "auto",
                    width: 600,
                    modal: true,
                    resizable: false,
                    closeOnEscape: true,
                    close: function () {
                        $("body").css("overflow", "auto");
                    }
                });
            });

            //Modalbox d'annulation
            $('.modal_annulation').click(function (e) {
                e.stopPropagation();
                e.preventDefault();
                var idContrat = $(this).attr('rel');
                $("#dialog-modal-annulation-" + idContrat + "[rel=" + idContrat + "]").dialog({
                    height: "auto",
                    width: 600,
                    modal: true,
                    resizable: false,
                    closeOnEscape: true,
                    close: function () {
                        $("body").css("overflow", "auto");
                    }
                });
            });

            if ($("body.page-account.reservations").length) {
                showLoader();
                $.post(base_route + "/_ajax/myBookingsReservations/", {
                }).done(function (data) {
                    if (data) {
                        $('table.reservations-list tbody').html(data);
                        hideLoader();
                        setTimeout(function () {
                            $('table.reservations-list').fadeIn();

                            //Espace mon compte, liste des réservations, click sur boutons annuler et modifier
                            $('a.modifier, a.annuler').click(function (e) {

                                var selector = '';
                                if ($(this).hasClass('modifier')) {
                                    selector = 'div[id^="dialog-modal-modification"]';
                                } else {
                                    selector = 'div[id^="dialog-modal-annulation"]';
                                }

                                e.stopPropagation();
                                e.preventDefault();
                                $("body").css("overflow", "hidden");
                                $(selector).dialog({
                                    height: "auto",
                                    width: 600,
                                    modal: true,
                                    resizable: false,
                                    closeOnEscape: true,
                                    close: function () {
                                        $("body").css("overflow", "auto");
                                    }
                                });
                            });
                            bindLoader();
                        }, 600);
                    }
                }).fail(function () {
                    hideLoader();
                });
            }

            if ($("body.page-account.main").length) {
                showLoader();
                var globalData = '';
                $.post(base_route + "/_ajax/myBookingsCount/", {
                }).done(function (countingData) {
                    var nb = parseInt(countingData);
                    console.log(nb);
                    if (nb < 6) {
                        $.post(base_route + "/_ajax/myBookingsMain/", {
                        }).done(function (data) {
                            if (data) {
                                $('table.reservations-list tbody').html(data);
                                hideLoader();
                                setTimeout(function () {
                                    $('table.reservations-list').fadeIn();
                                }, 600);
                            }
                        }).fail(function () {
                            hideLoader();
                        });
                    } else {
                        var callsCount = Math.floor(nb / 5);
                        if (nb % 5 !== 0) {
                            callsCount++;
                        }
                        $('#calls-count-remaining').text(callsCount);
                        var offset = 1;
                        for (var index = 1; index <= callsCount; index++) {
                            if (index > 1) {
                                offset = (index - 1) * 5 +  1;
                            }
                            $.post(base_route + "/_ajax/myBookingsMainSubPart/", { offset: offset
                            }).done(function (subPartData) {
                                $('#calls-count-remaining').text(
                                    parseInt($('#calls-count-remaining').text()) - 1
                                );
                                if (subPartData) {
                                    globalData = globalData + subPartData;
                                    if (parseInt($('#calls-count-remaining').text()) <= 0) {
                                        $('table.reservations-list tbody').html(globalData);
                                        hideLoader();
                                        setTimeout(function () {
                                            $('table.reservations-list').fadeIn();
                                        }, 600);
                                    }
                                } else {
                                    if (parseInt($('#calls-count-remaining').text()) <= 0) {
                                        $('table.reservations-list tbody').html(globalData);
                                        hideLoader();
                                        setTimeout(function () {
                                            $('table.reservations-list').fadeIn();
                                        }, 600);
                                    }
                                }
                            }).fail(function () {
                                hideLoader();
                            });
                        }
                    }
                }).fail(function () {
                    hideLoader();
                });
            }

            // saisie automatique google

            try {
                // var input = document.getElementById('adresse');
                var input = $('#adresse.gmap_place_autocomplete')[0];

                if (input !== undefined) {
                    var options = {
                        types: ['address']
                    };

                    var autocomplete = new google.maps.places.Autocomplete(input, options);

                    autocomplete.addListener('place_changed', function () {
                        var place = autocomplete.getPlace();
                        var infos = {
                            street_number: "",
                            route: "",
                            administrative_area_level_1: "",
                            administrative_area_level_2: "",
                            postal_code: "",
                            locality: "",
                            country: ""
                        };
                        for (var i = 0; i < place.address_components.length; i++) {
                            var field = place.address_components[i];
                            var fieldName = field.types[0];
                            var val = field.long_name;
                            infos[fieldName] = val;
                        }
                        $('#adresse').val(infos.street_number + " " + infos.route);
                        $('#adresse2').val("");
                        $('#code_postal').val(infos.postal_code);
                        $('#ville').val(infos.locality);
                        $('#pays').val(infos.country);
                    });
                }
            } catch (e) {
                // si module non activé
            }

            break;

        case 'circuits':

            switch (action_name) {
                case 'fiche':

                    //Reset du formulaire de réservation
                    $('.popin-top a.reset').click(function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        $('li.package.starting-price input.input-quantity').val('1');
                        $('span.total-price span').text($('span.total-price').attr('data-starting-price'));

                        $.post($('#base_route').val() + "/_ajax/amountTransform/", {number: $('span.total-price').attr('data-starting-price')}, function (data) {
                            var obj = jQuery.parseJSON(data);
                            $('span.total-price span').text(html_entity_decode(obj.result) + '');
                        }).fail(function () {
                        });

                        $('li.package input.input-quantity').val('0');
                    });

                    break;

                case 'home':

                    $('a.circuit-type-link').click(function (e) {

                        e.stopPropagation();
                        e.preventDefault();

                        if ($(this).attr('data-id-type') != '') {
                            $('input[name="id-type-circuit"]').val($(this).attr('data-id-type'));
                            $('#search-form-type-circuit').submit();
                        }
                    });

                    break;
            }
            break;

        case 'evenements':


        case 'promotions':

            var chrome = /chrome/.test(navigator.userAgent.toLowerCase());
            var safari = /safari/.test(navigator.userAgent.toLowerCase());
            var position = '';
            position = '1120px';

            $(window).resize(function () {

                if ($(window).width() > 992) {
                    $('.additional-options').removeAttr('style');
                    $('#vehicle-searchform').removeAttr('style');
                    $('#vehicle-search').removeAttr('style');
                }

                if ($(window).width() < 992) {
                    $('.additional-options').css('width', $('#vehicle-search').width() + 'px');
                    $('.additional-options').css('top', '1180px');
                }

                if ($(window).width() <= 768 && $(window).width() > 490) {
                    if ($('#moar-checkbox:checked').length) {
                        if ($(window).width() == 768) {
                            $('.additional-options').css('top', '1180px');
                        } else {
                            $('.additional-options').css('top', '1120px');
                        }
                        $('#vehicle-search').css('height', '530px');
                        $('#vehicle-searchform').css('height', '530px');
                        $('#boutonValider').css('top', '42%');
                    }
                }

                if ($(window).width() < 490 && $('#vehicle-search').length && $('.vehicle-searchform-ctn').length) {
                    var pos = $('#vehicle-search').offset();
                    $('.additional-options').css('top', ($('.vehicle-searchform-ctn').height() + pos.top + 15) + 'px');
                }

                if ($(window).width() < 483) {
                    if ($('#moar-checkbox:checked').length) {
                        $('#vehicle-search').css('height', '584px');
                        $('#vehicle-searchform').css('height', '592px');
                        $('#boutonValider').css('top', '49%');
                    }
                }
            });

            $('#heure_depart.error').parent().find('#heure_depart-button').addClass('error');
            $('#heure_retour.error').parent().find('#heure_retour-button').addClass('error');

            if ($('#heure_depart-button.error').legnth && $('#heure_depart.error').length == 0) {
                $('#heure_depart-button.error').removeClass('error');
            }

            if ($('#heure_retour-button.error').legnth && $('#heure_retour.error').length == 0) {
                $('#heure_retour-button.error').removeClass('error');
            }

            if ($('#kilometres.error').length) {
                $('#kilometres.error').val($('#kilometres.error').attr('data-error-value'));
            }


            if ($('#drivers-age.error').length) {
                $('#drivers-age-button').addClass('error');
                $('#drivers-age-button.error').val($('#drivers-age.error').attr('data-error-value'));
            }

            if ($('#licence-age.error').length) {
                $('#licence-age-button').addClass('error');
                $('#licence-age-button.error').val($('#licence-age.error').attr('data-error-value'));
            }

            reservationFormALinkBehaviourManagement();
            reservationFormTimeBehaviourManagement();

            $('.select-agency li').hover(function () {
                var idAgence = $(this).attr('id').replace(/\D+/, '');
                $('div[id^="agency-info-"]').removeAttr('style');
                $('div[id="agency-info-' + idAgence + '"]').attr('style', 'z-index: 10;')
            });

            oneWayTripManagement(action_name);

            //Désactivation de la sélection des zones comme agence de retour :
            $('.col-2 .location-content ul li a[rel^="z"], .col-2 .location-content ul li a[rel^="ao"]').each(function () {
                $(this).attr('style', 'font-weight:bold;pointer-events:none;');
            });

            if ($('*[data-error-value]').length) {
                $('.select-button.code-promo.arrow-button').trigger('click');
            }


            $('li a.promo-type-selector').click(function (e) {
                e.stopPropagation();
                e.preventDefault();
                showLoader();
                var href = $(this).attr('href');
                window.location = href;
            });

            if ($('#scroll-to-form').text() == '1') {
                $('button.select-button.arrow-button').trigger('click');
            }

            if ($('#promotion-menu-preselect').text() != '' && $('#promotion-menu-preselect').text() != 0 &&
                $('.vehicle-type-tabs ul li a.active').length == 0
                ) {
                $('.vehicle-type-tabs ul li[data-id="' + $('#promotion-menu-preselect').text() + '"] a').addClass('active');
            }

            //Pré-sélection de l'onglet de type de véhicule en fonction de l'onglet sélectionné au niveau du formulaire,
            // si affichage des onglets activé ET si nombre de types à affiché supérieur à 1
            if ($('ul.vehicle-searchform-tabs').length == 0) {
                $('span.ui-selectmenu-button[aria-owns="vehicle-type-menu"]').click(function () {
                    var arrTypesLabels = $('#type-urls-list').text().split(',');
                    $('#vehicle-type-menu li').each(function () {
                        if (arrTypesLabels.indexOf($(this).text().toLowerCase()) != -1) {
                            $(this).addClass('item-emphasis');
                        } else {
                            $(this).addClass('indentation');
                        }
                    });
                });
            }

            break;

        case 'faq':

            break;
        case 'vehicules':

            setFormDepartureArrival();

            if ($('div.sidebar').length) {
                function ajustePositionSideBarVehicules(offset)
                {
                    var $window = $(window);
                    var $sidebar = $('div.sidebar');
                    var $contenu = $('div.sidebar_reference');
                    var $container = $sidebar.parent();
                    var $blocvide = $('div.bloc_vide_actif');

                    var ecart = Math.max(($window.scrollTop() + offset - $container.offset().top), 0);  // calcule le debut de la zone non fixe
                    var maxi = Math.max(($contenu.height() - $sidebar.height()), 0); // taille de la zone de glisse
                    $blocvide.css("height", Math.min(ecart, maxi));

                }

                //initialisation de la page

                ajustePositionSideBarVehicules(30);

                //gestion du scroll de la page

                $(window).scroll(function () {
                    ajustePositionSideBarVehicules(30);
                });

                //gestion du resize de la page

                $(window).resize(function () {
                    ajustePositionSideBarVehicules(30);
                });
            }
            $('a.my-demand').click(function () {
                if ($(this).hasClass('open')) {
                    $('.loc-search-edit').fadeIn('slow');
                    $('#vehicle-searchform').toggleClass('invisible', false);
                } else {
                    $('.loc-search-edit').fadeOut('slow');
                    $('#vehicle-searchform').toggleClass('invisible', true);
                }
                $('.loc-search-edit').each(function () {
                    modifieEntetesFixesEtFlottants();
                });
            });

            if ($(".select-button.form-activated").length) {
                $(".select-button.form-activated").click(function () {

                    if ($('#spinner-script-url').text() != '') {
                        loadJS($('#spinner-script-url').text());
                    }

                    $.post(base_route + "/_ajax/resetInstance/", {
                    }, function (data) {
                    });

                    $(this).parent().attr('action', '#');
                    $(".select-button.form-activated.invisible").fadeIn('slow').removeClass('invisible');
                    $("html, body").animate({scrollTop: 0}, 'slow');
                    $('a.my-demand').removeClass('invisible');
                    $('.top-form-controls').removeClass('invisible');
                    $('#vehicle-searchform, .loc-search.loc-search-edit').fadeIn('slow').removeClass('invisible');
                    $('select[name="id_categorie_vehicules"] option').removeAttr('selected');
                    $('select[name="id_categorie_vehicules"] option[value="' + $(this).attr('data-id-categorie-vehicule') + '"]').attr('selected', 'selected');
                    if ($(this).hasClass('must-disappear')) {
                        $(this).addClass('invisible').fadeOut('slow');
                    }
                });
            }

            break;

        case 'agences':
            switch (action_name) {
                case 'list':

                case 'fiche':

                    $('a.button.inverted.smooth').click(function () {
                        var o = $('a#vehicules-anchor').offset();
                        $("html, body").animate({scrollTop: o.top}, 800);
                    });
                    $('a.avis.smooth').click(function () {
                        var o = $('a#avis-des-clients').offset();
                        $("html, body").animate({scrollTop: o.top}, 800);
                    });

                    $('.bloc-expand .title-little').click(function () {
                        $(this).next('.bloc-content').slideToggle();
                        $(this).parent().toggleClass('open');
                    });

                    $('button.route').click(function () {
                        window.open($(this).attr('data-url'), '_blank', 'height=800,width=1000,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no,directories=no, status=yes');
                    });

                    //Click sur un bouton réserver ici
                    $('button.rent.purple-submit').on('click', function () {


                        var parent = $(this).parent();

                        var inputDepart = parent.find('input[type="hidden"][name="id_agence_depart"]');
                        var inputRetour = parent.find('input[type="hidden"][name="id_agence_retour"]');

                        $.post(base_route + "/_ajax/setTargetAgencesIds/", {
                            id_agence_depart: inputDepart.val(),
                            id_agence_retour: inputRetour.val()
                        }, function (data) {
                        });

                    });
                    break;
            }
            break;
    }

    truncateFunc();

});


function isValidEmailAddress(emailAddress)
{
    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
}
;


function initSidebar()
{
    //Tooltip pour date de permis
//    $('.widget-content .more-infos').each(function () {
//        var primary_key = $(this).attr('rel');
//        var info = $('#infos_options_sidebar_' + primary_key).html();
//        $('#options_sidebar_' + primary_key).qtip({
//            content: info,
//            style: {
//                name: 'blue',
//                tip: 'bottomMiddle'
//            },
//            position: {
//                corner: {
//                    target: 'topMiddle',
//                    tooltip: 'bottomMiddle'
//                }
//            }
//        });
//    });

    //Tooltip pour l'agence
    agenceInfoTooltip('info_agence');
    agenceInfoTooltip('info_agence_retour');

    //Ouverture fermeture des onglets
    $('#sidebar .widget-expand').click(function () {
        if ($(this).hasClass('closed')) {
            $(this).next('.widget-content').slideDown();
            $(this).removeClass('closed');
            $(this).addClass('open');
        } else {
            $(this).next('.widget-content').slideUp();
            $(this).removeClass('open');
            $(this).addClass('closed');
        }

    });

    $('.current-demand .know-more').mouseenter(function () {
        $('.panel-sidebar').initSideBarMaps();
    });

}


function agenceInfoTooltip(idInfoPanel)
{
//    if ($('#' + idInfoPanel).length) {
//        var info = $('#' + idInfoPanel).html();
//        $('.' + idInfoPanel).qtip({
//            content: info,
//            style: {
//                name: 'light',
//                tip: 'bottomRight',
//                width: {
//                    max: 800
//                }
//            },
//            position: {
//                corner: {
//                    target: 'leftTop',
//                    tooltip: 'bottomRight'
//                }
//            }
//        });
//    }

}
;

function oneWayTripManagement(actionName)
{
    var base_route = $("#base_route").val();
    var aElemPath = ' ul.sbOptions li a';
    var preffix = '';

    if (actionName === 'etapeInfos') {
        preffix = '.location-time';
    } else if (actionName.substr(0, 11) === 'etapeTrajet') {
        preffix = '.location-content';
    }

    aElemPath = preffix + aElemPath;

    if ($('#id_agence_retour').val() === $('#id_agence_depart').val()) {
        $('#one_way_trip').attr('checked', 'checked');
        setTimeout(function () {
            departureEqualsReturn(actionName);
        }, 0);
    } else {
        setTimeout(function () {
            departureDifferentFromReturn(actionName);
        }, 50);
        manageDepatureAndReturnForOneWayTrip(aElemPath);
    }

    if ($('#img_return_same_agency').length) {
        var checkedValue = $(this).attr('value');
        var sbIdDepart = $('#id_agence_depart').attr('sb');
        var sbIdRetour = $('#id_agence_retour').attr('sb');

        $('#id_agence_retour option[value=' + checkedValue + ']').attr('selected', 'selected');
        var $selectionText = $('#sbSelector_' + sbIdDepart).text();
        $('#sbSelector_' + sbIdRetour).text($selectionText);
    }


    $('#id_agence_retour').change(function () {
        if ($(this).val() == $('#id_agence_depart').val()) {
            $('#one_way_trip').attr('checked', 'checked');
            departureEqualsReturn(actionName);
            $(preffix + ' .col-2 p.form-line:nth-child(3)').fadeOut();

            $.post(base_route + "/_ajax/allowedForOneWayTrip/", {
                // id_depart:
                // id_retour:
            }, function (data) {

                var idsAgences = data.split(',');

                $(aElemPath).each(function () {
                    $(this).removeClass('invisible');
                });
            });
        } else {
            $('#one_way_trip').removeAttr('checked');
        }
        refreshDates('agence_retour');
    });

    $('#id_agence_depart').change(function () {

        if ($('#one_way_trip').is(':checked') || $('#img_return_same_agency').length) {
            var checkedValue = $(this).attr('value');
            var sbIdDepart = $('#id_agence_depart').attr('sb');
            var sbIdRetour = $('#id_agence_retour').attr('sb');

            $('#id_agence_retour option[value=' + checkedValue + ']').attr('selected', 'selected');
            var selectionText = $('#sbSelector_' + sbIdDepart).text();
            $('#sbSelector_' + sbIdRetour).text(selectionText);
        }
        if ($(this).val() == $('#id_agence_retour').val()) {
            $('#one_way_trip').attr('checked', 'checked');
            $('span.error').each(function () {
                if ($(this).text() == 'Veuillez sélectionner une agence de retour') {
                    $(this).attr('style', 'display:none;');
                }
            });
            setTimeout(function () {
                departureEqualsReturn(actionName);
            }, 500);

            $.post(base_route + "/_ajax/allowedForOneWayTrip/", {
            }, function (data) {

                var idsAgences = data.split(',');

                $(aElemPath).each(function () {
                    $(this).removeClass('invisible');
                });
            });
        }
        refreshDates('agence_depart');
    });

    $('#one_way_trip').click(function () {

        $('.location-time .col-2 a.sbToggle').removeAttr('style');
        $('.location-time .col-2 a.sbSelector').removeAttr('style');

        if ($(this).is(':checked')) {
            departureEqualsReturn(actionName);

            $.post(base_route + "/_ajax/allowedForOneWayTrip/", {
                id_agence_depart: $('#id_agence_depart').val(),
                id_agence_retour: $('#id_agence_retour').val()
            }, function (data) {

                var idsAgences = data.split(',');

                $(aElemPath).each(function () {
                    $(this).removeClass('invisible');
                });
            });

            var checkedText = '';
            var checkedValue = '';

            $('span.error').each(function () {
                if ($(this).text() == 'Veuillez sélectionner une agence de retour') {
                    $(this).attr('style', 'display:none;');
                }
            });

            $('#id_agence_depart option').each(function () {
                if ($(this).is(':checked')) {
                    checkedText = $(this).text();
                    checkedValue = $(this).attr('value');
                }
            });

            $('#id_agence_retour option[selected="selected"]').removeAttr('selected');
            $('#id_agence_retour').val(checkedValue);

            var sbIdDepart = $('#id_agence_depart').attr('sb');
            var sbIdRetour = $('#id_agence_retour').attr('sb');

            selectionText = $('#sbSelector_' + sbIdDepart).text();
            $('#sbSelector_' + sbIdRetour).text(selectionText);
        } else {
            departureDifferentFromReturn(actionName);
            manageDepatureAndReturnForOneWayTrip(aElemPath);
        }

        refreshDates('agence_retour');
    });
}

function manageDepatureAndReturnForOneWayTrip(aElemPath)
{
    var base_route = $("#base_route").val();

    $.post(base_route + "/_ajax/allowedForOneWayTrip/", {
    }, function (data) {

        var elems = data.split('|');
        var idsAgences = elems[0];
        idsAgences = idsAgences.split(',');
        var idsZones = elems[1];
        idsZones = idsZones.split(',');

        var regAgence = new RegExp('am');
        var regZone = new RegExp('ao|z');

        $(aElemPath).each(function () {

            var rel = $(this).attr('rel');

            if (rel.substr(0, 2) == 'am') {
                var id = rel.replace(regAgence, '');
                if (jQuery.inArray(id, idsAgences) != -1) {
                    $(this).addClass('invisible');
                }
            }

            if (rel.substr(0, 2) == 'ao' || rel.substr(0, 1) == 'z') {
                var id = rel.replace(regZone, '');
                if (jQuery.inArray(id, idsZones) == -1) {
                    $(this).addClass('invisible');
                }
            }
        });

    });
}

function manageOWTComboBoxesDefaultValue(widget)
{
    var selectionText = 'Sélectionnez votre agence';
    var sbId = $('#id_agence_' + widget).attr('sb');

    $('#id_agence_' + widget + ' option[selected="selected"]').removeAttr('selected');
    $('#id_agence_' + widget).val('');
    $('#sbSelector_' + sbId).text(selectionText);
}

function manageComboboxesErrorState(widget)
{
    var suffix = '', colIndex = 1;
    var styleSelector = 'background-color:#FFC4C4;border-top:1px solid #D85656;border-bottom:1px solid #D85656;border-left:1px solid #D85656;';
    var styleToggler = 'background-color:#FFC4C4;border:1px solid #D85656;';

    if (widget == 'retour') {
        suffix = 'Retour';
        colIndex = 2;
    }

    if ($('#date_' + widget).attr('style') !== undefined ||
        $('#reservation_form .location-time .col-' + colIndex + ' span.error').length ||
        $('#reservation_form .location-content .col-' + colIndex + ' span.error').length) {
        $('#date_' + widget).attr('style', '');
        $('#heure_' + widget).attr('style', '');
        $('.location-time .col-' + colIndex + ' .sbHolderAgence' + suffix + ' a.sbToggle, .location-content .col-' + colIndex + ' .sbHolderAgence' + suffix + ' a.sbToggle').attr('style', styleToggler);
        $('.location-time .col-' + colIndex + ' .sbHolderAgence' + suffix + ' a.sbSelector, .location-content .col-' + colIndex + ' .sbHolderAgence' + suffix + ' a.sbSelector').attr('style', styleSelector);
    }

    var prefix = '';

    if ($('#action_name').val() == 'etapeInfos' || $('#action_name').val() == 'fiche') {
        colIndex = 1;
        prefix = '.location-vehicules';
    } else {
        colIndex = 3;
        prefix = '.location-content';
    }

    if ($('#reservation_form ' + prefix + ' .col-' + colIndex + ' span.error').length) {
        $(prefix + ' .col-' + colIndex + ' .sbHolderCategorie a.sbToggle').attr('style', styleToggler);
        $(prefix + ' .col-' + colIndex + ' .sbHolderCategorie a.sbSelector').attr('style', styleSelector);
    }
}

function departureDifferentFromReturn(etapeLabel)
{
    if (etapeLabel == 'etapeInfos' || etapeLabel == 'fiche') {
        $('.location-time .col-2 .location-content p.form-line:nth-child(1)').fadeIn();
        $('#return_same_agency').removeClass('departure-equals-return');
        $('.location-time .col-2 .location-content p.form-line:nth-last-child(1)').addClass('departure-not-equals-return-time').removeClass('departure-equals-return-time');
        $(' .col-1 .location-content p.form-line:nth-last-child(1)').addClass('col1-departure-not-equals-return-time');
        $('.location-vehicules .col-1 .location-content p.form-line:nth-last-child(1)').removeClass('col1-departure-not-equals-return-time');
        $('.location-vehicules .col-1').addClass('lv-departure-not-equals-return-time');
        $('.location-vehicules .col-2').addClass('lv-departure-not-equals-return-time');
        $('form .location-validation').attr('style', 'height: 38px;');
    } else {
        if (etapeLabel == 'etapeTrajet' || etapeLabel == 'etapeTrajetAgences') {
            $('.location-content .col-2 p.form-line:nth-child(3)').fadeIn();
        }
    }
}

function departureEqualsReturn(etapeLabel)
{
    if (etapeLabel == 'etapeInfos' || etapeLabel == 'fiche') {
        $('.location-time .col-1 .location-content p.form-line:nth-last-child(1)').removeClass('col1-departure-not-equals-return-time').removeClass('col1-departure-equals-return-time');
        $('#return_same_agency').addClass('departure-equals-return');
        $('.location-time .col-2 .location-content p.form-line:nth-child(1)').fadeOut();
        $('.location-vehicules .col-1').removeClass('lv-departure-not-equals-return-time');
        $('.location-vehicules .col-2').removeClass('lv-departure-not-equals-return-time');
        $('form .location-validation').removeAttr('style');
    } else {
        if (etapeLabel == 'etapeTrajet' || etapeLabel == 'etapeTrajetAgences') {
            $('.location-content .col-2 p.form-line:nth-child(3)').fadeOut();
        }
    }
}

function launchDispoSearch(obj, actionName, baseRoute, idCat, kms, listIdsCats)
{
    var idElement = obj.attr('id');
    var defaultKmmode = $('div.vehicle-list').data('default-kmmode');
    var defaultTypeTarif = $('div.vehicle-list').data('default-typetarif');

    if (actionName === 'etapeTrajetAgences') {
        var idElementRetour = obj.attr('relreturn');
        rechercheDispo(idElement, idElementRetour, true, baseRoute, idCat, defaultTypeTarif, defaultKmmode, kms, listIdsCats, false);
    } else {
        if ($('select.moyenne-duree').length == 0) {
            rechercheDispo(idElement, null, false, baseRoute, idCat, defaultTypeTarif, defaultKmmode, kms, listIdsCats, false);
        }
    }
}

function setGlobalLoadingSate()
{
    $(".vehicles-types .vehicles-category-type .tarif_proposition").each(function () {
        $(this).html('<div class="center"><img src="' + $('#loader-path').text() + '"></div>');
    });
}

function html_entity_decode(string, quoteStyle)
{
    // http://kevin.vanzonneveld.net
    // +   original by: john (http://www.jd-tech.net)
    // +      input by: ger
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: Onno Marsman
    // +   improved by: marc andreu
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      input by: Ratheous
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Nick Kolosov (http://sammy.ru)
    // +   bugfixed by: Fox
    // -    depends on: get_html_translation_table
    // *     example 1: html_entity_decode('Kevin &amp; van Zonneveld');
    // *     returns 1: 'Kevin & van Zonneveld'
    // *     example 2: html_entity_decode('&amp;lt;');
    // *     returns 2: '&lt;'
    var hash_map = {},
        symbol = '',
        tmp_str = '',
        entity = '';
    tmp_str = string.toString();

    if (false === (hash_map = this.get_html_translation_table('HTML_ENTITIES', quoteStyle))) {
        return false;
    }

    // fix &amp; problem
    // http://phpjs.org/functions/get_html_translation_table:416#comment_97660
    delete(hash_map['&']);
    hash_map['&'] = '&amp;';

    for (symbol in hash_map) {
        entity = hash_map[symbol];
        tmp_str = tmp_str.split(entity).join(symbol);
    }
    tmp_str = tmp_str.split('&#039;').join("'");

    return tmp_str;
}

function get_html_translation_table(table, quoteStyle)
{
    // http://kevin.vanzonneveld.net
    // +   original by: Philip Peterson
    // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: noname
    // +   bugfixed by: Alex
    // +   bugfixed by: Marco
    // +   bugfixed by: madipta
    // +   improved by: KELAN
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Frank Forte
    // +   bugfixed by: T.Wild
    // +      input by: Ratheous
    // %          note: It has been decided that we're not going to add global
    // %          note: dependencies to php.js, meaning the constants are not
    // %          note: real constants, but strings instead. Integers are also supported if someone
    // %          note: chooses to create the constants themselves.
    // *     example 1: get_html_translation_table('HTML_SPECIALCHARS');
    // *     returns 1: {'"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;'}
    var entities = {},
        hash_map = {},
        decimal;
    var constMappingTable = {},
        constMappingQuoteStyle = {};
    var useTable = {},
        useQuoteStyle = {};

    // Translate arguments
    constMappingTable[0] = 'HTML_SPECIALCHARS';
    constMappingTable[1] = 'HTML_ENTITIES';
    constMappingQuoteStyle[0] = 'ENT_NOQUOTES';
    constMappingQuoteStyle[2] = 'ENT_COMPAT';
    constMappingQuoteStyle[3] = 'ENT_QUOTES';

    var elseXpr = quoteStyle ? quoteStyle.toUpperCase() : 'ENT_COMPAT';
    useTable = !isNaN(table) ? constMappingTable[table] : table ? table.toUpperCase() : 'HTML_SPECIALCHARS';
    useQuoteStyle = !isNaN(quoteStyle) ? constMappingQuoteStyle[quoteStyle] : elseXpr;

    if (useTable !== 'HTML_SPECIALCHARS' && useTable !== 'HTML_ENTITIES') {
        throw new Error("Table: " + useTable + ' not supported');
    }

    entities['38'] = '&amp;';
    if (useTable === 'HTML_ENTITIES') {
        entities['160'] = '&nbsp;';
        entities['161'] = '&iexcl;';
        entities['162'] = '&cent;';
        entities['163'] = '&pound;';
        entities['164'] = '&curren;';
        entities['165'] = '&yen;';
        entities['166'] = '&brvbar;';
        entities['167'] = '&sect;';
        entities['168'] = '&uml;';
        entities['169'] = '&copy;';
        entities['170'] = '&ordf;';
        entities['171'] = '&laquo;';
        entities['172'] = '&not;';
        entities['173'] = '&shy;';
        entities['174'] = '&reg;';
        entities['175'] = '&macr;';
        entities['176'] = '&deg;';
        entities['177'] = '&plusmn;';
        entities['178'] = '&sup2;';
        entities['179'] = '&sup3;';
        entities['180'] = '&acute;';
        entities['181'] = '&micro;';
        entities['182'] = '&para;';
        entities['183'] = '&middot;';
        entities['184'] = '&cedil;';
        entities['185'] = '&sup1;';
        entities['186'] = '&ordm;';
        entities['187'] = '&raquo;';
        entities['188'] = '&frac14;';
        entities['189'] = '&frac12;';
        entities['190'] = '&frac34;';
        entities['191'] = '&iquest;';
        entities['192'] = '&Agrave;';
        entities['193'] = '&Aacute;';
        entities['194'] = '&Acirc;';
        entities['195'] = '&Atilde;';
        entities['196'] = '&Auml;';
        entities['197'] = '&Aring;';
        entities['198'] = '&AElig;';
        entities['199'] = '&Ccedil;';
        entities['200'] = '&Egrave;';
        entities['201'] = '&Eacute;';
        entities['202'] = '&Ecirc;';
        entities['203'] = '&Euml;';
        entities['204'] = '&Igrave;';
        entities['205'] = '&Iacute;';
        entities['206'] = '&Icirc;';
        entities['207'] = '&Iuml;';
        entities['208'] = '&ETH;';
        entities['209'] = '&Ntilde;';
        entities['210'] = '&Ograve;';
        entities['211'] = '&Oacute;';
        entities['212'] = '&Ocirc;';
        entities['213'] = '&Otilde;';
        entities['214'] = '&Ouml;';
        entities['215'] = '&times;';
        entities['216'] = '&Oslash;';
        entities['217'] = '&Ugrave;';
        entities['218'] = '&Uacute;';
        entities['219'] = '&Ucirc;';
        entities['220'] = '&Uuml;';
        entities['221'] = '&Yacute;';
        entities['222'] = '&THORN;';
        entities['223'] = '&szlig;';
        entities['224'] = '&agrave;';
        entities['225'] = '&aacute;';
        entities['226'] = '&acirc;';
        entities['227'] = '&atilde;';
        entities['228'] = '&auml;';
        entities['229'] = '&aring;';
        entities['230'] = '&aelig;';
        entities['231'] = '&ccedil;';
        entities['232'] = '&egrave;';
        entities['233'] = '&eacute;';
        entities['234'] = '&ecirc;';
        entities['235'] = '&euml;';
        entities['236'] = '&igrave;';
        entities['237'] = '&iacute;';
        entities['238'] = '&icirc;';
        entities['239'] = '&iuml;';
        entities['240'] = '&eth;';
        entities['241'] = '&ntilde;';
        entities['242'] = '&ograve;';
        entities['243'] = '&oacute;';
        entities['244'] = '&ocirc;';
        entities['245'] = '&otilde;';
        entities['246'] = '&ouml;';
        entities['247'] = '&divide;';
        entities['248'] = '&oslash;';
        entities['249'] = '&ugrave;';
        entities['250'] = '&uacute;';
        entities['251'] = '&ucirc;';
        entities['252'] = '&uuml;';
        entities['253'] = '&yacute;';
        entities['254'] = '&thorn;';
        entities['255'] = '&yuml;';
    }

    if (useQuoteStyle !== 'ENT_NOQUOTES') {
        entities['34'] = '&quot;';
    }
    if (useQuoteStyle === 'ENT_QUOTES') {
        entities['39'] = '&#39;';
    }
    entities['60'] = '&lt;';
    entities['62'] = '&gt;';


    // ascii decimals to real symbols
    for (decimal in entities) {
        if (entities.hasOwnProperty(decimal)) {
            hash_map[String.fromCharCode(decimal)] = entities[decimal];
        }
    }

    return hash_map;
}

function setFormDepartureArrival()
{

    if ($('#id_agence_depart option[selected="selected"]').text() !== '') {
        $('.input-departure .agency-value').text($('#id_agence_depart option[selected="selected"]').text());
    }
    if ($('#id_agence_retour option[selected="selected"]').text() !== '') {
        $('.input-arrival .agency-value').text($('#id_agence_retour option[selected="selected"]').text());
    }
    if ($('.input-departure').attr('data-error-value') !== undefined) {
        $('.input-departure span.agency-value').css('color', 'red').text($('.input-departure').attr('data-error-value'));
    }
    if ($('.input-arrival').attr('data-error-value') !== undefined) {
        $('.input-arrival span.agency-value').css('color', 'red').text($('.input-arrival').attr('data-error-value'));
    }
    if ($('#heure_depart').attr('data-error-value') !== undefined) {
        $('#heure_depart-button span.ui-selectmenu-text').css('color', 'red').text($('#heure_depart').attr('data-error-value'));
    }
    if ($('#heure_retour').attr('data-error-value') !== undefined) {
        $('#heure_retour-button span.ui-selectmenu-text').css('color', 'red').text($('#heure_retour').attr('data-error-value'));
    }
    if ($('#date_depart').attr('data-error-value') !== undefined) {
        $('#date_depart').css('color', 'red').val($('#date_depart').attr('data-error-value'));
    }
    if ($('#date_retour').attr('data-error-value') !== undefined) {
        $('#date_retour').css('color', 'red').val($('#date_retour').attr('data-error-value'));
    }
    if ($('#vehicle-type').attr('data-error-value') != undefined) {
        $('#vehicle-type-button').addClass('error');
        $('#vehicle-type-button span.ui-selectmenu-text').text($('#vehicle-type').attr('data-error-value'));
    }

    if ($('#drivers-age.error').length) {
        $('#drivers-age-button').addClass('error');
        $('#drivers-age-button.error span.ui-selectmenu-text').css('color', 'red').text($('#drivers-age.error').attr('data-error-value'));
        $('#drivers-age-button.error').attr('title', $('#drivers-age.error').attr('data-error-value'));
    }

    if ($('#licence-age.error').length) {
        $('#licence-age-button').addClass('error');
        $('#licence-age-button.error span.ui-selectmenu-text').css('color', 'red').text($('#licence-age.error').attr('data-error-value'));
        $('#licence-age-button.error').attr('title', $('#licence-age.error').attr('data-error-value'));
    }
}

function moreInfosFunction()
{
    if ($(".vehicle-single .more-infos").data('events') != undefined && $(".vehicle-single .more-infos").data('events').click != undefined) {
        //do nothing as the click event is already there
    } else {
        $('.vehicle-single .more-infos').click(function (e) {
            e.preventDefault();
            $(this).toggleClass('open').closest('.vehicle-single').find('.vehicle-moar-info').toggle();
        });
    }

}

function attachFixedOnScroll(obj, hStart)
{
    var pos = obj.offset();

    if (obj.attr('data-state-fixed')) {
        $(window).scroll(function () {
            if ($(this).scrollTop() > pos.top && obj.hasClass('default')) {
                obj.fadeOut('fast', function () {
                    $(this).removeClass('default').addClass('fixed').fadeIn('fast');
                    obj.addClass('pos-top');

                    var totalHeight = 0;
                    $('.vehicle-single').each(function () {
                        totalHeight += $(this).height();
                    });
                });
            } else if ($(this).scrollTop() <= pos.top && obj.hasClass('fixed')) {
                obj.fadeOut('fast', function () {
                    $(this).removeClass('fixed').addClass('default').fadeIn('fast');
                    obj.removeClass('pos-top');
                });
            }
        });
    }
}

function enableProductCheckboxes()
{
    $('.option-checkbox span.know-more').each(function () {
        $(this).unbind('mouseenter').unbind('mouseleave');
        $(this).removeClass('clicked');
    });
    $('.option-checkbox span').removeAttr('class');
    $('.styled-checkbox span .tooltip').remove();

}

function enableContinueButton()
{
    $('.panel-actions span.next-wrapper').removeAttr('class').addClass('next-wrapper').unbind('mouseenter').unbind('mouseleave').find('a.next').addClass('loader').unbind('click');

    $('.panel-actions a.next').removeAttr('style');
    $('.panel-actions span.next-wrapper').attr('style', 'background-color:transparent;right:42px;z-index:0;');
    $('.panel-actions span.next-wrapper .tooltip').remove();
}

function disableContinueButton()
{
    var buttonWrapper = $('.panel-actions span.next-wrapper');

    if (!buttonWrapper.hasClass('know-more')) {
        buttonWrapper.addClass('know-more right').mouseenter(function (e) {
            if ($('#checkbox-tooltip-text').text()) {
                var tooltipBox = $('<div class="tooltip" style="left:130px">' +
                    '<p>' +
                    $('#checkbox-tooltip-text').text() +
                    '</p>' +
                    '</div>');

                if ($(window).width() > 768) {
                    tooltipBox.appendTo(buttonWrapper).show();
                    buttonWrapper.on('mouseleave', function () {
                        buttonWrapper.find('.tooltip').remove();
                    });
                }
            }
        });

        $('.panel-actions a.next').attr('style', 'pointer-events:none;');
        $('.panel-actions span.next-wrapper').attr('style', 'background-color:transparent;right:42px;z-index:1;width:' + $('.loader.next').width() + 'px;');
        $('.next-wrapper.know-more').attr('style', $('.next-wrapper.know-more').attr('style') + 'background:none;');
    }
}

function disableProductCheckboxes()
{

    $('.option-checkbox span').addClass('noclick');

    if ($('#checkbox-tooltip-activation').attr('data-value') == 1) {
        $('.option-checkbox span').addClass('know-more');

        $(".option-checkbox span.know-more").each(function () {
            $(this).mouseenter(function (e) {
                if ($('#checkbox-tooltip-text').text()) {
                    var tooltipBox = $('<div class="tooltip">' +
                        '<p>' +
                        $('#checkbox-tooltip-text').text() +
                        '</p>' +
                        '</div>');

                    tooltipBox.appendTo($(this)).show();
                    $(this).on('mouseleave', function () {
                        $(this).find('.tooltip').remove();
                    });
                }
            });
            $(this).click(function (e) {
                e.stopPropagation();
                e.preventDefault();
            });
        });
    }
}

function reservationFormALinkBehaviourManagement()
{
    $('li[id^="info_agence_depart"] a, li[id^="info_agence_depart"] a span').click(function (e) {
        e.preventDefault();
        $('.input-departure').removeAttr('style').removeClass('error');
        $('.input-departure span.agency-value').removeAttr('style');
    });

    $('li[id^="info_agence_retour"] a, li[id^="info_agence_retour"] a span').click(function (e) {
        e.preventDefault();
        $('.input-arrival').removeAttr('style').removeClass('error');
        $('.input-arrival span.agency-value').removeAttr('style');
    });

    $(window).click(function (e) {

        if ($('body.page-promo-list').length) {
            if ($(e.target).hasClass('ui-menu-item') && $(e.target).is('li') && $(e.target).parent().attr('id') == 'vehicle-type-menu') {
                $('#vehicle-type-button').removeClass('error').removeAttr('style');
            }

            if ($(e.target).hasClass('ui-menu-item') && $(e.target).is('li') && $(e.target).parent().attr('id') == 'drivers-age-menu') {
                $('#drivers-age-button').removeClass('error').removeAttr('style');
                $('#drivers-age-button .ui-selectmenu-text').removeAttr('style');
            }

            if ($(e.target).hasClass('ui-menu-item') && $(e.target).is('li') && $(e.target).parent().attr('id') == 'licence-age-menu') {
                $('#licence-age-button').removeClass('error').removeAttr('style');
                $('#licence-age-button .ui-selectmenu-text').removeAttr('style');
            }
        }
    });

    $(window).click(function (e) {
        if ($(e.target).hasClass('ui-menu-item') && $(e.target).is('li') && $(e.target).parent().attr('id') == 'vehicle-type-menu') {
            $('#vehicle-type-button').removeClass('error').removeAttr('style');
        }
    });
}

function getSearchButtonHeight()
{

    if ($('.vehicle-searchform-line .unused').length == 6) {
        return '92px;'
    } else {
        var departureMaxMsgHeight = 0, arrivalMaxMsgHeight = 0;
        if ($('.vehicle-searchform-line.error-departure-line .unused').length != 3) {
            $('.vehicle-searchform-line.error-departure-line:not(.unused) p.form-line').each(function () {
                if (departureMaxMsgHeight == 0 || departureMaxMsgHeight < $(this).height()) {
                    departureMaxMsgHeight = $(this).height();
                }
            });
        }
        if ($('.vehicle-searchform-line.error-arrival-line .unused').length != 3) {
            $('.vehicle-searchform-line.error-arrival-line:not(.unused) p.form-line').each(function () {
                if (arrivalMaxMsgHeight == 0 || arrivalMaxMsgHeight < $(this).height()) {
                    arrivalMaxMsgHeight = $(this).height();
                }
            });
        }
        return (departureMaxMsgHeight + arrivalMaxMsgHeight + $(".input-departure").height() + $(".input-arrival").height() + 24) + 'px';
    }
}

function reservationFormTimeBehaviourManagement()
{
    $(window).click(function (e) {
        if ($(e.target).hasClass('ui-menu-item') && !$(e.target).hasClass('ui-state-disabled')) {
            if ($(e.target).parent().attr('id') == 'heure_depart-menu') {
                $('.error-heure-depart').addClass('unused').html('');
                $('#heure_depart-button').css('background-color', 'white').css('border-color', 'white').removeClass('error');
                $('#heure_depart').removeClass('error').removeAttr('data-error-value');
                $('#heure_depart-button span.ui-selectmenu-text').removeAttr('style');
            }

            if ($(e.target).parent().attr('id') == 'heure_retour-menu') {
                $('.error-heure-retour').addClass('unused').html('');
                $('#heure_retour-button').css('background-color', 'white').css('border-color', 'white').removeClass('error');
                $('#heure_retour').removeClass('error').removeAttr('data-error-value');
                $('#heure_retour-button span.ui-selectmenu-text').removeAttr('style');
            }
        }
    });
}

function launchSlidersRoll()
{
    if (parseInt($('#sliders-roll-activation').text()) == 1) {
        var interval = setInterval(slidersRoll, parseInt($('#sliders-roll-timer').text()));
        setTimeout(function () {
            clearInterval(interval)
        }, 900000);
    }
}

function slidersRoll()
{
    var counter = parseInt($('#counter').attr('data-value'));

    var url = $('#sliders-images-set span[data-counter="' + counter + '"]').attr('data-value');
    var $opacity = $("#loc-search-opacity");
    var $contenerImage = $opacity.parent();


    if ($('#sliders-images-set span').length > 1) {
        $opacity.parent().css("position", "relative");
        $opacity.css({
            display: "block",
            position: "absolute",
            'background-color': "white",
            opacity: 0,
            top: 0,
            left: 0,
            height: $contenerImage.outerHeight() + "px",
            width: "100%",
            margin: 0,
            padding: 0
        });

        $opacity
            .animate({opacity: 1}, 1000, function () {
                $contenerImage.css({'background-image': "url('" + url + "')"});
            })
            .delay(100)
            .animate({opacity: 0}, {duration: 1500});

        if (counter == $('#sliders-images-set span').length) {
            $('#counter').attr('data-value', 1);
        } else {
            $('#counter').attr('data-value', parseInt($('#counter').attr('data-value')) + 1);
        }
    }
}

function bindLoader()
{
    $('.loader').click(function () {
        var message = '';
        if (this.hasAttribute('data-loader-message')) {
            message = $(this).attr('data-loader-message');
        }
        showLoader(message);
    });
}

function showLoader(message, allowEscape)
{
    if (allowEscape == undefined) {
        allowEscape = false;
    }
    if (message == '' || message == undefined) {
        if ($('#loader-default-msg').text() != '') {
            message = $('#loader-default-msg').text();
        } else {
            message = 'Chargement en cours...';
        }
    }
    $('section#loader span').text(message);
    $('section#loader').fadeIn();

    if (allowEscape == false) {
        $('section#loader').css('pointer-events', 'none');
        $('section#loader *').addClass('no-event');

        $(document).keydown(function (e) {
            if (e.keyCode == 27) {
                return false;
            }
        });
    } else {
        $('section#loader').css('pointer-events', 'all');
    }
}
function showBadReservation(message)
{
    showLoader('');
    window.location.href = "/?reset_instance=timeout";
}

function hideLoader()
{
    $('*').removeClass('no-event');
    $('section#loader').fadeOut();
}

function simpleCrypt(value)
{

    var key = CryptoJS.lib.WordArray.random(16);
    var iv = CryptoJS.lib.WordArray.random(16);

    var encrypted = CryptoJS.AES.encrypt(value, key, {iv: iv});
    var valDataBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    var valIvBase64 = encrypted.iv.toString(CryptoJS.enc.Base64);
    var valKeyBase64 = encrypted.key.toString(CryptoJS.enc.Base64);

    return {valDataBase64: valDataBase64, valIvBase64: valIvBase64, valKeyBase64: valKeyBase64};
}


function refreshAjaxPrix(
    refreshElement,
    idCategorieVehicule,
    typeTarif,
    kmmode,
    kms,
    codeReduction,
    age,
    agePermis,
    idAgenceDepartOverride,
    idAgenceRetourOverride,
    disableWatingMessage,
    trigger,
    displayOnly
) {
    // null === récupérer les valeurs mémorisées
    // récupération des valeurs du dernier devis (utile pour rafraichir le devis en cas de modification du code promo
    if (idCategorieVehicule === "<memo>") {
        idCategorieVehicule = $(refreshElement).data('idcategorievehiculememo');
    }
    if (typeTarif === "<memo>") {
        typeTarif = $(refreshElement).data('typetarifmemo');
    }
    if (kmmode === "<memo>") {
        kmmode = $(refreshElement).data('kmmodememo');
    }
    if (kms === "<memo>") {
        kms = $(refreshElement).data('kmsmemo');
    }
    if (codeReduction === "<memo>") {
        codeReduction = $(refreshElement).data('codereductionmemo');
    }
    if (age === "<memo>") {
        age = $(refreshElement).data('agememo');
    }
    if (agePermis === "<memo>") {
        agePermis = $(refreshElement).data('agepermismemo');
    }

    // memorisation pour le prochain appel
    $(refreshElement).data('ajaxPrixCalled', true);
    $(refreshElement).data('idcategorievehiculememo', idCategorieVehicule);
    $(refreshElement).data('typetarifmemo', typeTarif);
    $(refreshElement).data('kmmodememo', kmmode);
    $(refreshElement).data('kmsmemo', kms);
    $(refreshElement).data('codereductionmemo', codeReduction);
    $(refreshElement).data('agememo', age);
    $(refreshElement).data('agepermismemo', agePermis);

    // key pour la mise en cache locale
    var cacheName = idCategorieVehicule + "-" + typeTarif + "-" + kmmode + "-" + kms + "-" + codeReduction + '-' + age + '-' + agePermis;
    // message d'attente
    var message = $('div#search-price h2').html();
    if (message.length == 0) {
        message = "recherche en cours...";
    }
    var unavailableLabel = $('#proximity-unavailable-base-label').text();
    var refClient = $("body").attr('data-reference-client');

    message = '<br/><br/><br/><br/><br/>' + message + '<br/><img src="/images/v3/specifique_client/' + refClient + '/icons/loader.GIF" alt="Recherche en cours..." style="vertical-align: middle;" loading="lazy" >' + '<br/><br/><br/><br/><br/>';

    if ($(refreshElement).data(cacheName) !== undefined && idAgenceDepartOverride === undefined && idAgenceRetourOverride === undefined) {
        // display cache DOM
        var cacheHtml = $(refreshElement).data(cacheName);
        $(refreshElement).fadeTo("fast", 0.3);
        $(refreshElement).html(cacheHtml);
        $(".ui-selectmenu-button .ui-icon").attr('style', 'display:none;');
        $('#vehicles-sort-price-button').addClass('no-event').addClass('grayed');
        $('#vehicles-sort-vehicle-type-button').addClass('no-event').addClass('grayed');
        spinWaiting($('#vehicles-sort-price-button'), true, 5, 3, false, $('#vehicles-sort-price-button').width() - 28, 4, '#000', 0.9);
        spinWaiting($('#vehicles-sort-vehicle-type-button'), true, 5, 3, false, $('#vehicles-sort-vehicle-type-button').width() - 28, 4, '#000', 0.9);
        refreshAjaxPrixInfosComplementaires(refreshElement, cacheHtml);
        $('#vehicles-sort-price-button').removeClass('no-event').removeClass('grayed');
        $('#vehicles-sort-vehicle-type-button').removeClass('no-event').removeClass('grayed');
        spinWaiting($("#vehicles-sort-price-button"), false);
        spinWaiting($("#vehicles-sort-vehicle-type-button"), false);
        $(".ui-selectmenu-button .ui-icon").removeAttr('style');
        $(refreshElement).fadeTo("fast", 1);
    } else {
        // generate cache DOM
        var departureElement = null, arrivalElement = null;
        if (
            (
                idAgenceDepartOverride === undefined ||
                idAgenceRetourOverride === undefined ||
                idAgenceRetourOverride === 0 ||
                $(window).width() >= 992
            ) &&
            (disableWatingMessage === false || disableWatingMessage === undefined)
        ) {
            $(refreshElement).html(message);
        }
        $(".ui-selectmenu-button .ui-icon").attr('style', 'display:none;');
        spinWaiting($('#vehicles-sort-price-button'), true, 5, 3, false, $('#vehicles-sort-price-button').width() - 28, 4, '#000', 0.9);
        spinWaiting($('#vehicles-sort-vehicle-type-button'), true, 5, 3, false, $('#vehicles-sort-vehicle-type-button').width() - 28, 4, '#000', 0.9);
        $('#vehicles-sort-price-button').addClass('no-event').addClass('grayed');
        $('#vehicles-sort-vehicle-type-button').addClass('no-event').addClass('grayed');
        if (
            (idAgenceDepartOverride !== undefined && idAgenceDepartOverride !== null && idAgenceDepartOverride !== 0) ||
            (idAgenceRetourOverride !== undefined && idAgenceRetourOverride !== null && idAgenceRetourOverride !== 0)
        ) {
            var parentElement   = $(refreshElement).parent().parent();
            var elementToAppear = parentElement.find('.row.proximity-quotations-infos');
            var visibleElement  = parentElement.find('.row.proximity-quotations-infos:visible');
            departureElement    = elementToAppear.find('.details.departure');
            arrivalElement      = elementToAppear.find('.details.arrival');

            if (!visibleElement.length) {
                elementToAppear.fadeIn();
                spinWaiting(departureElement, true);
                spinWaiting(arrivalElement, true);
                departureElement.find('input[type="radio"]').css('pointer-events', 'none');
                arrivalElement.find('input[type="radio"]').css('pointer-events', 'none');
                departureElement.find('.know-more.has-big-popin-arrow').css('pointer-events', 'none');
                arrivalElement.find('.know-more.has-big-popin-arrow').css('pointer-events', 'none');
            }
        }

        var idAgencyDeparture = null;
        var idAgencyArrival = null;
        var arrivalDeparture = 'departure';
        var baseSelector = '.vehicle-single[data-idcategorievehicule=' +
            $(refreshElement).attr('data-idcategorievehicule') +
            '] .row.proximity-quotations-infos .details'
        ;
        var baseSelectorKms = '.vehicle-single[data-idcategorievehicule=' +
            $(refreshElement).attr('data-idcategorievehicule') +
            '] .proximity-quotations-kmmodes'
        ;
        var popinContainer =
            '.know-more[data-target-map-id="map-' + arrivalDeparture + '-agency-' +
            idAgencyDeparture + '-vehicle-' + idCategorieVehicule + '"]'
        ;
        var status = false;
        var selector = baseSelector + '.departure p.agency-alternative-quote';


        if (displayOnly === true) {
            if (trigger === undefined || trigger === 'departure') {
                if (
                    idAgenceDepartOverride !== undefined &&
                    idAgenceDepartOverride !== null &&
                    idAgenceDepartOverride !== 0
                ) {
                    idAgencyDeparture = idAgenceDepartOverride;
                }
            }
            if (trigger === undefined || trigger === 'arrival') {
                if (
                    idAgenceRetourOverride !== undefined &&
                    idAgenceRetourOverride !== null &&
                    idAgenceRetourOverride !== 0
                ) {
                    idAgencyArrival = idAgenceRetourOverride;
                }
            }

            if (
                idAgenceRetourOverride !== undefined && idAgenceRetourOverride !== null &&
                idAgenceRetourOverride !== 0 &&
                (
                    idAgenceDepartOverride === undefined ||
                    idAgenceDepartOverride === null ||
                    idAgenceDepartOverride === 0
                )
            ) {
                arrivalDeparture = 'arrival';
                manageReturnAgenciesOverride({
                    baseSelectorKms: baseSelectorKms,
                    currentKmmode: null,
                    baseSelector: baseSelector,
                    selector: selector,
                    price: null,
                    unavailableLabel : unavailableLabel,
                    isPrice: false,
                    status: status,
                    idCategorieVehicule: idCategorieVehicule,
                    departureElement: departureElement,
                    arrivalElement: arrivalElement,
                    idAgenceRetourOverride: idAgenceRetourOverride,
                });
            } else {
                if (
                    idAgenceRetourOverride !== undefined && idAgenceRetourOverride !== null &&
                    idAgenceRetourOverride !== 0 &&
                    idAgenceDepartOverride !== undefined && idAgenceDepartOverride !== null &&
                    idAgenceDepartOverride !== 0
                ) {
                    manageAllAgenciesOverrides({
                        baseSelectorKms: baseSelectorKms,
                        currentKmmode: null,
                        baseSelector: baseSelector,
                        selector: selector,
                        price: null,
                        isPrice: false,
                        unavailableLabel : unavailableLabel,
                        status: status,
                        idCategorieVehicule: idCategorieVehicule,
                        departureElement: departureElement,
                        arrivalElement: arrivalElement,
                        idAgenceDepartOverride: idAgenceDepartOverride,
                        idAgenceRetourOverride: idAgenceRetourOverride,
                    });
                } else {
                    manageDepartureAgenciesOverride({
                        baseSelectorKms: baseSelectorKms,
                        currentKmmode: null,
                        baseSelector: baseSelector,
                        selector: selector,
                        price: null,
                        unavailableLabel : unavailableLabel,
                        isPrice: false,
                        status: status,
                        idCategorieVehicule: idCategorieVehicule,
                        departureElement: departureElement,
                        idAgenceDepartOverride: idAgenceDepartOverride,
                    });
                }
            }
            $(popinContainer).mouseenter(function () {
                $(popinContainer + ' .big-popin').initSideBarMaps(
                    'map-' + arrivalDeparture + '-agency-' + idAgencyDeparture + '-vehicle-' + idCategorieVehicule
                );
            });
            popinContainer =
                '.know-more[data-target-map-id="map-' + arrivalDeparture + '-agency-' +
                idAgencyArrival + '-vehicle-' + idCategorieVehicule + '"]'
            ;
            $(popinContainer).mouseenter(function () {
                $(popinContainer + ' .big-popin').initSideBarMaps(
                    'map-' + arrivalDeparture + '-agency-' + idAgencyArrival + '-vehicle-' + idCategorieVehicule
                );
            });
        } else {
            $.ajax({
                url: $('#base_route').val() + "/_ajax/prix",
                type: "POST",
                data: {
                    id: idCategorieVehicule,
                    typeTarif: typeTarif,
                    kmmode: kmmode,
                    kms: kms,
                    codeReduction: codeReduction,
                    idRetour: null,
                    isAgence: 0,
                    age: age,
                    agePermis: agePermis,
                    idAgenceDepartOverride: idAgenceDepartOverride,
                    idAgenceRetourOverride: idAgenceRetourOverride
                }
            }).done(function (data) {
                if (idAgenceDepartOverride === undefined && idAgenceRetourOverride === undefined) {
                    $(refreshElement).html(data);
                    $(refreshElement).data(cacheName, data);
                    refreshAjaxPrixInfosComplementaires(refreshElement, data);
                    var kmsbase = parseInt($(refreshElement).data('km-base'));
                    // memorise le km par defaut pour chaque premier devis (si existe)
                    if (isNaN(kmsbase)) {
                        var kms = parseInt($(refreshElement).find('input[name=kilometers]').val());
                        if (!isNaN(kms)) {
                            $(refreshElement).attr('data-km-base', kms);
                        }
                    }
                } else {
                    var doc = $('<html></html>');
                    doc.html(data);
                    idAgencyDeparture = null;
                    var selectorRootDeparture = '';
                    idAgencyArrival = null;
                    var selectorRootArrival = '';
                    arrivalDeparture = 'departure';
                    baseSelector = '.vehicle-single[data-idcategorievehicule=' +
                        $(refreshElement).attr('data-idcategorievehicule') +
                        '] .row.proximity-quotations-infos .details'
                    ;
                    baseSelectorKms = '.vehicle-single[data-idcategorievehicule=' +
                        $(refreshElement).attr('data-idcategorievehicule') +
                        '] .proximity-quotations-kmmodes'
                    ;
                    if (trigger === undefined || trigger === 'departure') {
                        if (
                            idAgenceDepartOverride !== undefined &&
                            idAgenceDepartOverride !== null &&
                            idAgenceDepartOverride !== 0
                        ) {
                            idAgencyDeparture = idAgenceDepartOverride;
                            selectorRootDeparture = '.details.departure ';
                        }
                    }
                    if (trigger === undefined || trigger === 'arrival') {
                        if (
                            idAgenceRetourOverride !== undefined &&
                            idAgenceRetourOverride !== null &&
                            idAgenceRetourOverride !== 0
                        ) {
                            idAgencyArrival = idAgenceRetourOverride;
                            selectorRootArrival = '.details.arrival ';
                        }
                    }
                    if (selectorRootDeparture !== '') {
                        $(baseSelector + selectorRootDeparture + '.pricing-response-cache[data-id-agency=' +
                            idAgencyDeparture + '][data-id-vehicle=' + idCategorieVehicule + ']').html(data)
                        ;
                    }
                    if (selectorRootArrival !== '') {
                        $(baseSelector + selectorRootArrival + '.pricing-response-cache[data-id-agency=' + idAgencyArrival +
                            '][data-id-vehicle=' + idCategorieVehicule + ']').html(data)
                        ;
                    }
                    var priceActionData = $(data);
                    var currentKmmode = priceActionData.find('div.rating-information').attr('data-kmmode');
                    var priceOrMsg = $('p.prix', doc).text(); // All the anchor elements
                    var bookingButtonAvailable = $('.arrow-button.submit.action-reservation', doc).length ? true : false;
                    status = true;
                    var isPrice = true;

                    if (priceOrMsg === '' || typeof priceOrMsg === 'undefined') {
                        isPrice = false;
                        priceOrMsg = $('div.dispo div', doc).text();
                        if (priceOrMsg === '') {
                            priceOrMsg = unavailableLabel;
                        }
                    }
                    if (bookingButtonAvailable === false) {
                        priceOrMsg = $('div.dispo div', doc).text();
                        status = false;
                        isPrice = false;
                    }

                    selector = baseSelector + '.departure p.agency-alternative-quote';

                    if (
                        idAgenceRetourOverride !== undefined && idAgenceRetourOverride !== null &&
                        idAgenceRetourOverride !== 0 &&
                        (
                            idAgenceDepartOverride === undefined ||
                            idAgenceDepartOverride === null ||
                            idAgenceDepartOverride === 0
                        )
                    ) {
                        arrivalDeparture = 'arrival';
                        manageReturnAgenciesOverride({
                            baseSelectorKms: baseSelectorKms,
                            currentKmmode: currentKmmode,
                            baseSelector: baseSelector,
                            selector: selector,
                            price: priceOrMsg,
                            unavailableLabel : unavailableLabel,
                            isPrice: isPrice,
                            status: status,
                            idCategorieVehicule: idCategorieVehicule,
                            departureElement: departureElement,
                            arrivalElement: arrivalElement,
                            idAgenceRetourOverride: idAgenceRetourOverride,
                        });
                    } else {
                        if (
                            idAgenceRetourOverride !== undefined && idAgenceRetourOverride !== null &&
                            idAgenceRetourOverride !== 0 &&
                            idAgenceDepartOverride !== undefined && idAgenceDepartOverride !== null &&
                            idAgenceDepartOverride !== 0
                        ) {
                            manageAllAgenciesOverrides({
                                baseSelectorKms: baseSelectorKms,
                                currentKmmode: currentKmmode,
                                baseSelector: baseSelector,
                                selector: selector,
                                price: priceOrMsg,
                                unavailableLabel : unavailableLabel,
                                isPrice: isPrice,
                                status: status,
                                idCategorieVehicule: idCategorieVehicule,
                                departureElement: departureElement,
                                arrivalElement: arrivalElement,
                                idAgenceDepartOverride: idAgenceDepartOverride,
                                idAgenceRetourOverride: idAgenceRetourOverride,
                            });
                        } else {
                            manageDepartureAgenciesOverride({
                                baseSelectorKms: baseSelectorKms,
                                currentKmmode: currentKmmode,
                                baseSelector: baseSelector,
                                selector: selector,
                                price: priceOrMsg,
                                unavailableLabel : unavailableLabel,
                                isPrice: isPrice,
                                status: status,
                                idCategorieVehicule: idCategorieVehicule,
                                departureElement: departureElement,
                                idAgenceDepartOverride: idAgenceDepartOverride,
                            });
                        }
                    }
                    popinContainer =
                        '.know-more[data-target-map-id="map-' + arrivalDeparture + '-agency-' +
                        idAgencyDeparture + '-vehicle-' + idCategorieVehicule + '"]'
                    ;
                    $(popinContainer).mouseenter(function () {
                        $(popinContainer + ' .big-popin').initSideBarMaps(
                            'map-' + arrivalDeparture + '-agency-' + idAgencyDeparture + '-vehicle-' + idCategorieVehicule
                        );
                    });
                    popinContainer =
                        '.know-more[data-target-map-id="map-' + arrivalDeparture + '-agency-' +
                        idAgencyArrival + '-vehicle-' + idCategorieVehicule + '"]'
                    ;
                    $(popinContainer).mouseenter(function () {
                        $(popinContainer + ' .big-popin').initSideBarMaps(
                            'map-' + arrivalDeparture + '-agency-' + idAgencyArrival + '-vehicle-' + idCategorieVehicule
                        );
                    });
                }
            }).fail(function (data) {
                $(refreshElement).html('');
                $(refreshElement).data(cacheName, '');
                refreshAjaxPrixInfosComplementaires(refreshElement, '');
                if (data.status == 500 && data.statusText == "expiredSession") {
                    showLoader();
                    window.location = "/?session_expiree";
                }
            }).always(function (data) {
                spinWaiting($("#vehicles-sort-price-button"), false);
                spinWaiting($("#vehicles-sort-vehicle-type-button"), false);

                if ($("#vehicles-sort-price-button").attr("SpinCount") == 0 || $("#vehicles-sort-vehicle-type-button").attr("SpinCount") == 0) {
                    // verifie que c'est le dernier (via spinWaiting)
                    $(".ui-selectmenu-button .ui-icon").removeAttr('style');
                    $('#vehicles-sort-price-button').removeClass('no-event').removeClass('grayed');
                    $('#vehicles-sort-vehicle-type-button').removeClass('no-event').removeClass('grayed');
                }
            });
        }
    }
}

function manageDepartureAgenciesOverride(parameters)
{
    var regAgence = new RegExp('am');
    var baseElement =
        $(parameters.selector + '[data-id-agence=' + parameters.idAgenceDepartOverride + '] span.agency-price')
    ;

    if (baseElement.text() === '' || !isNaN(parseInt(baseElement.text()))) {
        if (parameters.price !== '') {
            if (parameters.isPrice === true) {
                baseElement.text(parameters.price);
            } else {
                baseElement.text(parameters.unavailableLabel);
            }
        } else {
            baseElement.text(parameters.unavailableLabel);
        }
        baseElement.addClass('populated');
    } else {
        baseElement.text(parameters.unavailableLabel);
        baseElement.addClass('populated');
    }
    if (parameters.isPrice === true) {
        baseElement.addClass('is-price');
        baseElement.parent().parent().find('.picto.picto-infos').addClass('invisible');
        if (!baseElement.hasClass('set')) {
            baseElement.attr('title', parameters.price);
        }
    } else {
        baseElement.parent().parent().find('.picto.picto-infos').removeClass('invisible');
        if (!baseElement.hasClass('set')) {
            baseElement.attr('title', parameters.price);
        }
    }
    if (parameters.price !== null && parameters.price.length > 28) {
        baseElement.addClass('long-text');
    }
    if (baseElement.parent().find('.picto-infos').length) {
        baseElement.parent().find('.picto-infos .tooltip').text(parameters.price);
        if (baseElement.parent().find('.picto-infos .tooltip').text() === '') {
            baseElement.parent().find('.picto-infos .tooltip').text(baseElement.attr('title'))
        }
    }

    if (parameters.status === false && !isNaN(parseInt(baseElement.text()))) {
        baseElement.parent().
            parent().parent().find('input[type="radio"]').attr('disabled', 'disabled')
        ;
    }
    baseElement.parent().parent().parent().removeClass('hidden');
    baseElement.
        parent().parent().parent().addClass('computed').attr('data-kmmode', parameters.currentKmmode)
    ;
    if (parameters.currentKmmode !== null) {
        $(parameters.baseSelectorKms).find(
            'span[data-id-agence-depart="' + parameters.idAgenceDepartOverride + '"][data-id-agence-retour="' +
            $('#id_agence_retour').val().replace(regAgence, '') + '"]'
        ).text(parameters.currentKmmode);
    }
    if (
        parseInt($(parameters.selector).parent().parent().find('.agency-wrapper.computed').length +
            $(parameters.selector).parent().parent().find('.agency-wrapper.empty').length) ===
        $(parameters.selector).parent().parent().find('.agency-wrapper').length
    ) {
        spinWaiting(parameters.departureElement, false);
        parameters.departureElement.find(('.know-more.has-big-popin-arrow')).css('pointer-events', 'all');
        sortData(parameters.idCategorieVehicule, 'depature');
        parameters.departureElement.find('input[type="radio"]').css('pointer-events', 'all');
    }
}

/**
 *
 * @param parameters
 */
function manageReturnAgenciesOverride(parameters)
{
    var regAgence = new RegExp('am');
    parameters.selector = parameters.baseSelector + '.arrival p.agency-alternative-quote';
    parameters.arrivalDeparture = 'arrival';
    var baseElement =
        $(parameters.selector + '[data-id-agence=' + parameters.idAgenceRetourOverride + '] span.agency-price')
    ;

    if (baseElement.text() === '' || !isNaN(parseInt(baseElement.text()))) {
        if (parameters.price !== null) {
            if (parameters.isPrice === true) {
                baseElement.text(parameters.price);
            } else {
                baseElement.text(parameters.unavailableLabel);
            }
        } else {
            baseElement.text(parameters.unavailableLabel);
        }
        baseElement.addClass('populated');
    } else {
        baseElement.text(parameters.unavailableLabel);
        baseElement.addClass('populated');
    }

    if (parameters.isPrice === true) {
        baseElement.addClass('is-price');
        baseElement.parent().parent().find('.picto.picto-infos').addClass('invisible');
        if (!baseElement.hasClass('set')) {
            baseElement.attr('title', parameters.price);
        }
    } else {
        baseElement.parent().parent().find('.picto.picto-infos').removeClass('invisible');
        if (!baseElement.hasClass('set')) {
            baseElement.attr('title', parameters.price);
        }
        baseElement.removeClass('is-price');
    }
    if (parameters.status === false && !isNaN(parseInt(baseElement.text()))) {
        $(parameters.selector + '[data-id-agence=' + parameters.idAgenceDepartOverride + '] span.agency-price').parent()
            .parent().parent().find('input[type="radio"]').attr('disabled', 'disabled')
        ;
    }
    baseElement.parent().parent().parent().removeClass('hidden');
    if (parameters.price !== null && parameters.price.length > 28) {
        baseElement.addClass('long-text');
    }
    if (baseElement.parent().find('.picto-infos').length && parameters.price !== '') {
        baseElement.parent().find('.picto-infos .tooltip').text(parameters.price);
        if (baseElement.parent().find('.picto-infos .tooltip').text() === '') {
            baseElement.parent().find('.picto-infos .tooltip').text(baseElement.attr('title'))
        }
    }
    if (parameters.currentKmmode !== null) {
        baseElement.parent().parent().parent().attr('data-kmmode', parameters.currentKmmode);
    }
    baseElement.parent().parent().parent().addClass('computed');
    if (parameters.currentKmmode !== null) {
        $(parameters.baseSelectorKms).find('span[data-id-agence-depart="' +
            $('#id_agence_depart').val().replace(regAgence, '') + '"][data-id-agence-retour="' +
            parameters.idAgenceRetourOverride + '"]').text(parameters.currentKmmode)
        ;
    }
    if (
        parseInt($(parameters.selector).parent().parent().find('.agency-wrapper.computed').length +
            $(parameters.selector).parent().parent().find('.agency-wrapper.empty').length) ===
        $(parameters.selector).parent().parent().find('.agency-wrapper').length
    ) {
        spinWaiting(parameters.arrivalElement, false);
        parameters.arrivalElement.find(('.know-more.has-big-popin-arrow')).css('pointer-events', 'all');
        sortData(parameters.idCategorieVehicule, 'arrival');
        parameters.arrivalElement.find('input[type="radio"]').css('pointer-events', 'all');
    }
}

/**
 *
 * @param parameters
 */
function allAgenciesOverridesDeparture(parameters)
{
    var baseElement =
        $(parameters.selector + '[data-id-agence=' + parameters.idAgenceDepartOverride + '] span.agency-price')
    ;
    if ($(parameters.baseSelector + '.departure.refresh-required').length) {
        parameters.selector = parameters.baseSelector + '.departure p.agency-alternative-quote';

        if (baseElement.text() === '' || !isNaN(parseInt(baseElement.text()))) {
            if (parameters.price !== null) {
                if (parameters.isPrice === true) {
                    baseElement.text(parameters.price);
                } else {
                    baseElement.text(parameters.unavailableLabel);
                }
            } else {
                baseElement.text(parameters.unavailableLabel);
            }
            baseElement.addClass('populated');
        } else {
            baseElement.text(parameters.unavailableLabel);
            baseElement.addClass('populated');
        }

        if (parameters.isPrice === true) {
            baseElement.addClass('is-price');
            baseElement.parent().parent().find('.picto.picto-infos').addClass('invisible');
            if (!baseElement.hasClass('set')) {
                baseElement.attr('title', parameters.price);
            }
        } else {
            baseElement.parent().parent().find('.picto.picto-infos').removeClass('invisible');
            if (!baseElement.hasClass('set')) {
                baseElement.attr('title', parameters.price);
            }
            baseElement.removeClass('is-price');
        }
        if (parameters.status === false && !isNaN(parseInt(baseElement.text()))) {
            baseElement.parent()
                .parent().parent().find('input[type="radio"]').attr('disabled', 'disabled')
            ;
        }
        if (parameters.price !== null && parameters.price.length > 28) {
            baseElement.addClass('long-text');
        }
        if (baseElement.parent().find('.picto-infos').length && parameters.price !== '') {
            baseElement.parent().find('.picto-infos .tooltip').text(parameters.price);
            if (baseElement.parent().find('.picto-infos .tooltip').text() === '') {
                baseElement.parent().find('.picto-infos .tooltip').text(baseElement.attr('title'))
            }
        }
        baseElement.parent().parent().parent().removeClass('hidden');
        if (parameters.currentKmmode !== null) {
            baseElement.parent().parent().parent().attr('data-kmmode', parameters.currentKmmode);
        }
        baseElement.parent().parent().parent().addClass('computed');
        if (parameters.currentKmmode !== null) {
            $(parameters.baseSelectorKms).find('span[data-id-agence-depart="' + parameters.idAgenceDepartOverride +
                '"][data-id-agence-retour="' + parameters.idAgenceRetourOverride + '"]').text(parameters.currentKmmode)
            ;
        }
        if (
            parseInt($(parameters.selector).parent().parent().find('.agency-wrapper.computed').length +
                $(parameters.selector).parent().parent().find('.agency-wrapper.empty').length) ===
            $(parameters.selector).parent().parent().find('.agency-wrapper').length
        ) {
            spinWaiting(parameters.departureElement, false);
            parameters.departureElement.find(('.know-more.has-big-popin-arrow')).css('pointer-events', 'all');
            sortData(parameters.idCategorieVehicule, 'departure');
            sortData(parameters.idCategorieVehicule, 'arrival');
            $(parameters.baseSelector).find('input[type="radio"]').css('pointer-events', 'all');
            $(parameters.baseSelector + '.departure.refresh-required').removeClass('refresh-required');
        }
    }
}

/**
 *
 * @param parameters
 */
function allAgenciesOverridesArrival(parameters)
{
    var baseElement =
        $(parameters.selector + '[data-id-agence=' + parameters.idAgenceRetourOverride + '] span.agency-price')
    ;
    if ($(parameters.baseSelector + '.arrival.refresh-required').length) {
        var regAgence = new RegExp('am');
        parameters.selector = parameters.baseSelector + '.arrival p.agency-alternative-quote';
        baseElement =
            $(parameters.selector + '[data-id-agence=' + parameters.idAgenceRetourOverride + '] span.agency-price')
        ;

        if (baseElement.text() === '' || !isNaN(parseInt(baseElement.text()))) {
            if (parameters.price !== null) {
                if (parameters.isPrice === true) {
                    baseElement.text(parameters.price);
                } else {
                    baseElement.text(parameters.unavailableLabel);
                }
            } else {
                baseElement.text(parameters.unavailableLabel);
            }
            baseElement.addClass('populated');
        } else {
            baseElement.text(parameters.unavailableLabel);
            baseElement.addClass('populated');
        }
        if (parameters.isPrice === true) {
            baseElement.addClass('is-price');
            baseElement.parent().parent().find('.picto.picto-infos').addClass('invisible');
            if (!baseElement.hasClass('set')) {
                baseElement.attr('title', parameters.price);
            }
        } else {
            baseElement.parent().parent().find('.picto.picto-infos').removeClass('invisible');
            if (!baseElement.hasClass('set')) {
                baseElement.attr('title', parameters.price);
            }
            baseElement.removeClass('is-price');
        }
        baseElement.parent().parent().parent().removeClass('hidden');

        if (parameters.price !== null && parameters.price.length > 28) {
            baseElement.addClass('long-text');
        }
        if (baseElement.parent().find('.picto-infos').length && parameters.price !== '') {
            baseElement.parent().find('.picto-infos .tooltip').text(parameters.price);
            if (baseElement.parent().find('.picto-infos .tooltip').text() === '') {
                baseElement.parent().find('.picto-infos .tooltip').text(baseElement.attr('title'))
            }
        }
        baseElement.parent().parent().parent().addClass('computed');
        if (parameters.currentKmmode !== null) {
            baseElement.parent().parent().parent().attr('data-kmmode', parameters.currentKmmode);
        }
        if (parameters.currentKmmode !== null) {
            $(parameters.baseSelectorKms).find('span[data-id-agence-depart="' +
                $('#id_agence_depart').val().replace(regAgence, '') +
                '"][data-id-agence-retour="' + parameters.idAgenceRetourOverride + '"]').text(parameters.currentKmmode)
            ;
        }
        if (
            parseInt($(parameters.selector).parent().parent().find('.agency-wrapper.computed').length +
                $(parameters.selector).parent().parent().find('.agency-wrapper.empty').length) ===
            $(parameters.selector).parent().parent().find('.agency-wrapper').length
        ) {
            spinWaiting(parameters.arrivalElement, false);
            parameters.arrivalElement.find('.know-more.has-big-popin-arrow').css('pointer-events', 'all');
            sortData(parameters.idCategorieVehicule, 'arrival');
            $(parameters.baseSelector).find('input[type="radio"]').css('pointer-events', 'all');
            $(parameters.baseSelector + '.arrival.refresh-required').removeClass('refresh-required');
        }
    }
}

/**
 *
 * @param parameters
 */
function manageAllAgenciesOverrides(parameters)
{
    allAgenciesOverridesDeparture(parameters);
    allAgenciesOverridesArrival(parameters);
}

function refreshAjaxPrixWaitOnKms(obj)
{
    var thSep = $('#thousands-separator').text();
    var kms = 0;
    var regpc = null;
    if (thSep == ' ' || thSep == String.fromCharCode(160)) {
        regpc = new RegExp(/\s/g);
    } else {
        kms = parseInt($(obj).closest('div.choix').find('input[name=kilometers]').val().split(thSep).join(''));
    }
    if (regpc != null) {
        kms = parseInt($(obj).closest('div.choix').find('input[name=kilometers]').val().replace(regpc, ''));
    }
    var age = $(obj).closest('[data-driverage]').data('driverage');
    var agePermis = $(obj).closest('[data-permisage]').data('permisage');
    var refreshElement = $(obj).closest('div.prixOnline').parent();
    var currentVehicleSingle = refreshElement.parent().parent();
    var idCategorieVehicule = $(obj).closest('[data-idcategorievehicule]').attr('data-idcategorievehicule');
    var typeTarif = $(obj).closest('[data-typetarif]').attr('data-typetarif');
    var kmmode = $(obj).closest('[data-kmmode]').attr('data-kmmode');
    kms = isNaN(kms) ? 0 : kms;
    var kmsbase = $(obj).closest('[data-km-base]').data('km-base');
    kmsbase = isNaN(kmsbase) ? null : kmsbase;
    var codePromotion = $(obj).closest('div.vehicle-single ').find('input[name=promo-code]').val();
    var kmsMin = 0;
    kms = kms < kmsMin ? kmsMin : kms;
    $(obj).closest('div.choix').find('input[name=kilometers]').val(formatNumber(kms));
    $(obj).closest('div.price-actions').data('kms', kms);
    var key = 'refreshAjaxPrixWaitOnKms_' + idCategorieVehicule;
    var dataId = null;
    $.doTimeout(key, 1500, function () {
        refreshAjaxPrix(
            refreshElement,
            idCategorieVehicule,
            typeTarif,
            kmmode,
            (kms === kmsbase ? null : kms),
            codePromotion,
            age,
            agePermis
        );
        var baseElement = refreshElement.parent().parent();
        if (baseElement.find('.proximity-quotations-infos').length) {
            var departureElement = baseElement.find('.row.proximity-quotations-infos .details.departure');
            resetDepartureAgenciesWrappersVisibility(baseElement);
            if (parseInt(departureElement.attr('spincount')) < 1) {
                spinWaiting(departureElement, true);
                departureElement.find('.agency-wrapper.computed').removeClass('computed');
            }
            dataId = null;
            kmmode = null;
            $('.proximity-quotation.departure span').each(function () {
                dataId = $(this).attr('data-id');
                kmmode = currentVehicleSingle.find(
                    '.details.departure .agency-name.agency-alternative-quote[data-id-agence="' + dataId + '"]'
                ).parent().attr('data-kmmode');
                if (parseInt(kmmode) === 1 || typeof kmmode === 'undefined' || kmmode === false) {
                    refreshAjaxPrix(
                        refreshElement,
                        idCategorieVehicule,
                        typeTarif,
                        kmmode,
                        (kms === kmsbase ? null : kms),
                        codePromotion,
                        age,
                        agePermis,
                        dataId
                    );
                } else {
                    var agencyWrappers = currentVehicleSingle.find(
                        '.details.departure .agency-name.agency-alternative-quote[data-id-agence="' + dataId + '"]'
                    ).parent().parent();
                    agencyWrappers.find('.agency-wrapper').each(function () {
                        if (parseInt($(this).attr('data-kmmode')) === 2) {
                            $(this).removeClass('hidden').addClass('computed');
                        }
                    });
                }
            });
        }
        if (baseElement.find('.proximity-quotations-infos').length) {
            var arrivalElement = baseElement.find('.row.proximity-quotations-infos .details.arrival');
            resetArrivalAgenciesWrappersVisibility(baseElement);
            if (parseInt(arrivalElement.attr('spincount')) < 1) {
                spinWaiting(arrivalElement, true);
                arrivalElement.find('.agency-wrapper.computed').removeClass('computed');
            }
            dataId = null;
            kmmode = null;
            $('.proximity-quotation.arrival span').each(function () {
                dataId = $(this).attr('data-id');
                kmmode = currentVehicleSingle.find(
                    '.details.arrival .agency-name.agency-alternative-quote[data-id-agence="' + dataId + '"]'
                ).parent().attr('data-kmmode');
                if (parseInt(kmmode) === 1 || typeof kmmode === 'undefined' || kmmode === false) {
                    refreshAjaxPrix(
                        refreshElement,
                        idCategorieVehicule,
                        typeTarif,
                        kmmode,
                        (kms === kmsbase ? null : kms),
                        codePromotion,
                        age,
                        agePermis,
                        null,
                        dataId
                    );
                } else {
                    var agencyWrappers = currentVehicleSingle.find(
                        '.details.arrival .agency-name.agency-alternative-quote[data-id-agence="' + dataId + '"]'
                    ).parent().parent();
                    agencyWrappers.find('.agency-wrapper').each(function () {
                        if (parseInt($(this).attr('data-kmmode')) === 2) {
                            $(this).removeClass('hidden').addClass('computed');
                        }
                    });
                }
            });
        }
    });
}

function refreshAjaxPrixInfosComplementaires(refreshElement, data)
{
    var $vehicleSingle = $(refreshElement).closest('.vehicle-single');
    var idElement = $(refreshElement).closest('[idCategorieVehicule]').data('[idCategorieVehicule]');
    var idCat = idElement;

    // maj structure de tri
    var prix = $(data).find('span.raw-price').text();
    $vehicleSingle.attr('data-price', prix);

    // astuce de cache local pour repondre a une demande de fde (afficher les kms inclus en mode JKM lors d'une demande en mode KI)

    var $kmInclusFactures = $vehicleSingle.find('.km-inclus-factures');
    if (isNaN(parseInt($kmInclusFactures.text()))) {
        $kmInclusFactures.text($vehicleSingle.attr('data-km-inclus-factures'));
    } else {
        $vehicleSingle.attr('data-km-inclus-factures', $kmInclusFactures.text());
    }

    // bloc condition franchise et depot garantie

    var hasInfo = false;

    var franchise_assurance_dommage = $(data).find('span.raw-franchise-assurance-dommage').text();
    if (parseFloat(franchise_assurance_dommage.replace(' ', '').replace(',', '.'))) {
        $vehicleSingle.find('.franchise-assurance-dommage').html(franchise_assurance_dommage).closest('li').css('display', 'block');
        hasInfo = true;
    } else {
        $vehicleSingle.find('.franchise-assurance-dommage').closest('li').css('display', 'none');
    }

    var franchise_assurance_vol = $(data).find('span.raw-franchise-assurance-vol').text();
    if (parseFloat(franchise_assurance_vol.replace(' ', '').replace(',', '.'))) {
        $vehicleSingle.find('.franchise-assurance-vol').html(franchise_assurance_vol).closest('li').css('display', 'block');
        hasInfo = true;
    } else {
        $vehicleSingle.find('.franchise-assurance-vol').closest('li').css('display', 'none');
    }

    var franchise_phb = $(data).find('span.raw-franchise-phb').text();
    if (parseFloat(franchise_phb.replace(' ', '').replace(',', '.'))) {
        $vehicleSingle.find('.franchise-phb').html(franchise_phb).closest('li').css('display', 'block');
        hasInfo = true;
    } else {
        $vehicleSingle.find('.franchise-phb').closest('li').css('display', 'none');
    }

    var franchiseBrisGlace = $(data).find('span.raw-franchise-bris-glace').text();
    if (parseFloat(franchiseBrisGlace.replace(' ', '').replace(',', '.'))) {
        $vehicleSingle.find('.franchise-bris-glace').html(franchiseBrisGlace).closest('li').css('display', 'block');
        hasInfo = true;
    } else {
        $vehicleSingle.find('.franchise-bris-glace').closest('li').css('display', 'none');
    }

    var depot_garantie = $(data).find('span.raw-depot-garantie').text();
    if (parseFloat(depot_garantie.replace(' ', '').replace(',', '.'))) {
        $vehicleSingle.find('.depot-garantie').html(depot_garantie).closest('li').css('display', 'block');
        hasInfo = true;
    } else {
        $vehicleSingle.find('.depot-garantie').closest('li').css('display', 'none');
    }


    if (hasInfo) {
        $vehicleSingle.find('.half.conditions').css('display', 'block');
    } else {
        $vehicleSingle.find('.half.conditions').css('display', 'none');
    }

    // code promotion

    var codePromo = $(data).find('span.raw-code-promotion').text();
    var $elem = $vehicleSingle.find('.enter-promo-code')
    if ($.trim(codePromo).length) {
        $elem.find('input').attr('readonly', 'readonly').val(codePromo);
        $elem.find('button span.text').text($('#promo-code-deletion-label').text());
    } else {
        $elem.find('input').removeAttr('readonly').val('');
        $elem.find('button span.text').text($('#promo-code-adding-label').text());
    }
}

function modifieEntetesFixesEtFlottants()
{
    var $window = $(window);
    var $header = null;

    if ($('body header').length != 0) {
        $header = $('body header');
    } else {
        $header = $('body .head.pwa');
    }
    if ($('body nav.block-nav').length != 0 && $window.width() > 991) {
        $header = $('body nav.block-nav');
    }
    var paddingTop = $('section.main').css("padding-top").replace(/\D+/, '');
    var scrolltop  = $window.scrollTop();
    var limit      = $header.height() + $header.position().top;

    // positionnement des entetes fixes

    if ($window.width() > 991) {
        limit += ($('.custom-top-bar-wrapper.top-bar-mobile-hidden').height() || 0);
        limit += ($('.steps-navigation').height() || 0);
    } else {
        var rect = document.querySelector('.top-form-controls').getBoundingClientRect();
        if (rect.top == 0 || rect.top == $('.custom-top-bar-wrapper.top-bar-desktop-hidden').height()) {
            $('.pwa.head .block-top-mobile.home').addClass('no-box-shadow');
        } else {
            $('.pwa.head .block-top-mobile.home').removeClass('no-box-shadow');
        }
    }

    if (scrolltop > limit) {
        var totalHeigth = 0;
        if ($window.width() > 991) {
            // positionnement des entetes fixes en mode PC
            $('div[data-state-fixed-pc=1]:visible').each(function () {
                $(this).addClass("fixed");
                $(this).css("top", totalHeigth).css("z-index", 500);

                totalHeigth += $(this).height();
            });
        } else {
            // positionnement des entetes fixes en mode Tablette
            $('div[data-state-fixed-tablette=1]:visible').each(function () {
                $(this).addClass("fixed");
                $(this).css("top", totalHeigth).css("z-index", 500);
                totalHeigth += $(this).height();
            });
        }
        $('section.main').css("padding-top", (totalHeigth) + "px");
    } else {
        if (scrolltop < paddingTop) {
            // annulation du mode fixe
            $('div[data-state-fixed-pc=1]:visible').removeClass('fixed');
            $('div[data-state-fixed-tablette=1]:visible').removeClass('fixed');
            $('section.main').css("padding-top", 0);
        }
    }
    if ($window.width() > 991) {
        // reaffiche le formulaire qui a pu etre caché
        $('.button-search-options-ctn').toggleClass('open');
        $('.loc-search-edit').show();
    }
}

function plusmoins(linkSelector, divSelector)
{
    $(linkSelector).toggleClass('open')
    $(divSelector).slideToggle();
}

function formatNumber(number)
{
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, $('#thousands-separator').text());
}

function truncateFunc()
{
    if ($(window).width() < 1022 && $('.truncated').length > 0) {
        var $bparent = $('.block-top-mobile .truncated').parent();
        var bparentFreeWidth = $bparent.width() - 26;
        var bparentUsedWidth = 0;
        $bparent.children().not(".truncated").not(":hidden").each(function () {
            bparentUsedWidth += $(this).outerWidth(true);
        });
        $('.block-top-mobile .truncated').attr('style', 'width:' + (bparentFreeWidth - bparentUsedWidth - 5) + 'px;');
    }
}

function selectPaymentCard(numContrat, $cardOption, context)
{
    var base_route = $("#base_route").val();
    var idcard = $cardOption.attr('data-card-id');
    var typecard = $cardOption.attr('data-cardname');
    var idOrigine = parseInt($('#id-origine').text());

    $.post(base_route + "/_ajax/creditCardSelection/", {
        card: idcard
    }).done(function (data) {
        $.post(base_route + "/_ajax/generatePaymentForm/", {
            numContrat: numContrat,
            typecard: typecard,
            context: context,
            idOrigine : idOrigine
        }, function (data) {
            var formData = $('#form_reservation_paiement_data');
            formData.html(data);
            $('#amount').text(formData.find('#amount-value').text());
            hideModalWaiting();
            $('#btn-paiement').slideUp();
            $('#form_reservation_paiement').slideDown();
            hideLoader();
        }).fail(function () {
            showLoader();
            window.location.reload();
        });
    }).fail(function () {
        showLoader();
        window.location.reload();
    });
}


function setGMapAutoCompleteOnInputField(fieldId, suffix)
{
    var input = $('#' + fieldId + '_adresse' + suffix + '.gmap_place_autocomplete')[0];

    if (input !== undefined) {
        var options = {
            types: ['address']
        };
        var autocomplete = new google.maps.places.Autocomplete(input, options);
        autocomplete.addListener('place_changed', function () {
            var place = autocomplete.getPlace();
            var infos = {
                street_number: "",
                route: "",
                administrative_area_level_1: "",
                administrative_area_level_2: "",
                postal_code: "",
                locality: "",
                country: ""
            };
            for (var i = 0; i < place.address_components.length; i++) {
                var field = place.address_components[i];
                var fieldName = field.types[0];
                var val = field.long_name;
                infos[fieldName] = val;
            }
            $('#' + fieldId + '_adresse' + suffix).val(infos.street_number + " " + infos.route);
            $('#' + fieldId + '_adresse2' + suffix).val("");
            $('#' + fieldId + '_code_postal' + suffix).val(infos.postal_code);
            $('#' + fieldId + '_ville' + suffix).val(infos.locality);
            $('#' + fieldId + '_pays' + suffix).val(infos.country);
        });
    }
}
